import tt, { jsxs as Ze, Fragment as wn, jsx as be } from "react/jsx-runtime";
import { Close as Ia, Report as ja, CheckCircle as Da, Warning as qa, Info as Ha, KeyboardArrowLeft as $a, KeyboardArrowRight as ka } from "@mui/icons-material";
import { styled as Ua, Alert as Ba, IconButton as Fa, Snackbar as za, AlertTitle as Ga } from "@mui/material";
import { Button as Wa, AppSpinner as Va } from "@one-snap/sparkles";
import xe, { createContext as Xa, useContext as Ka, useState as rn, useCallback as Qe, useMemo as et, useEffect as nn } from "react";
import ia from "react-dom";
import { storeCookie as Ya } from "@one-snap/core";
const Qa = "#1b844a", Ja = "#3d5ccf", Za = "#062d4e", ei = "#ffca4d", ti = "#dc7f4a", ri = "#67b25e", ni = "#5fa4f9", oi = "#95d0e1", ai = "#cacde2", ii = "#f4f2ea", si = "#353849", ui = "#6c6d77", ci = "#e6e6e6", li = "#ededf2", fi = "#f4f6f8", di = "#ffffff", pi = "#af0f0f", hi = "#fff2f1", mi = "#b16307", gi = "#fff9e9", _i = "#1b844a", yi = "#eefbe8", vi = "#3d5ccf", bi = "#f0f6ff", Si = "#f0fff1", Ri = "#f7fff8", Ei = "#0c0f25", Pi = "#22a15a", wi = "#080808", Oi = "#171717", Ai = "#262626", Ci = "#404040", Ti = "#525252", xi = "#737373", Li = "#a3a3a3", Mi = "#d4d4d4", Ni = "#e5e5e5", Ii = "#f5f5f5", ji = "#fafafa", Di = {
  SnapGreen: Qa,
  SnapBlue: Ja,
  SnapDarkBlue: Za,
  SnapYellow: ei,
  SnapOrange: ti,
  SnapLightGreen: ri,
  SnapMediumBlue: ni,
  SnapLightBlue: oi,
  SnapLavender: ai,
  SnapSand: ii,
  SnapGrey500: si,
  SnapGrey400: ui,
  SnapGrey300: ci,
  SnapGrey200: li,
  SnapGrey100: fi,
  SnapWhite: di,
  SnapError: pi,
  SnapLightError: hi,
  SnapWarning: mi,
  SnapLightWarning: gi,
  SnapSuccess: _i,
  SnapLightSuccess: yi,
  SnapNeutral: vi,
  SnapLightNeutral: bi,
  SnapLimeGreen: Si,
  SnapLimeWhite: Ri,
  SnapSeenBlue: Ei,
  SnapSeaGreen: Pi,
  SnapNeutral950: wi,
  SnapNeutral900: Oi,
  SnapNeutral800: Ai,
  SnapNeutral700: Ci,
  SnapNeutral600: Ti,
  SnapNeutral500: xi,
  SnapNeutral400: Li,
  SnapNeutral300: Mi,
  SnapNeutral200: Ni,
  SnapNeutral100: Ii,
  SnapNeutral50: ji
}, He = {
  ...Di
}, qi = Ua(Ba)(({ theme: n }) => ({
  border: "1px solid",
  color: He.SnapGrey500,
  "&.MuiAlert-standardSuccess": {
    borderColor: He.SnapGreen,
    backgroundColor: He.SnapLightSuccess
  },
  "&.MuiAlert-standardError": {
    borderColor: He.SnapError,
    backgroundColor: He.SnapLightError
  },
  "&.MuiAlert-standardWarning": {
    borderColor: He.SnapWarning,
    backgroundColor: He.SnapLightWarning
  },
  "&.MuiAlert-standardInfo": {
    borderColor: He.SnapBlue,
    backgroundColor: He.SnapLightNeutral,
    ".MuiAlert-icon": {
      color: He.SnapBlue
    }
  }
})), sa = Xa({
  isOpened: !1,
  showSuccessMessage: () => {
  },
  showErrorMessage: () => {
  },
  showWarningMessage: () => {
  },
  showInfoMessage: () => {
  },
  closeMessage: () => {
  }
});
function yu() {
  return Ka(sa);
}
function vu({
  className: n,
  children: e
}) {
  const [s, i] = rn({
    open: !1,
    type: "info",
    alertHead: "",
    message: "",
    textLink: "",
    link: "",
    showCloseIcon: !0
  }), o = Qe(() => {
    i((m) => ({ ...m, open: !1 }));
  }, []), t = (m, l) => {
    l !== "clickaway" && i((f) => ({ ...f, open: !1 }));
  }, r = Qe((m) => {
    i({
      type: "success",
      open: !0,
      ...m
    });
  }, []), a = Qe((m) => {
    i({
      type: "error",
      open: !0,
      ...m
    });
  }, []), d = Qe((m) => {
    i({
      type: "warning",
      open: !0,
      ...m
    });
  }, []), v = Qe((m) => {
    i({
      type: "info",
      open: !0,
      ...m
    });
  }, []), E = et(
    () => /* @__PURE__ */ Ze(wn, { children: [
      s.link ? /* @__PURE__ */ be(
        Wa,
        {
          href: s.link,
          variant: "link",
          size: "compact",
          style: { fontSize: "14px" },
          children: /* @__PURE__ */ be("strong", { children: s.textLink })
        }
      ) : null,
      /* @__PURE__ */ be(
        Fa,
        {
          size: "small",
          "aria-label": "close",
          color: "inherit",
          onClick: t,
          children: /* @__PURE__ */ be(Ia, { fontSize: "small" })
        }
      )
    ] }),
    [s]
  ), h = et(
    () => ({
      error: /* @__PURE__ */ be(ja, {}),
      success: /* @__PURE__ */ be(Da, {}),
      warning: /* @__PURE__ */ be(qa, {}),
      info: /* @__PURE__ */ be(Ha, {})
    })[s.type],
    [s]
  );
  return /* @__PURE__ */ Ze(
    sa.Provider,
    {
      value: {
        isOpened: s.open,
        showSuccessMessage: r,
        showErrorMessage: a,
        showWarningMessage: d,
        showInfoMessage: v,
        closeMessage: o
      },
      children: [
        e,
        /* @__PURE__ */ be(
          za,
          {
            anchorOrigin: { vertical: "top", horizontal: "center" },
            open: s.open,
            onClose: t,
            className: n,
            autoHideDuration: s.autoHideDuration,
            sx: s.customStyle,
            children: /* @__PURE__ */ be(
              qi,
              {
                icon: h,
                onClose: s.showCloseIcon ? t : void 0,
                severity: s.type,
                "data-testid": "app-message",
                action: s.showCloseIcon ? E : null,
                sx: s.customAlertStyle,
                children: s.open && /* @__PURE__ */ Ze(wn, { children: [
                  s.alertHead && /* @__PURE__ */ be(Ga, { style: { textTransform: "capitalize" }, children: /* @__PURE__ */ be("strong", { children: s.alertHead }) }),
                  s.message
                ] })
              }
            )
          }
        )
      ]
    }
  );
}
var Hi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rt(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function $i(n) {
  if (n.__esModule)
    return n;
  var e = n.default;
  if (typeof e == "function") {
    var s = function i() {
      return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    s.prototype = e.prototype;
  } else
    s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(n).forEach(function(i) {
    var o = Object.getOwnPropertyDescriptor(n, i);
    Object.defineProperty(s, i, o.get ? o : {
      enumerable: !0,
      get: function() {
        return n[i];
      }
    });
  }), s;
}
var ua = {}, Te = {};
Te._ = Te._interop_require_default = ki;
function ki(n) {
  return n && n.__esModule ? n : { default: n };
}
var on = {}, xt = {};
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.defineProperty(n, "warnOnce", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  let e = (s) => {
  };
  if (process.env.NODE_ENV !== "production") {
    const s = /* @__PURE__ */ new Set();
    e = (i) => {
      s.has(i) || console.warn(i), s.add(i);
    };
  }
})(xt);
var ca = {};
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.defineProperty(n, "getImageBlurSvg", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  function e(s) {
    let { widthInt: i, heightInt: o, blurWidth: t, blurHeight: r, blurDataURL: a, objectFit: d } = s;
    const v = 20, E = t ? t * 40 : i, h = r ? r * 40 : o, m = E && h ? "viewBox='0 0 " + E + " " + h + "'" : "", l = m ? "none" : d === "contain" ? "xMidYMid" : d === "cover" ? "xMidYMid slice" : "none";
    return "%3Csvg xmlns='http://www.w3.org/2000/svg' " + m + "%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='" + v + "'/%3E%3CfeColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 100 -1' result='s'/%3E%3CfeFlood x='0' y='0' width='100%25' height='100%25'/%3E%3CfeComposite operator='out' in='s'/%3E%3CfeComposite in2='SourceGraphic'/%3E%3CfeGaussianBlur stdDeviation='" + v + "'/%3E%3C/filter%3E%3Cimage width='100%25' height='100%25' x='0' y='0' preserveAspectRatio='" + l + "' style='filter: url(%23b);' href='" + a + "'/%3E%3C/svg%3E";
  }
})(ca);
var Lt = {};
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  function e(o, t) {
    for (var r in t)
      Object.defineProperty(o, r, {
        enumerable: !0,
        get: t[r]
      });
  }
  e(n, {
    VALID_LOADERS: function() {
      return s;
    },
    imageConfigDefault: function() {
      return i;
    }
  });
  const s = [
    "default",
    "imgix",
    "cloudinary",
    "akamai",
    "custom"
  ], i = {
    deviceSizes: [
      640,
      750,
      828,
      1080,
      1200,
      1920,
      2048,
      3840
    ],
    imageSizes: [
      16,
      32,
      48,
      64,
      96,
      128,
      256,
      384
    ],
    path: "/_next/image",
    loader: "default",
    loaderFile: "",
    domains: [],
    disableStaticImages: !1,
    minimumCacheTTL: 60,
    formats: [
      "image/webp"
    ],
    dangerouslyAllowSVG: !1,
    contentSecurityPolicy: "script-src 'none'; frame-src 'none'; sandbox;",
    contentDispositionType: "inline",
    localPatterns: void 0,
    remotePatterns: [],
    qualities: void 0,
    unoptimized: !1
  };
})(Lt);
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.defineProperty(n, "getImgProps", {
    enumerable: !0,
    get: function() {
      return l;
    }
  });
  const e = xt, s = ca, i = Lt, o = [
    "lazy",
    "eager",
    void 0
  ];
  function t(f) {
    return f.default !== void 0;
  }
  function r(f) {
    return f.src !== void 0;
  }
  function a(f) {
    return typeof f == "object" && (t(f) || r(f));
  }
  const d = /* @__PURE__ */ new Map();
  let v;
  function E(f) {
    return typeof f > "u" ? f : typeof f == "number" ? Number.isFinite(f) ? f : NaN : typeof f == "string" && /^[0-9]+$/.test(f) ? parseInt(f, 10) : NaN;
  }
  function h(f, u, c) {
    let { deviceSizes: p, allSizes: P } = f;
    if (c) {
      const y = /(^|\s)(1?\d?\d)vw/g, S = [];
      for (let R; R = y.exec(c); R)
        S.push(parseInt(R[2]));
      if (S.length) {
        const R = Math.min(...S) * 0.01;
        return {
          widths: P.filter((_) => _ >= p[0] * R),
          kind: "w"
        };
      }
      return {
        widths: P,
        kind: "w"
      };
    }
    return typeof u != "number" ? {
      widths: p,
      kind: "w"
    } : {
      widths: [
        ...new Set(
          // > This means that most OLED screens that say they are 3x resolution,
          // > are actually 3x in the green color, but only 1.5x in the red and
          // > blue colors. Showing a 3x resolution image in the app vs a 2x
          // > resolution image will be visually the same, though the 3x image
          // > takes significantly more data. Even true 3x resolution screens are
          // > wasteful as the human eye cannot see that level of detail without
          // > something like a magnifying glass.
          // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
          [
            u,
            u * 2
            /*, width * 3*/
          ].map((y) => P.find((S) => S >= y) || P[P.length - 1])
        )
      ],
      kind: "x"
    };
  }
  function m(f) {
    let { config: u, src: c, unoptimized: p, width: P, quality: g, sizes: y, loader: S } = f;
    if (p)
      return {
        src: c,
        srcSet: void 0,
        sizes: void 0
      };
    const { widths: R, kind: _ } = h(u, P, y), b = R.length - 1;
    return {
      sizes: !y && _ === "w" ? "100vw" : y,
      srcSet: R.map((A, w) => S({
        config: u,
        src: c,
        quality: g,
        width: A
      }) + " " + (_ === "w" ? A : w + 1) + _).join(", "),
      // It's intended to keep `src` the last attribute because React updates
      // attributes in order. If we keep `src` the first one, Safari will
      // immediately start to fetch `src`, before `sizes` and `srcSet` are even
      // updated by React. That causes multiple unnecessary requests if `srcSet`
      // and `sizes` are defined.
      // This bug cannot be reproduced in Chrome or Firefox.
      src: S({
        config: u,
        src: c,
        quality: g,
        width: R[b]
      })
    };
  }
  function l(f, u) {
    let { src: c, sizes: p, unoptimized: P = !1, priority: g = !1, loading: y, className: S, quality: R, width: _, height: b, fill: A = !1, style: w, overrideSrc: j, onLoad: B, onLoadingComplete: X, placeholder: O = "empty", blurDataURL: N, fetchPriority: L, decoding: z = "async", layout: $, objectFit: U, objectPosition: K, lazyBoundary: Z, lazyRoot: se, ...ee } = f;
    const { imgConf: ce, showAltText: ae, blurComplete: pe, defaultLoader: M } = u;
    let le, me = ce || i.imageConfigDefault;
    if ("allSizes" in me)
      le = me;
    else {
      var he;
      const Y = [
        ...me.deviceSizes,
        ...me.imageSizes
      ].sort((Q, te) => Q - te), I = me.deviceSizes.sort((Q, te) => Q - te), V = (he = me.qualities) == null ? void 0 : he.sort((Q, te) => Q - te);
      le = {
        ...me,
        allSizes: Y,
        deviceSizes: I,
        qualities: V
      };
    }
    if (typeof M > "u")
      throw new Error(`images.loaderFile detected but the file is missing default export.
Read more: https://nextjs.org/docs/messages/invalid-images-config`);
    let T = ee.loader || M;
    delete ee.loader, delete ee.srcSet;
    const x = "__next_img_default" in T;
    if (x) {
      if (le.loader === "custom")
        throw new Error('Image with src "' + c + `" is missing "loader" prop.
Read more: https://nextjs.org/docs/messages/next-image-missing-loader`);
    } else {
      const Y = T;
      T = (I) => {
        const { config: V, ...Q } = I;
        return Y(Q);
      };
    }
    if ($) {
      $ === "fill" && (A = !0);
      const Y = {
        intrinsic: {
          maxWidth: "100%",
          height: "auto"
        },
        responsive: {
          width: "100%",
          height: "auto"
        }
      }, I = {
        responsive: "100vw",
        fill: "100vw"
      }, V = Y[$];
      V && (w = {
        ...w,
        ...V
      });
      const Q = I[$];
      Q && !p && (p = Q);
    }
    let Re = "", q = E(_), W = E(b), H, D;
    if (a(c)) {
      const Y = t(c) ? c.default : c;
      if (!Y.src)
        throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received " + JSON.stringify(Y));
      if (!Y.height || !Y.width)
        throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received " + JSON.stringify(Y));
      if (H = Y.blurWidth, D = Y.blurHeight, N = N || Y.blurDataURL, Re = Y.src, !A) {
        if (!q && !W)
          q = Y.width, W = Y.height;
        else if (q && !W) {
          const I = q / Y.width;
          W = Math.round(Y.height * I);
        } else if (!q && W) {
          const I = W / Y.height;
          q = Math.round(Y.width * I);
        }
      }
    }
    c = typeof c == "string" ? c : Re;
    let C = !g && (y === "lazy" || typeof y > "u");
    (!c || c.startsWith("data:") || c.startsWith("blob:")) && (P = !0, C = !1), le.unoptimized && (P = !0), x && c.endsWith(".svg") && !le.dangerouslyAllowSVG && (P = !0), g && (L = "high");
    const F = E(R);
    if (process.env.NODE_ENV !== "production") {
      if (le.output === "export" && x && !P)
        throw new Error("Image Optimization using the default loader is not compatible with `{ output: 'export' }`.\n  Possible solutions:\n    - Remove `{ output: 'export' }` and run \"next start\" to run server mode including the Image Optimization API.\n    - Configure `{ images: { unoptimized: true } }` in `next.config.js` to disable the Image Optimization API.\n  Read more: https://nextjs.org/docs/messages/export-image-api");
      if (!c)
        P = !0;
      else if (A) {
        if (_)
          throw new Error('Image with src "' + c + '" has both "width" and "fill" properties. Only one should be used.');
        if (b)
          throw new Error('Image with src "' + c + '" has both "height" and "fill" properties. Only one should be used.');
        if (w != null && w.position && w.position !== "absolute")
          throw new Error('Image with src "' + c + '" has both "fill" and "style.position" properties. Images with "fill" always use position absolute - it cannot be modified.');
        if (w != null && w.width && w.width !== "100%")
          throw new Error('Image with src "' + c + '" has both "fill" and "style.width" properties. Images with "fill" always use width 100% - it cannot be modified.');
        if (w != null && w.height && w.height !== "100%")
          throw new Error('Image with src "' + c + '" has both "fill" and "style.height" properties. Images with "fill" always use height 100% - it cannot be modified.');
      } else {
        if (typeof q > "u")
          throw new Error('Image with src "' + c + '" is missing required "width" property.');
        if (isNaN(q))
          throw new Error('Image with src "' + c + '" has invalid "width" property. Expected a numeric value in pixels but received "' + _ + '".');
        if (typeof W > "u")
          throw new Error('Image with src "' + c + '" is missing required "height" property.');
        if (isNaN(W))
          throw new Error('Image with src "' + c + '" has invalid "height" property. Expected a numeric value in pixels but received "' + b + '".');
      }
      if (!o.includes(y))
        throw new Error('Image with src "' + c + '" has invalid "loading" property. Provided "' + y + '" should be one of ' + o.map(String).join(",") + ".");
      if (g && y === "lazy")
        throw new Error('Image with src "' + c + `" has both "priority" and "loading='lazy'" properties. Only one should be used.`);
      if (O !== "empty" && O !== "blur" && !O.startsWith("data:image/"))
        throw new Error('Image with src "' + c + '" has invalid "placeholder" property "' + O + '".');
      if (O !== "empty" && q && W && q * W < 1600 && (0, e.warnOnce)('Image with src "' + c + '" is smaller than 40x40. Consider removing the "placeholder" property to improve performance.'), O === "blur" && !N) {
        const Y = [
          "jpeg",
          "png",
          "webp",
          "avif"
        ];
        throw new Error('Image with src "' + c + `" has "placeholder='blur'" property but is missing the "blurDataURL" property.
        Possible solutions:
          - Add a "blurDataURL" property, the contents should be a small Data URL to represent the image
          - Change the "src" property to a static import with one of the supported file types: ` + Y.join(",") + ` (animated images not supported)
          - Remove the "placeholder" property, effectively no blur effect
        Read more: https://nextjs.org/docs/messages/placeholder-blur-data-url`);
      }
      if ("ref" in ee && (0, e.warnOnce)('Image with src "' + c + '" is using unsupported "ref" property. Consider using the "onLoad" property instead.'), !P && !x) {
        const Y = T({
          config: le,
          src: c,
          width: q || 400,
          quality: F || 75
        });
        let I;
        try {
          I = new URL(Y);
        } catch {
        }
        (Y === c || I && I.pathname === c && !I.search) && (0, e.warnOnce)('Image with src "' + c + `" has a "loader" property that does not implement width. Please implement it or use the "unoptimized" property instead.
Read more: https://nextjs.org/docs/messages/next-image-missing-loader-width`);
      }
      X && (0, e.warnOnce)('Image with src "' + c + '" is using deprecated "onLoadingComplete" property. Please use the "onLoad" property instead.');
      for (const [Y, I] of Object.entries({
        layout: $,
        objectFit: U,
        objectPosition: K,
        lazyBoundary: Z,
        lazyRoot: se
      }))
        I && (0, e.warnOnce)('Image with src "' + c + '" has legacy prop "' + Y + `". Did you forget to run the codemod?
Read more: https://nextjs.org/docs/messages/next-image-upgrade-to-13`);
      if (typeof window < "u" && !v && window.PerformanceObserver) {
        v = new PerformanceObserver((Y) => {
          for (const V of Y.getEntries()) {
            var I;
            const Q = (V == null || (I = V.element) == null ? void 0 : I.src) || "", te = d.get(Q);
            te && !te.priority && te.placeholder === "empty" && !te.src.startsWith("data:") && !te.src.startsWith("blob:") && (0, e.warnOnce)('Image with src "' + te.src + `" was detected as the Largest Contentful Paint (LCP). Please add the "priority" property if this image is above the fold.
Read more: https://nextjs.org/docs/api-reference/next/image#priority`);
          }
        });
        try {
          v.observe({
            type: "largest-contentful-paint",
            buffered: !0
          });
        } catch (Y) {
          console.error(Y);
        }
      }
    }
    const ue = Object.assign(A ? {
      position: "absolute",
      height: "100%",
      width: "100%",
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      objectFit: U,
      objectPosition: K
    } : {}, ae ? {} : {
      color: "transparent"
    }, w), oe = !pe && O !== "empty" ? O === "blur" ? 'url("data:image/svg+xml;charset=utf-8,' + (0, s.getImageBlurSvg)({
      widthInt: q,
      heightInt: W,
      blurWidth: H,
      blurHeight: D,
      blurDataURL: N || "",
      objectFit: ue.objectFit
    }) + '")' : 'url("' + O + '")' : null;
    let k = oe ? {
      backgroundSize: ue.objectFit || "cover",
      backgroundPosition: ue.objectPosition || "50% 50%",
      backgroundRepeat: "no-repeat",
      backgroundImage: oe
    } : {};
    process.env.NODE_ENV === "development" && k.backgroundImage && O === "blur" && N != null && N.startsWith("/") && (k.backgroundImage = 'url("' + N + '")');
    const ne = m({
      config: le,
      src: c,
      unoptimized: P,
      width: q,
      quality: F,
      sizes: p,
      loader: T
    });
    if (process.env.NODE_ENV !== "production" && typeof window < "u") {
      let Y;
      try {
        Y = new URL(ne.src);
      } catch {
        Y = new URL(ne.src, window.location.href);
      }
      d.set(Y.href, {
        src: c,
        priority: g,
        placeholder: O
      });
    }
    return {
      props: {
        ...ee,
        loading: C ? "lazy" : y,
        fetchPriority: L,
        width: q,
        height: W,
        decoding: z,
        className: S,
        style: {
          ...ue,
          ...k
        },
        sizes: ne.sizes,
        srcSet: ne.srcSet,
        src: j || ne.src
      },
      meta: {
        unoptimized: P,
        priority: g,
        placeholder: O,
        fill: A
      }
    };
  }
})(on);
var Fr = { exports: {} }, Be = {};
function la(n) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap();
  return (la = function(i) {
    return i ? s : e;
  })(n);
}
Be._ = Be._interop_require_wildcard = Ui;
function Ui(n, e) {
  if (!e && n && n.__esModule)
    return n;
  if (n === null || typeof n != "object" && typeof n != "function")
    return { default: n };
  var s = la(e);
  if (s && s.has(n))
    return s.get(n);
  var i = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var t in n)
    if (t !== "default" && Object.prototype.hasOwnProperty.call(n, t)) {
      var r = o ? Object.getOwnPropertyDescriptor(n, t) : null;
      r && (r.get || r.set) ? Object.defineProperty(i, t, r) : i[t] = n[t];
    }
  return i.default = n, s && s.set(n, i), i;
}
var at = { exports: {} }, Ht = {}, On;
function Bi() {
  return On || (On = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    const e = xe, s = typeof window > "u", i = s ? () => {
    } : e.useLayoutEffect, o = s ? () => {
    } : e.useEffect;
    function t(r) {
      const { headManager: a, reduceComponentsToState: d } = r;
      function v() {
        if (a && a.mountedInstances) {
          const h = e.Children.toArray(Array.from(a.mountedInstances).filter(Boolean));
          a.updateHead(d(h, r));
        }
      }
      if (s) {
        var E;
        a == null || (E = a.mountedInstances) == null || E.add(r.children), v();
      }
      return i(() => {
        var h;
        return a == null || (h = a.mountedInstances) == null || h.add(r.children), () => {
          var m;
          a == null || (m = a.mountedInstances) == null || m.delete(r.children);
        };
      }), i(() => (a && (a._pendingUpdate = v), () => {
        a && (a._pendingUpdate = v);
      })), o(() => (a && a._pendingUpdate && (a._pendingUpdate(), a._pendingUpdate = null), () => {
        a && a._pendingUpdate && (a._pendingUpdate(), a._pendingUpdate = null);
      })), null;
    }
  }(Ht)), Ht;
}
var $t = {}, An;
function Fi() {
  return An || (An = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "AmpStateContext", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const i = (/* @__PURE__ */ Te._(xe)).default.createContext({});
    process.env.NODE_ENV !== "production" && (i.displayName = "AmpStateContext");
  }($t)), $t;
}
var kt = {}, Cn;
function fa() {
  return Cn || (Cn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "HeadManagerContext", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const i = (/* @__PURE__ */ Te._(xe)).default.createContext({});
    process.env.NODE_ENV !== "production" && (i.displayName = "HeadManagerContext");
  }(kt)), kt;
}
var Ut = {}, Tn;
function zi() {
  return Tn || (Tn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "isInAmpMode", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s) {
      let { ampFirst: i = !1, hybrid: o = !1, hasQuery: t = !1 } = s === void 0 ? {} : s;
      return i || o && t;
    }
  }(Ut)), Ut;
}
var xn;
function Gi() {
  return xn || (xn = 1, function(n, e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function s(g, y) {
      for (var S in y)
        Object.defineProperty(g, S, {
          enumerable: !0,
          get: y[S]
        });
    }
    s(e, {
      default: function() {
        return P;
      },
      defaultHead: function() {
        return m;
      }
    });
    const i = Te, o = Be, t = tt, r = /* @__PURE__ */ o._(xe), a = /* @__PURE__ */ i._(Bi()), d = Fi(), v = fa(), E = zi(), h = xt;
    function m(g) {
      g === void 0 && (g = !1);
      const y = [
        /* @__PURE__ */ (0, t.jsx)("meta", {
          charSet: "utf-8"
        })
      ];
      return g || y.push(/* @__PURE__ */ (0, t.jsx)("meta", {
        name: "viewport",
        content: "width=device-width"
      })), y;
    }
    function l(g, y) {
      return typeof y == "string" || typeof y == "number" ? g : y.type === r.default.Fragment ? g.concat(
        // @ts-expect-error @types/react does not remove fragments but this could also return ReactPortal[]
        r.default.Children.toArray(y.props.children).reduce(
          // @ts-expect-error @types/react does not remove fragments but this could also return ReactPortal[]
          (S, R) => typeof R == "string" || typeof R == "number" ? S : S.concat(R),
          []
        )
      ) : g.concat(y);
    }
    const f = [
      "name",
      "httpEquiv",
      "charSet",
      "itemProp"
    ];
    function u() {
      const g = /* @__PURE__ */ new Set(), y = /* @__PURE__ */ new Set(), S = /* @__PURE__ */ new Set(), R = {};
      return (_) => {
        let b = !0, A = !1;
        if (_.key && typeof _.key != "number" && _.key.indexOf("$") > 0) {
          A = !0;
          const w = _.key.slice(_.key.indexOf("$") + 1);
          g.has(w) ? b = !1 : g.add(w);
        }
        switch (_.type) {
          case "title":
          case "base":
            y.has(_.type) ? b = !1 : y.add(_.type);
            break;
          case "meta":
            for (let w = 0, j = f.length; w < j; w++) {
              const B = f[w];
              if (_.props.hasOwnProperty(B))
                if (B === "charSet")
                  S.has(B) ? b = !1 : S.add(B);
                else {
                  const X = _.props[B], O = R[B] || /* @__PURE__ */ new Set();
                  (B !== "name" || !A) && O.has(X) ? b = !1 : (O.add(X), R[B] = O);
                }
            }
            break;
        }
        return b;
      };
    }
    function c(g, y) {
      const { inAmpMode: S } = y;
      return g.reduce(l, []).reverse().concat(m(S).reverse()).filter(u()).reverse().map((R, _) => {
        const b = R.key || _;
        if (process.env.NODE_ENV !== "development" && process.env.__NEXT_OPTIMIZE_FONTS && !S && R.type === "link" && R.props.href && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
        [
          "https://fonts.googleapis.com/css",
          "https://use.typekit.net/"
        ].some((A) => R.props.href.startsWith(A))) {
          const A = {
            ...R.props || {}
          };
          return A["data-href"] = A.href, A.href = void 0, A["data-optimized-fonts"] = !0, /* @__PURE__ */ r.default.cloneElement(R, A);
        }
        if (process.env.NODE_ENV === "development")
          if (R.type === "script" && R.props.type !== "application/ld+json") {
            const A = R.props.src ? '<script> tag with src="' + R.props.src + '"' : "inline <script>";
            (0, h.warnOnce)("Do not add <script> tags using next/head (see " + A + `). Use next/script instead. 
See more info here: https://nextjs.org/docs/messages/no-script-tags-in-head-component`);
          } else
            R.type === "link" && R.props.rel === "stylesheet" && (0, h.warnOnce)('Do not add stylesheets using next/head (see <link rel="stylesheet"> tag with href="' + R.props.href + `"). Use Document instead. 
See more info here: https://nextjs.org/docs/messages/no-stylesheets-in-head-component`);
        return /* @__PURE__ */ r.default.cloneElement(R, {
          key: b
        });
      });
    }
    function p(g) {
      let { children: y } = g;
      const S = (0, r.useContext)(d.AmpStateContext), R = (0, r.useContext)(v.HeadManagerContext);
      return /* @__PURE__ */ (0, t.jsx)(a.default, {
        reduceComponentsToState: c,
        headManager: R,
        inAmpMode: (0, E.isInAmpMode)(S),
        children: y
      });
    }
    const P = p;
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(at, at.exports)), at.exports;
}
var Bt = {}, Ln;
function Wi() {
  return Ln || (Ln = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "ImageConfigContext", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const s = /* @__PURE__ */ Te._(xe), i = Lt, o = s.default.createContext(i.imageConfigDefault);
    process.env.NODE_ENV !== "production" && (o.displayName = "ImageConfigContext");
  }(Bt)), Bt;
}
var Ft = {}, Mn;
function an() {
  return Mn || (Mn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "RouterContext", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const i = (/* @__PURE__ */ Te._(xe)).default.createContext(null);
    process.env.NODE_ENV !== "production" && (i.displayName = "RouterContext");
  }(Ft)), Ft;
}
var zt = {}, Gt = {}, Wt = { exports: {} }, Nn;
function da() {
  return Nn || (Nn = 1, (() => {
    var n = { 170: (o, t, r) => {
      const a = r(510), d = () => {
        if (typeof navigator < "u" && navigator.platform) {
          const E = navigator.platform.toLowerCase();
          return E === "win32" || E === "windows";
        }
        return typeof process < "u" && process.platform ? process.platform === "win32" : !1;
      };
      function v(E, h, m = !1) {
        return h && (h.windows === null || h.windows === void 0) && (h = { ...h, windows: d() }), a(E, h, m);
      }
      Object.assign(v, a), o.exports = v;
    }, 154: (o) => {
      const t = "\\\\/", r = `[^${t}]`, a = "\\.", d = "\\+", v = "\\?", E = "\\/", h = "(?=.)", m = "[^/]", l = `(?:${E}|$)`, f = `(?:^|${E})`, u = `${a}{1,2}${l}`, c = `(?!${a})`, p = `(?!${f}${u})`, P = `(?!${a}{0,1}${l})`, g = `(?!${u})`, y = `[^.${E}]`, S = `${m}*?`, _ = { DOT_LITERAL: a, PLUS_LITERAL: d, QMARK_LITERAL: v, SLASH_LITERAL: E, ONE_CHAR: h, QMARK: m, END_ANCHOR: l, DOTS_SLASH: u, NO_DOT: c, NO_DOTS: p, NO_DOT_SLASH: P, NO_DOTS_SLASH: g, QMARK_NO_DOT: y, STAR: S, START_ANCHOR: f, SEP: "/" }, b = { ..._, SLASH_LITERAL: `[${t}]`, QMARK: r, STAR: `${r}*?`, DOTS_SLASH: `${a}{1,2}(?:[${t}]|$)`, NO_DOT: `(?!${a})`, NO_DOTS: `(?!(?:^|[${t}])${a}{1,2}(?:[${t}]|$))`, NO_DOT_SLASH: `(?!${a}{0,1}(?:[${t}]|$))`, NO_DOTS_SLASH: `(?!${a}{1,2}(?:[${t}]|$))`, QMARK_NO_DOT: `[^.${t}]`, START_ANCHOR: `(?:^|[${t}])`, END_ANCHOR: `(?:[${t}]|$)`, SEP: "\\" }, A = { alnum: "a-zA-Z0-9", alpha: "a-zA-Z", ascii: "\\x00-\\x7F", blank: " \\t", cntrl: "\\x00-\\x1F\\x7F", digit: "0-9", graph: "\\x21-\\x7E", lower: "a-z", print: "\\x20-\\x7E ", punct: "\\-!\"#$%&'()\\*+,./:;<=>?@[\\]^_`{|}~", space: " \\t\\r\\n\\v\\f", upper: "A-Z", word: "A-Za-z0-9_", xdigit: "A-Fa-f0-9" };
      o.exports = { MAX_LENGTH: 65536, POSIX_REGEX_SOURCE: A, REGEX_BACKSLASH: /\\(?![*+?^${}(|)[\]])/g, REGEX_NON_SPECIAL_CHARS: /^[^@![\].,$*+?^{}()|\\/]+/, REGEX_SPECIAL_CHARS: /[-*+?.^${}(|)[\]]/, REGEX_SPECIAL_CHARS_BACKREF: /(\\?)((\W)(\3*))/g, REGEX_SPECIAL_CHARS_GLOBAL: /([-*+?.^${}(|)[\]])/g, REGEX_REMOVE_BACKSLASH: /(?:\[.*?[^\\]\]|\\(?=.))/g, REPLACEMENTS: { "***": "*", "**/**": "**", "**/**/**": "**" }, CHAR_0: 48, CHAR_9: 57, CHAR_UPPERCASE_A: 65, CHAR_LOWERCASE_A: 97, CHAR_UPPERCASE_Z: 90, CHAR_LOWERCASE_Z: 122, CHAR_LEFT_PARENTHESES: 40, CHAR_RIGHT_PARENTHESES: 41, CHAR_ASTERISK: 42, CHAR_AMPERSAND: 38, CHAR_AT: 64, CHAR_BACKWARD_SLASH: 92, CHAR_CARRIAGE_RETURN: 13, CHAR_CIRCUMFLEX_ACCENT: 94, CHAR_COLON: 58, CHAR_COMMA: 44, CHAR_DOT: 46, CHAR_DOUBLE_QUOTE: 34, CHAR_EQUAL: 61, CHAR_EXCLAMATION_MARK: 33, CHAR_FORM_FEED: 12, CHAR_FORWARD_SLASH: 47, CHAR_GRAVE_ACCENT: 96, CHAR_HASH: 35, CHAR_HYPHEN_MINUS: 45, CHAR_LEFT_ANGLE_BRACKET: 60, CHAR_LEFT_CURLY_BRACE: 123, CHAR_LEFT_SQUARE_BRACKET: 91, CHAR_LINE_FEED: 10, CHAR_NO_BREAK_SPACE: 160, CHAR_PERCENT: 37, CHAR_PLUS: 43, CHAR_QUESTION_MARK: 63, CHAR_RIGHT_ANGLE_BRACKET: 62, CHAR_RIGHT_CURLY_BRACE: 125, CHAR_RIGHT_SQUARE_BRACKET: 93, CHAR_SEMICOLON: 59, CHAR_SINGLE_QUOTE: 39, CHAR_SPACE: 32, CHAR_TAB: 9, CHAR_UNDERSCORE: 95, CHAR_VERTICAL_LINE: 124, CHAR_ZERO_WIDTH_NOBREAK_SPACE: 65279, extglobChars(w) {
        return { "!": { type: "negate", open: "(?:(?!(?:", close: `))${w.STAR})` }, "?": { type: "qmark", open: "(?:", close: ")?" }, "+": { type: "plus", open: "(?:", close: ")+" }, "*": { type: "star", open: "(?:", close: ")*" }, "@": { type: "at", open: "(?:", close: ")" } };
      }, globChars(w) {
        return w === !0 ? b : _;
      } };
    }, 697: (o, t, r) => {
      const a = r(154), d = r(96), { MAX_LENGTH: v, POSIX_REGEX_SOURCE: E, REGEX_NON_SPECIAL_CHARS: h, REGEX_SPECIAL_CHARS_BACKREF: m, REPLACEMENTS: l } = a, f = (p, P) => {
        if (typeof P.expandRange == "function")
          return P.expandRange(...p, P);
        p.sort();
        const g = `[${p.join("-")}]`;
        try {
          new RegExp(g);
        } catch {
          return p.map((S) => d.escapeRegex(S)).join("..");
        }
        return g;
      }, u = (p, P) => `Missing ${p}: "${P}" - use "\\\\${P}" to match literal characters`, c = (p, P) => {
        if (typeof p != "string")
          throw new TypeError("Expected a string");
        p = l[p] || p;
        const g = { ...P }, y = typeof g.maxLength == "number" ? Math.min(v, g.maxLength) : v;
        let S = p.length;
        if (S > y)
          throw new SyntaxError(`Input length: ${S}, exceeds maximum allowed length: ${y}`);
        const R = { type: "bos", value: "", output: g.prepend || "" }, _ = [R], b = g.capture ? "" : "?:", A = a.globChars(g.windows), w = a.extglobChars(A), { DOT_LITERAL: j, PLUS_LITERAL: B, SLASH_LITERAL: X, ONE_CHAR: O, DOTS_SLASH: N, NO_DOT: L, NO_DOT_SLASH: z, NO_DOTS_SLASH: $, QMARK: U, QMARK_NO_DOT: K, STAR: Z, START_ANCHOR: se } = A, ee = (G) => `(${b}(?:(?!${se}${G.dot ? N : j}).)*?)`, ce = g.dot ? "" : L, ae = g.dot ? U : K;
        let pe = g.bash === !0 ? ee(g) : Z;
        g.capture && (pe = `(${pe})`), typeof g.noext == "boolean" && (g.noextglob = g.noext);
        const M = { input: p, index: -1, start: 0, dot: g.dot === !0, consumed: "", output: "", prefix: "", backtrack: !1, negated: !1, brackets: 0, braces: 0, parens: 0, quotes: 0, globstar: !1, tokens: _ };
        p = d.removePrefix(p, M), S = p.length;
        const le = [], me = [], he = [];
        let T = R, x;
        const Re = () => M.index === S - 1, q = M.peek = (G = 1) => p[M.index + G], W = M.advance = () => p[++M.index] || "", H = () => p.slice(M.index + 1), D = (G = "", Y = 0) => {
          M.consumed += G, M.index += Y;
        }, C = (G) => {
          M.output += G.output != null ? G.output : G.value, D(G.value);
        }, F = () => {
          let G = 1;
          for (; q() === "!" && (q(2) !== "(" || q(3) === "?"); )
            W(), M.start++, G++;
          return G % 2 === 0 ? !1 : (M.negated = !0, M.start++, !0);
        }, ue = (G) => {
          M[G]++, he.push(G);
        }, oe = (G) => {
          M[G]--, he.pop();
        }, k = (G) => {
          if (T.type === "globstar") {
            const Y = M.braces > 0 && (G.type === "comma" || G.type === "brace"), I = G.extglob === !0 || le.length && (G.type === "pipe" || G.type === "paren");
            G.type !== "slash" && G.type !== "paren" && !Y && !I && (M.output = M.output.slice(0, -T.output.length), T.type = "star", T.value = "*", T.output = pe, M.output += T.output);
          }
          if (le.length && G.type !== "paren" && (le[le.length - 1].inner += G.value), (G.value || G.output) && C(G), T && T.type === "text" && G.type === "text") {
            T.output = (T.output || T.value) + G.value, T.value += G.value;
            return;
          }
          G.prev = T, _.push(G), T = G;
        }, ne = (G, Y) => {
          const I = { ...w[Y], conditions: 1, inner: "" };
          I.prev = T, I.parens = M.parens, I.output = M.output;
          const V = (g.capture ? "(" : "") + I.open;
          ue("parens"), k({ type: G, value: Y, output: M.output ? "" : O }), k({ type: "paren", extglob: !0, value: W(), output: V }), le.push(I);
        }, J = (G) => {
          let Y = G.close + (g.capture ? ")" : ""), I;
          if (G.type === "negate") {
            let V = pe;
            if (G.inner && G.inner.length > 1 && G.inner.includes("/") && (V = ee(g)), (V !== pe || Re() || /^\)+$/.test(H())) && (Y = G.close = `)$))${V}`), G.inner.includes("*") && (I = H()) && /^\.[^\\/.]+$/.test(I)) {
              const Q = c(I, { ...P, fastpaths: !1 }).output;
              Y = G.close = `)${Q})${V})`;
            }
            G.prev.type === "bos" && (M.negatedExtglob = !0);
          }
          k({ type: "paren", extglob: !0, value: x, output: Y }), oe("parens");
        };
        if (g.fastpaths !== !1 && !/(^[*!]|[/()[\]{}"])/.test(p)) {
          let G = !1, Y = p.replace(m, (I, V, Q, te, ie, ve) => te === "\\" ? (G = !0, I) : te === "?" ? V ? V + te + (ie ? U.repeat(ie.length) : "") : ve === 0 ? ae + (ie ? U.repeat(ie.length) : "") : U.repeat(Q.length) : te === "." ? j.repeat(Q.length) : te === "*" ? V ? V + te + (ie ? pe : "") : pe : V ? I : `\\${I}`);
          return G === !0 && (g.unescape === !0 ? Y = Y.replace(/\\/g, "") : Y = Y.replace(/\\+/g, (I) => I.length % 2 === 0 ? "\\\\" : I ? "\\" : "")), Y === p && g.contains === !0 ? (M.output = p, M) : (M.output = d.wrapOutput(Y, M, P), M);
        }
        for (; !Re(); ) {
          if (x = W(), x === "\0")
            continue;
          if (x === "\\") {
            const I = q();
            if (I === "/" && g.bash !== !0 || I === "." || I === ";")
              continue;
            if (!I) {
              x += "\\", k({ type: "text", value: x });
              continue;
            }
            const V = /^\\+/.exec(H());
            let Q = 0;
            if (V && V[0].length > 2 && (Q = V[0].length, M.index += Q, Q % 2 !== 0 && (x += "\\")), g.unescape === !0 ? x = W() : x += W(), M.brackets === 0) {
              k({ type: "text", value: x });
              continue;
            }
          }
          if (M.brackets > 0 && (x !== "]" || T.value === "[" || T.value === "[^")) {
            if (g.posix !== !1 && x === ":") {
              const I = T.value.slice(1);
              if (I.includes("[") && (T.posix = !0, I.includes(":"))) {
                const V = T.value.lastIndexOf("["), Q = T.value.slice(0, V), te = T.value.slice(V + 2), ie = E[te];
                if (ie) {
                  T.value = Q + ie, M.backtrack = !0, W(), !R.output && _.indexOf(T) === 1 && (R.output = O);
                  continue;
                }
              }
            }
            (x === "[" && q() !== ":" || x === "-" && q() === "]") && (x = `\\${x}`), x === "]" && (T.value === "[" || T.value === "[^") && (x = `\\${x}`), g.posix === !0 && x === "!" && T.value === "[" && (x = "^"), T.value += x, C({ value: x });
            continue;
          }
          if (M.quotes === 1 && x !== '"') {
            x = d.escapeRegex(x), T.value += x, C({ value: x });
            continue;
          }
          if (x === '"') {
            M.quotes = M.quotes === 1 ? 0 : 1, g.keepQuotes === !0 && k({ type: "text", value: x });
            continue;
          }
          if (x === "(") {
            ue("parens"), k({ type: "paren", value: x });
            continue;
          }
          if (x === ")") {
            if (M.parens === 0 && g.strictBrackets === !0)
              throw new SyntaxError(u("opening", "("));
            const I = le[le.length - 1];
            if (I && M.parens === I.parens + 1) {
              J(le.pop());
              continue;
            }
            k({ type: "paren", value: x, output: M.parens ? ")" : "\\)" }), oe("parens");
            continue;
          }
          if (x === "[") {
            if (g.nobracket === !0 || !H().includes("]")) {
              if (g.nobracket !== !0 && g.strictBrackets === !0)
                throw new SyntaxError(u("closing", "]"));
              x = `\\${x}`;
            } else
              ue("brackets");
            k({ type: "bracket", value: x });
            continue;
          }
          if (x === "]") {
            if (g.nobracket === !0 || T && T.type === "bracket" && T.value.length === 1) {
              k({ type: "text", value: x, output: `\\${x}` });
              continue;
            }
            if (M.brackets === 0) {
              if (g.strictBrackets === !0)
                throw new SyntaxError(u("opening", "["));
              k({ type: "text", value: x, output: `\\${x}` });
              continue;
            }
            oe("brackets");
            const I = T.value.slice(1);
            if (T.posix !== !0 && I[0] === "^" && !I.includes("/") && (x = `/${x}`), T.value += x, C({ value: x }), g.literalBrackets === !1 || d.hasRegexChars(I))
              continue;
            const V = d.escapeRegex(T.value);
            if (M.output = M.output.slice(0, -T.value.length), g.literalBrackets === !0) {
              M.output += V, T.value = V;
              continue;
            }
            T.value = `(${b}${V}|${T.value})`, M.output += T.value;
            continue;
          }
          if (x === "{" && g.nobrace !== !0) {
            ue("braces");
            const I = { type: "brace", value: x, output: "(", outputIndex: M.output.length, tokensIndex: M.tokens.length };
            me.push(I), k(I);
            continue;
          }
          if (x === "}") {
            const I = me[me.length - 1];
            if (g.nobrace === !0 || !I) {
              k({ type: "text", value: x, output: x });
              continue;
            }
            let V = ")";
            if (I.dots === !0) {
              const Q = _.slice(), te = [];
              for (let ie = Q.length - 1; ie >= 0 && (_.pop(), Q[ie].type !== "brace"); ie--)
                Q[ie].type !== "dots" && te.unshift(Q[ie].value);
              V = f(te, g), M.backtrack = !0;
            }
            if (I.comma !== !0 && I.dots !== !0) {
              const Q = M.output.slice(0, I.outputIndex), te = M.tokens.slice(I.tokensIndex);
              I.value = I.output = "\\{", x = V = "\\}", M.output = Q;
              for (const ie of te)
                M.output += ie.output || ie.value;
            }
            k({ type: "brace", value: x, output: V }), oe("braces"), me.pop();
            continue;
          }
          if (x === "|") {
            le.length > 0 && le[le.length - 1].conditions++, k({ type: "text", value: x });
            continue;
          }
          if (x === ",") {
            let I = x;
            const V = me[me.length - 1];
            V && he[he.length - 1] === "braces" && (V.comma = !0, I = "|"), k({ type: "comma", value: x, output: I });
            continue;
          }
          if (x === "/") {
            if (T.type === "dot" && M.index === M.start + 1) {
              M.start = M.index + 1, M.consumed = "", M.output = "", _.pop(), T = R;
              continue;
            }
            k({ type: "slash", value: x, output: X });
            continue;
          }
          if (x === ".") {
            if (M.braces > 0 && T.type === "dot") {
              T.value === "." && (T.output = j);
              const I = me[me.length - 1];
              T.type = "dots", T.output += x, T.value += x, I.dots = !0;
              continue;
            }
            if (M.braces + M.parens === 0 && T.type !== "bos" && T.type !== "slash") {
              k({ type: "text", value: x, output: j });
              continue;
            }
            k({ type: "dot", value: x, output: j });
            continue;
          }
          if (x === "?") {
            if (!(T && T.value === "(") && g.noextglob !== !0 && q() === "(" && q(2) !== "?") {
              ne("qmark", x);
              continue;
            }
            if (T && T.type === "paren") {
              const V = q();
              let Q = x;
              (T.value === "(" && !/[!=<:]/.test(V) || V === "<" && !/<([!=]|\w+>)/.test(H())) && (Q = `\\${x}`), k({ type: "text", value: x, output: Q });
              continue;
            }
            if (g.dot !== !0 && (T.type === "slash" || T.type === "bos")) {
              k({ type: "qmark", value: x, output: K });
              continue;
            }
            k({ type: "qmark", value: x, output: U });
            continue;
          }
          if (x === "!") {
            if (g.noextglob !== !0 && q() === "(" && (q(2) !== "?" || !/[!=<:]/.test(q(3)))) {
              ne("negate", x);
              continue;
            }
            if (g.nonegate !== !0 && M.index === 0) {
              F();
              continue;
            }
          }
          if (x === "+") {
            if (g.noextglob !== !0 && q() === "(" && q(2) !== "?") {
              ne("plus", x);
              continue;
            }
            if (T && T.value === "(" || g.regex === !1) {
              k({ type: "plus", value: x, output: B });
              continue;
            }
            if (T && (T.type === "bracket" || T.type === "paren" || T.type === "brace") || M.parens > 0) {
              k({ type: "plus", value: x });
              continue;
            }
            k({ type: "plus", value: B });
            continue;
          }
          if (x === "@") {
            if (g.noextglob !== !0 && q() === "(" && q(2) !== "?") {
              k({ type: "at", extglob: !0, value: x, output: "" });
              continue;
            }
            k({ type: "text", value: x });
            continue;
          }
          if (x !== "*") {
            (x === "$" || x === "^") && (x = `\\${x}`);
            const I = h.exec(H());
            I && (x += I[0], M.index += I[0].length), k({ type: "text", value: x });
            continue;
          }
          if (T && (T.type === "globstar" || T.star === !0)) {
            T.type = "star", T.star = !0, T.value += x, T.output = pe, M.backtrack = !0, M.globstar = !0, D(x);
            continue;
          }
          let G = H();
          if (g.noextglob !== !0 && /^\([^?]/.test(G)) {
            ne("star", x);
            continue;
          }
          if (T.type === "star") {
            if (g.noglobstar === !0) {
              D(x);
              continue;
            }
            const I = T.prev, V = I.prev, Q = I.type === "slash" || I.type === "bos", te = V && (V.type === "star" || V.type === "globstar");
            if (g.bash === !0 && (!Q || G[0] && G[0] !== "/")) {
              k({ type: "star", value: x, output: "" });
              continue;
            }
            const ie = M.braces > 0 && (I.type === "comma" || I.type === "brace"), ve = le.length && (I.type === "pipe" || I.type === "paren");
            if (!Q && I.type !== "paren" && !ie && !ve) {
              k({ type: "star", value: x, output: "" });
              continue;
            }
            for (; G.slice(0, 3) === "/**"; ) {
              const Se = p[M.index + 4];
              if (Se && Se !== "/")
                break;
              G = G.slice(3), D("/**", 3);
            }
            if (I.type === "bos" && Re()) {
              T.type = "globstar", T.value += x, T.output = ee(g), M.output = T.output, M.globstar = !0, D(x);
              continue;
            }
            if (I.type === "slash" && I.prev.type !== "bos" && !te && Re()) {
              M.output = M.output.slice(0, -(I.output + T.output).length), I.output = `(?:${I.output}`, T.type = "globstar", T.output = ee(g) + (g.strictSlashes ? ")" : "|$)"), T.value += x, M.globstar = !0, M.output += I.output + T.output, D(x);
              continue;
            }
            if (I.type === "slash" && I.prev.type !== "bos" && G[0] === "/") {
              const Se = G[1] !== void 0 ? "|$" : "";
              M.output = M.output.slice(0, -(I.output + T.output).length), I.output = `(?:${I.output}`, T.type = "globstar", T.output = `${ee(g)}${X}|${X}${Se})`, T.value += x, M.output += I.output + T.output, M.globstar = !0, D(x + W()), k({ type: "slash", value: "/", output: "" });
              continue;
            }
            if (I.type === "bos" && G[0] === "/") {
              T.type = "globstar", T.value += x, T.output = `(?:^|${X}|${ee(g)}${X})`, M.output = T.output, M.globstar = !0, D(x + W()), k({ type: "slash", value: "/", output: "" });
              continue;
            }
            M.output = M.output.slice(0, -T.output.length), T.type = "globstar", T.output = ee(g), T.value += x, M.output += T.output, M.globstar = !0, D(x);
            continue;
          }
          const Y = { type: "star", value: x, output: pe };
          if (g.bash === !0) {
            Y.output = ".*?", (T.type === "bos" || T.type === "slash") && (Y.output = ce + Y.output), k(Y);
            continue;
          }
          if (T && (T.type === "bracket" || T.type === "paren") && g.regex === !0) {
            Y.output = x, k(Y);
            continue;
          }
          (M.index === M.start || T.type === "slash" || T.type === "dot") && (T.type === "dot" ? (M.output += z, T.output += z) : g.dot === !0 ? (M.output += $, T.output += $) : (M.output += ce, T.output += ce), q() !== "*" && (M.output += O, T.output += O)), k(Y);
        }
        for (; M.brackets > 0; ) {
          if (g.strictBrackets === !0)
            throw new SyntaxError(u("closing", "]"));
          M.output = d.escapeLast(M.output, "["), oe("brackets");
        }
        for (; M.parens > 0; ) {
          if (g.strictBrackets === !0)
            throw new SyntaxError(u("closing", ")"));
          M.output = d.escapeLast(M.output, "("), oe("parens");
        }
        for (; M.braces > 0; ) {
          if (g.strictBrackets === !0)
            throw new SyntaxError(u("closing", "}"));
          M.output = d.escapeLast(M.output, "{"), oe("braces");
        }
        if (g.strictSlashes !== !0 && (T.type === "star" || T.type === "bracket") && k({ type: "maybe_slash", value: "", output: `${X}?` }), M.backtrack === !0) {
          M.output = "";
          for (const G of M.tokens)
            M.output += G.output != null ? G.output : G.value, G.suffix && (M.output += G.suffix);
        }
        return M;
      };
      c.fastpaths = (p, P) => {
        const g = { ...P }, y = typeof g.maxLength == "number" ? Math.min(v, g.maxLength) : v, S = p.length;
        if (S > y)
          throw new SyntaxError(`Input length: ${S}, exceeds maximum allowed length: ${y}`);
        p = l[p] || p;
        const { DOT_LITERAL: R, SLASH_LITERAL: _, ONE_CHAR: b, DOTS_SLASH: A, NO_DOT: w, NO_DOTS: j, NO_DOTS_SLASH: B, STAR: X, START_ANCHOR: O } = a.globChars(g.windows), N = g.dot ? j : w, L = g.dot ? B : w, z = g.capture ? "" : "?:", $ = { negated: !1, prefix: "" };
        let U = g.bash === !0 ? ".*?" : X;
        g.capture && (U = `(${U})`);
        const K = (ce) => ce.noglobstar === !0 ? U : `(${z}(?:(?!${O}${ce.dot ? A : R}).)*?)`, Z = (ce) => {
          switch (ce) {
            case "*":
              return `${N}${b}${U}`;
            case ".*":
              return `${R}${b}${U}`;
            case "*.*":
              return `${N}${U}${R}${b}${U}`;
            case "*/*":
              return `${N}${U}${_}${b}${L}${U}`;
            case "**":
              return N + K(g);
            case "**/*":
              return `(?:${N}${K(g)}${_})?${L}${b}${U}`;
            case "**/*.*":
              return `(?:${N}${K(g)}${_})?${L}${U}${R}${b}${U}`;
            case "**/.*":
              return `(?:${N}${K(g)}${_})?${R}${b}${U}`;
            default: {
              const ae = /^(.*?)\.(\w+)$/.exec(ce);
              if (!ae)
                return;
              const pe = Z(ae[1]);
              return pe ? pe + R + ae[2] : void 0;
            }
          }
        }, se = d.removePrefix(p, $);
        let ee = Z(se);
        return ee && g.strictSlashes !== !0 && (ee += `${_}?`), ee;
      }, o.exports = c;
    }, 510: (o, t, r) => {
      const a = r(716), d = r(697), v = r(96), E = r(154), h = (l) => l && typeof l == "object" && !Array.isArray(l), m = (l, f, u = !1) => {
        if (Array.isArray(l)) {
          const _ = l.map((A) => m(A, f, u));
          return (A) => {
            for (const w of _) {
              const j = w(A);
              if (j)
                return j;
            }
            return !1;
          };
        }
        const c = h(l) && l.tokens && l.input;
        if (l === "" || typeof l != "string" && !c)
          throw new TypeError("Expected pattern to be a non-empty string");
        const p = f || {}, P = p.windows, g = c ? m.compileRe(l, f) : m.makeRe(l, f, !1, !0), y = g.state;
        delete g.state;
        let S = () => !1;
        if (p.ignore) {
          const _ = { ...f, ignore: null, onMatch: null, onResult: null };
          S = m(p.ignore, _, u);
        }
        const R = (_, b = !1) => {
          const { isMatch: A, match: w, output: j } = m.test(_, g, f, { glob: l, posix: P }), B = { glob: l, state: y, regex: g, posix: P, input: _, output: j, match: w, isMatch: A };
          return typeof p.onResult == "function" && p.onResult(B), A === !1 ? (B.isMatch = !1, b ? B : !1) : S(_) ? (typeof p.onIgnore == "function" && p.onIgnore(B), B.isMatch = !1, b ? B : !1) : (typeof p.onMatch == "function" && p.onMatch(B), b ? B : !0);
        };
        return u && (R.state = y), R;
      };
      m.test = (l, f, u, { glob: c, posix: p } = {}) => {
        if (typeof l != "string")
          throw new TypeError("Expected input to be a string");
        if (l === "")
          return { isMatch: !1, output: "" };
        const P = u || {}, g = P.format || (p ? v.toPosixSlashes : null);
        let y = l === c, S = y && g ? g(l) : l;
        return y === !1 && (S = g ? g(l) : l, y = S === c), (y === !1 || P.capture === !0) && (P.matchBase === !0 || P.basename === !0 ? y = m.matchBase(l, f, u, p) : y = f.exec(S)), { isMatch: !!y, match: y, output: S };
      }, m.matchBase = (l, f, u) => (f instanceof RegExp ? f : m.makeRe(f, u)).test(v.basename(l)), m.isMatch = (l, f, u) => m(f, u)(l), m.parse = (l, f) => Array.isArray(l) ? l.map((u) => m.parse(u, f)) : d(l, { ...f, fastpaths: !1 }), m.scan = (l, f) => a(l, f), m.compileRe = (l, f, u = !1, c = !1) => {
        if (u === !0)
          return l.output;
        const p = f || {}, P = p.contains ? "" : "^", g = p.contains ? "" : "$";
        let y = `${P}(?:${l.output})${g}`;
        l && l.negated === !0 && (y = `^(?!${y}).*$`);
        const S = m.toRegex(y, f);
        return c === !0 && (S.state = l), S;
      }, m.makeRe = (l, f = {}, u = !1, c = !1) => {
        if (!l || typeof l != "string")
          throw new TypeError("Expected a non-empty string");
        let p = { negated: !1, fastpaths: !0 };
        return f.fastpaths !== !1 && (l[0] === "." || l[0] === "*") && (p.output = d.fastpaths(l, f)), p.output || (p = d(l, f)), m.compileRe(p, f, u, c);
      }, m.toRegex = (l, f) => {
        try {
          const u = f || {};
          return new RegExp(l, u.flags || (u.nocase ? "i" : ""));
        } catch (u) {
          if (f && f.debug === !0)
            throw u;
          return /$^/;
        }
      }, m.constants = E, o.exports = m;
    }, 716: (o, t, r) => {
      const a = r(96), { CHAR_ASTERISK: d, CHAR_AT: v, CHAR_BACKWARD_SLASH: E, CHAR_COMMA: h, CHAR_DOT: m, CHAR_EXCLAMATION_MARK: l, CHAR_FORWARD_SLASH: f, CHAR_LEFT_CURLY_BRACE: u, CHAR_LEFT_PARENTHESES: c, CHAR_LEFT_SQUARE_BRACKET: p, CHAR_PLUS: P, CHAR_QUESTION_MARK: g, CHAR_RIGHT_CURLY_BRACE: y, CHAR_RIGHT_PARENTHESES: S, CHAR_RIGHT_SQUARE_BRACKET: R } = r(154), _ = (w) => w === f || w === E, b = (w) => {
        w.isPrefix !== !0 && (w.depth = w.isGlobstar ? 1 / 0 : 1);
      }, A = (w, j) => {
        const B = j || {}, X = w.length - 1, O = B.parts === !0 || B.scanToEnd === !0, N = [], L = [], z = [];
        let $ = w, U = -1, K = 0, Z = 0, se = !1, ee = !1, ce = !1, ae = !1, pe = !1, M = !1, le = !1, me = !1, he = !1, T = !1, x = 0, Re, q, W = { value: "", depth: 0, isGlob: !1 };
        const H = () => U >= X, D = () => $.charCodeAt(U + 1), C = () => (Re = q, $.charCodeAt(++U));
        for (; U < X; ) {
          q = C();
          let ne;
          if (q === E) {
            le = W.backslashes = !0, q = C(), q === u && (M = !0);
            continue;
          }
          if (M === !0 || q === u) {
            for (x++; H() !== !0 && (q = C()); ) {
              if (q === E) {
                le = W.backslashes = !0, C();
                continue;
              }
              if (q === u) {
                x++;
                continue;
              }
              if (M !== !0 && q === m && (q = C()) === m) {
                if (se = W.isBrace = !0, ce = W.isGlob = !0, T = !0, O === !0)
                  continue;
                break;
              }
              if (M !== !0 && q === h) {
                if (se = W.isBrace = !0, ce = W.isGlob = !0, T = !0, O === !0)
                  continue;
                break;
              }
              if (q === y && (x--, x === 0)) {
                M = !1, se = W.isBrace = !0, T = !0;
                break;
              }
            }
            if (O === !0)
              continue;
            break;
          }
          if (q === f) {
            if (N.push(U), L.push(W), W = { value: "", depth: 0, isGlob: !1 }, T === !0)
              continue;
            if (Re === m && U === K + 1) {
              K += 2;
              continue;
            }
            Z = U + 1;
            continue;
          }
          if (B.noext !== !0 && (q === P || q === v || q === d || q === g || q === l) === !0 && D() === c) {
            if (ce = W.isGlob = !0, ae = W.isExtglob = !0, T = !0, q === l && U === K && (he = !0), O === !0) {
              for (; H() !== !0 && (q = C()); ) {
                if (q === E) {
                  le = W.backslashes = !0, q = C();
                  continue;
                }
                if (q === S) {
                  ce = W.isGlob = !0, T = !0;
                  break;
                }
              }
              continue;
            }
            break;
          }
          if (q === d) {
            if (Re === d && (pe = W.isGlobstar = !0), ce = W.isGlob = !0, T = !0, O === !0)
              continue;
            break;
          }
          if (q === g) {
            if (ce = W.isGlob = !0, T = !0, O === !0)
              continue;
            break;
          }
          if (q === p) {
            for (; H() !== !0 && (ne = C()); ) {
              if (ne === E) {
                le = W.backslashes = !0, C();
                continue;
              }
              if (ne === R) {
                ee = W.isBracket = !0, ce = W.isGlob = !0, T = !0;
                break;
              }
            }
            if (O === !0)
              continue;
            break;
          }
          if (B.nonegate !== !0 && q === l && U === K) {
            me = W.negated = !0, K++;
            continue;
          }
          if (B.noparen !== !0 && q === c) {
            if (ce = W.isGlob = !0, O === !0) {
              for (; H() !== !0 && (q = C()); ) {
                if (q === c) {
                  le = W.backslashes = !0, q = C();
                  continue;
                }
                if (q === S) {
                  T = !0;
                  break;
                }
              }
              continue;
            }
            break;
          }
          if (ce === !0) {
            if (T = !0, O === !0)
              continue;
            break;
          }
        }
        B.noext === !0 && (ae = !1, ce = !1);
        let F = $, ue = "", oe = "";
        K > 0 && (ue = $.slice(0, K), $ = $.slice(K), Z -= K), F && ce === !0 && Z > 0 ? (F = $.slice(0, Z), oe = $.slice(Z)) : ce === !0 ? (F = "", oe = $) : F = $, F && F !== "" && F !== "/" && F !== $ && _(F.charCodeAt(F.length - 1)) && (F = F.slice(0, -1)), B.unescape === !0 && (oe && (oe = a.removeBackslashes(oe)), F && le === !0 && (F = a.removeBackslashes(F)));
        const k = { prefix: ue, input: w, start: K, base: F, glob: oe, isBrace: se, isBracket: ee, isGlob: ce, isExtglob: ae, isGlobstar: pe, negated: me, negatedExtglob: he };
        if (B.tokens === !0 && (k.maxDepth = 0, _(q) || L.push(W), k.tokens = L), B.parts === !0 || B.tokens === !0) {
          let ne;
          for (let J = 0; J < N.length; J++) {
            const G = ne ? ne + 1 : K, Y = N[J], I = w.slice(G, Y);
            B.tokens && (J === 0 && K !== 0 ? (L[J].isPrefix = !0, L[J].value = ue) : L[J].value = I, b(L[J]), k.maxDepth += L[J].depth), (J !== 0 || I !== "") && z.push(I), ne = Y;
          }
          if (ne && ne + 1 < w.length) {
            const J = w.slice(ne + 1);
            z.push(J), B.tokens && (L[L.length - 1].value = J, b(L[L.length - 1]), k.maxDepth += L[L.length - 1].depth);
          }
          k.slashes = N, k.parts = z;
        }
        return k;
      };
      o.exports = A;
    }, 96: (o, t, r) => {
      const { REGEX_BACKSLASH: a, REGEX_REMOVE_BACKSLASH: d, REGEX_SPECIAL_CHARS: v, REGEX_SPECIAL_CHARS_GLOBAL: E } = r(154);
      t.isObject = (h) => h !== null && typeof h == "object" && !Array.isArray(h), t.hasRegexChars = (h) => v.test(h), t.isRegexChar = (h) => h.length === 1 && t.hasRegexChars(h), t.escapeRegex = (h) => h.replace(E, "\\$1"), t.toPosixSlashes = (h) => h.replace(a, "/"), t.removeBackslashes = (h) => h.replace(d, (m) => m === "\\" ? "" : m), t.escapeLast = (h, m, l) => {
        const f = h.lastIndexOf(m, l);
        return f === -1 ? h : h[f - 1] === "\\" ? t.escapeLast(h, m, f - 1) : `${h.slice(0, f)}\\${h.slice(f)}`;
      }, t.removePrefix = (h, m = {}) => {
        let l = h;
        return l.startsWith("./") && (l = l.slice(2), m.prefix = "./"), l;
      }, t.wrapOutput = (h, m = {}, l = {}) => {
        const f = l.contains ? "" : "^", u = l.contains ? "" : "$";
        let c = `${f}(?:${h})${u}`;
        return m.negated === !0 && (c = `(?:^(?!${c}).*$)`), c;
      }, t.basename = (h, { windows: m } = {}) => {
        const l = h.split(m ? /[\\/]/ : "/"), f = l[l.length - 1];
        return f === "" ? l[l.length - 2] : f;
      };
    } }, e = {};
    function s(o) {
      var t = e[o];
      if (t !== void 0)
        return t.exports;
      var r = e[o] = { exports: {} }, a = !0;
      try {
        n[o](r, r.exports, s), a = !1;
      } finally {
        a && delete e[o];
      }
      return r.exports;
    }
    typeof s < "u" && (s.ab = __dirname + "/");
    var i = s(170);
    Wt.exports = i;
  })()), Wt.exports;
}
var In;
function Vi() {
  return In || (In = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(t, r) {
      for (var a in r)
        Object.defineProperty(t, a, {
          enumerable: !0,
          get: r[a]
        });
    }
    e(n, {
      hasLocalMatch: function() {
        return o;
      },
      matchLocalPattern: function() {
        return i;
      }
    });
    const s = da();
    function i(t, r) {
      if (t.search !== void 0 && t.search !== r.search)
        return !1;
      var a;
      return !!(0, s.makeRe)((a = t.pathname) != null ? a : "**", {
        dot: !0
      }).test(r.pathname);
    }
    function o(t, r) {
      if (!t)
        return !0;
      const a = new URL(r, "http://n");
      return t.some((d) => i(d, a));
    }
  }(Gt)), Gt;
}
var Vt = {}, jn;
function Xi() {
  return jn || (jn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(t, r) {
      for (var a in r)
        Object.defineProperty(t, a, {
          enumerable: !0,
          get: r[a]
        });
    }
    e(n, {
      hasRemoteMatch: function() {
        return o;
      },
      matchRemotePattern: function() {
        return i;
      }
    });
    const s = da();
    function i(t, r) {
      if (t.protocol !== void 0) {
        const d = r.protocol.slice(0, -1);
        if (t.protocol !== d)
          return !1;
      }
      if (t.port !== void 0 && t.port !== r.port)
        return !1;
      if (t.hostname === void 0)
        throw new Error(`Pattern should define hostname but found
` + JSON.stringify(t));
      if (!(0, s.makeRe)(t.hostname).test(r.hostname) || t.search !== void 0 && t.search !== r.search)
        return !1;
      var a;
      return !!(0, s.makeRe)((a = t.pathname) != null ? a : "**", {
        dot: !0
      }).test(r.pathname);
    }
    function o(t, r, a) {
      return t.some((d) => a.hostname === d) || r.some((d) => i(d, a));
    }
  }(Vt)), Vt;
}
var Dn;
function pa() {
  return Dn || (Dn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "default", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = 75;
    function s(o) {
      let { config: t, src: r, width: a, quality: d } = o;
      var v;
      if (process.env.NODE_ENV !== "production") {
        const h = [];
        if (r || h.push("src"), a || h.push("width"), h.length > 0)
          throw new Error("Next Image Optimization requires " + h.join(", ") + " to be provided. Make sure you pass them as props to the `next/image` component. Received: " + JSON.stringify({
            src: r,
            width: a,
            quality: d
          }));
        if (r.startsWith("//"))
          throw new Error('Failed to parse src "' + r + '" on `next/image`, protocol-relative URL (//) must be changed to an absolute URL (http:// or https://)');
        if (r.startsWith("/") && t.localPatterns && process.env.NODE_ENV !== "test" && // micromatch isn't compatible with edge runtime
        process.env.NEXT_RUNTIME !== "edge") {
          const { hasLocalMatch: m } = Vi();
          if (!m(t.localPatterns, r))
            throw new Error("Invalid src prop (" + r + ") on `next/image` does not match `images.localPatterns` configured in your `next.config.js`\nSee more info: https://nextjs.org/docs/messages/next-image-unconfigured-localpatterns");
        }
        if (!r.startsWith("/") && (t.domains || t.remotePatterns)) {
          let m;
          try {
            m = new URL(r);
          } catch (l) {
            throw console.error(l), new Error('Failed to parse src "' + r + '" on `next/image`, if using relative image it must start with a leading slash "/" or be an absolute URL (http:// or https://)');
          }
          if (process.env.NODE_ENV !== "test" && // micromatch isn't compatible with edge runtime
          process.env.NEXT_RUNTIME !== "edge") {
            const { hasRemoteMatch: l } = Xi();
            if (!l(t.domains, t.remotePatterns, m))
              throw new Error("Invalid src prop (" + r + ') on `next/image`, hostname "' + m.hostname + '" is not configured under images in your `next.config.js`\nSee more info: https://nextjs.org/docs/messages/next-image-unconfigured-host');
          }
        }
        if (d && t.qualities && !t.qualities.includes(d))
          throw new Error("Invalid quality prop (" + d + ") on `next/image` does not match `images.qualities` configured in your `next.config.js`\nSee more info: https://nextjs.org/docs/messages/next-image-unconfigured-qualities");
      }
      const E = d || ((v = t.qualities) == null ? void 0 : v.reduce((h, m) => Math.abs(m - e) < Math.abs(h - e) ? m : h)) || e;
      return t.path + "?url=" + encodeURIComponent(r) + "&w=" + a + "&q=" + E + (process.env.NEXT_DEPLOYMENT_ID ? "&dpl=" + process.env.NEXT_DEPLOYMENT_ID : "");
    }
    s.__next_img_default = !0;
    const i = s;
  }(zt)), zt;
}
(function(n, e) {
  "use client";
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "Image", {
    enumerable: !0,
    get: function() {
      return g;
    }
  });
  const s = Te, i = Be, o = tt, t = /* @__PURE__ */ i._(xe), r = /* @__PURE__ */ s._(ia), a = /* @__PURE__ */ s._(Gi()), d = on, v = Lt, E = Wi(), h = xt, m = an(), l = /* @__PURE__ */ s._(pa()), f = process.env.__NEXT_IMAGE_OPTS;
  typeof window > "u" && (globalThis.__NEXT_IMAGE_IMPORTED = !0);
  function u(y, S, R, _, b, A, w) {
    const j = y == null ? void 0 : y.src;
    if (!y || y["data-loaded-src"] === j)
      return;
    y["data-loaded-src"] = j, ("decode" in y ? y.decode() : Promise.resolve()).catch(() => {
    }).then(() => {
      if (!(!y.parentElement || !y.isConnected)) {
        if (S !== "empty" && b(!0), R != null && R.current) {
          const X = new Event("load");
          Object.defineProperty(X, "target", {
            writable: !1,
            value: y
          });
          let O = !1, N = !1;
          R.current({
            ...X,
            nativeEvent: X,
            currentTarget: y,
            target: y,
            isDefaultPrevented: () => O,
            isPropagationStopped: () => N,
            persist: () => {
            },
            preventDefault: () => {
              O = !0, X.preventDefault();
            },
            stopPropagation: () => {
              N = !0, X.stopPropagation();
            }
          });
        }
        if (_ != null && _.current && _.current(y), process.env.NODE_ENV !== "production") {
          const X = new URL(j, "http://n").searchParams.get("url") || j;
          if (y.getAttribute("data-nimg") === "fill") {
            if (!A && (!w || w === "100vw") && y.getBoundingClientRect().width / window.innerWidth < 0.6 && (w === "100vw" ? (0, h.warnOnce)('Image with src "' + X + '" has "fill" prop and "sizes" prop of "100vw", but image is not rendered at full viewport width. Please adjust "sizes" to improve page performance. Read more: https://nextjs.org/docs/api-reference/next/image#sizes') : (0, h.warnOnce)('Image with src "' + X + '" has "fill" but is missing "sizes" prop. Please add it to improve page performance. Read more: https://nextjs.org/docs/api-reference/next/image#sizes')), y.parentElement) {
              const { position: L } = window.getComputedStyle(y.parentElement), z = [
                "absolute",
                "fixed",
                "relative"
              ];
              z.includes(L) || (0, h.warnOnce)('Image with src "' + X + '" has "fill" and parent element with invalid "position". Provided "' + L + '" should be one of ' + z.map(String).join(",") + ".");
            }
            y.height === 0 && (0, h.warnOnce)('Image with src "' + X + '" has "fill" and a height value of 0. This is likely because the parent element of the image has not been styled to have a set height.');
          }
          const O = y.height.toString() !== y.getAttribute("height"), N = y.width.toString() !== y.getAttribute("width");
          (O && !N || !O && N) && (0, h.warnOnce)('Image with src "' + X + `" has either width or height modified, but not the other. If you use CSS to change the size of your image, also include the styles 'width: "auto"' or 'height: "auto"' to maintain the aspect ratio.`);
        }
      }
    });
  }
  function c(y) {
    return t.use ? {
      fetchPriority: y
    } : {
      fetchpriority: y
    };
  }
  const p = /* @__PURE__ */ (0, t.forwardRef)((y, S) => {
    let { src: R, srcSet: _, sizes: b, height: A, width: w, decoding: j, className: B, style: X, fetchPriority: O, placeholder: N, loading: L, unoptimized: z, fill: $, onLoadRef: U, onLoadingCompleteRef: K, setBlurComplete: Z, setShowAltText: se, sizesInput: ee, onLoad: ce, onError: ae, ...pe } = y;
    return /* @__PURE__ */ (0, o.jsx)("img", {
      ...pe,
      ...c(O),
      // It's intended to keep `loading` before `src` because React updates
      // props in order which causes Safari/Firefox to not lazy load properly.
      // See https://github.com/facebook/react/issues/25883
      loading: L,
      width: w,
      height: A,
      decoding: j,
      "data-nimg": $ ? "fill" : "1",
      className: B,
      style: X,
      // It's intended to keep `src` the last attribute because React updates
      // attributes in order. If we keep `src` the first one, Safari will
      // immediately start to fetch `src`, before `sizes` and `srcSet` are even
      // updated by React. That causes multiple unnecessary requests if `srcSet`
      // and `sizes` are defined.
      // This bug cannot be reproduced in Chrome or Firefox.
      sizes: b,
      srcSet: _,
      src: R,
      ref: (0, t.useCallback)((M) => {
        S && (typeof S == "function" ? S(M) : typeof S == "object" && (S.current = M)), M && (ae && (M.src = M.src), process.env.NODE_ENV !== "production" && (R || console.error('Image is missing required "src" property:', M), M.getAttribute("alt") === null && console.error('Image is missing required "alt" property. Please add Alternative Text to describe the image for screen readers and search engines.')), M.complete && u(M, N, U, K, Z, z, ee));
      }, [
        R,
        N,
        U,
        K,
        Z,
        ae,
        z,
        ee,
        S
      ]),
      onLoad: (M) => {
        const le = M.currentTarget;
        u(le, N, U, K, Z, z, ee);
      },
      onError: (M) => {
        se(!0), N !== "empty" && Z(!0), ae && ae(M);
      }
    });
  });
  function P(y) {
    let { isAppRouter: S, imgAttributes: R } = y;
    const _ = {
      as: "image",
      imageSrcSet: R.srcSet,
      imageSizes: R.sizes,
      crossOrigin: R.crossOrigin,
      referrerPolicy: R.referrerPolicy,
      ...c(R.fetchPriority)
    };
    return S && r.default.preload ? (r.default.preload(
      R.src,
      // @ts-expect-error TODO: upgrade to `@types/react-dom@18.3.x`
      _
    ), null) : /* @__PURE__ */ (0, o.jsx)(a.default, {
      children: /* @__PURE__ */ (0, o.jsx)("link", {
        rel: "preload",
        // Note how we omit the `href` attribute, as it would only be relevant
        // for browsers that do not support `imagesrcset`, and in those cases
        // it would cause the incorrect image to be preloaded.
        //
        // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
        href: R.srcSet ? void 0 : R.src,
        ..._
      }, "__nimg-" + R.src + R.srcSet + R.sizes)
    });
  }
  const g = /* @__PURE__ */ (0, t.forwardRef)((y, S) => {
    const _ = !(0, t.useContext)(m.RouterContext), b = (0, t.useContext)(E.ImageConfigContext), A = (0, t.useMemo)(() => {
      var K;
      const Z = f || b || v.imageConfigDefault, se = [
        ...Z.deviceSizes,
        ...Z.imageSizes
      ].sort((ae, pe) => ae - pe), ee = Z.deviceSizes.sort((ae, pe) => ae - pe), ce = (K = Z.qualities) == null ? void 0 : K.sort((ae, pe) => ae - pe);
      return {
        ...Z,
        allSizes: se,
        deviceSizes: ee,
        qualities: ce
      };
    }, [
      b
    ]), { onLoad: w, onLoadingComplete: j } = y, B = (0, t.useRef)(w);
    (0, t.useEffect)(() => {
      B.current = w;
    }, [
      w
    ]);
    const X = (0, t.useRef)(j);
    (0, t.useEffect)(() => {
      X.current = j;
    }, [
      j
    ]);
    const [O, N] = (0, t.useState)(!1), [L, z] = (0, t.useState)(!1), { props: $, meta: U } = (0, d.getImgProps)(y, {
      defaultLoader: l.default,
      imgConf: A,
      blurComplete: O,
      showAltText: L
    });
    return /* @__PURE__ */ (0, o.jsxs)(o.Fragment, {
      children: [
        /* @__PURE__ */ (0, o.jsx)(p, {
          ...$,
          unoptimized: U.unoptimized,
          placeholder: U.placeholder,
          fill: U.fill,
          onLoadRef: B,
          onLoadingCompleteRef: X,
          setBlurComplete: N,
          setShowAltText: z,
          sizesInput: y.sizes,
          ref: S
        }),
        U.priority ? /* @__PURE__ */ (0, o.jsx)(P, {
          isAppRouter: _,
          imgAttributes: $
        }) : null
      ]
    });
  });
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(Fr, Fr.exports);
var Ki = Fr.exports;
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  function e(d, v) {
    for (var E in v)
      Object.defineProperty(d, E, {
        enumerable: !0,
        get: v[E]
      });
  }
  e(n, {
    default: function() {
      return a;
    },
    getImageProps: function() {
      return r;
    }
  });
  const s = Te, i = on, o = Ki, t = /* @__PURE__ */ s._(pa());
  function r(d) {
    const { props: v } = (0, i.getImgProps)(d, {
      defaultLoader: t.default,
      // This is replaced by webpack define plugin
      imgConf: process.env.__NEXT_IMAGE_OPTS
    });
    for (const [E, h] of Object.entries(v))
      h === void 0 && delete v[E];
    return {
      props: v
    };
  }
  const a = o.Image;
})(ua);
var Yi = ua;
const Qi = /* @__PURE__ */ rt(Yi);
var zr = { exports: {} }, it = { exports: {} }, Xt = {}, qn;
function Mt() {
  return qn || (qn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(r, a) {
      for (var d in a)
        Object.defineProperty(r, d, {
          enumerable: !0,
          get: a[d]
        });
    }
    e(n, {
      assign: function() {
        return t;
      },
      searchParamsToUrlQuery: function() {
        return s;
      },
      urlQueryToSearchParams: function() {
        return o;
      }
    });
    function s(r) {
      const a = {};
      return r.forEach((d, v) => {
        typeof a[v] > "u" ? a[v] = d : Array.isArray(a[v]) ? a[v].push(d) : a[v] = [
          a[v],
          d
        ];
      }), a;
    }
    function i(r) {
      return typeof r == "string" || typeof r == "number" && !isNaN(r) || typeof r == "boolean" ? String(r) : "";
    }
    function o(r) {
      const a = new URLSearchParams();
      return Object.entries(r).forEach((d) => {
        let [v, E] = d;
        Array.isArray(E) ? E.forEach((h) => a.append(v, i(h))) : a.set(v, i(E));
      }), a;
    }
    function t(r) {
      for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), v = 1; v < a; v++)
        d[v - 1] = arguments[v];
      return d.forEach((E) => {
        Array.from(E.keys()).forEach((h) => r.delete(h)), E.forEach((h, m) => r.append(m, h));
      }), r;
    }
  }(Xt)), Xt;
}
var Kt = {}, Hn;
function sn() {
  return Hn || (Hn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(d, v) {
      for (var E in v)
        Object.defineProperty(d, E, {
          enumerable: !0,
          get: v[E]
        });
    }
    e(n, {
      formatUrl: function() {
        return t;
      },
      formatWithValidation: function() {
        return a;
      },
      urlObjectKeys: function() {
        return r;
      }
    });
    const i = /* @__PURE__ */ Be._(Mt()), o = /https?|ftp|gopher|file/;
    function t(d) {
      let { auth: v, hostname: E } = d, h = d.protocol || "", m = d.pathname || "", l = d.hash || "", f = d.query || "", u = !1;
      v = v ? encodeURIComponent(v).replace(/%3A/i, ":") + "@" : "", d.host ? u = v + d.host : E && (u = v + (~E.indexOf(":") ? "[" + E + "]" : E), d.port && (u += ":" + d.port)), f && typeof f == "object" && (f = String(i.urlQueryToSearchParams(f)));
      let c = d.search || f && "?" + f || "";
      return h && !h.endsWith(":") && (h += ":"), d.slashes || (!h || o.test(h)) && u !== !1 ? (u = "//" + (u || ""), m && m[0] !== "/" && (m = "/" + m)) : u || (u = ""), l && l[0] !== "#" && (l = "#" + l), c && c[0] !== "?" && (c = "?" + c), m = m.replace(/[?#]/g, encodeURIComponent), c = c.replace("#", "%23"), "" + h + u + m + c + l;
    }
    const r = [
      "auth",
      "hash",
      "host",
      "hostname",
      "href",
      "path",
      "pathname",
      "port",
      "protocol",
      "query",
      "search",
      "slashes"
    ];
    function a(d) {
      return process.env.NODE_ENV === "development" && d !== null && typeof d == "object" && Object.keys(d).forEach((v) => {
        r.includes(v) || console.warn("Unknown key passed via urlObject into url.format: " + v);
      }), t(d);
    }
  }(Kt)), Kt;
}
var Yt = {}, $n;
function ha() {
  return $n || ($n = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "omit", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s, i) {
      const o = {};
      return Object.keys(s).forEach((t) => {
        i.includes(t) || (o[t] = s[t]);
      }), o;
    }
  }(Yt)), Yt;
}
var Qt = {}, kn;
function Ke() {
  return kn || (kn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(y, S) {
      for (var R in S)
        Object.defineProperty(y, R, {
          enumerable: !0,
          get: S[R]
        });
    }
    e(n, {
      DecodeError: function() {
        return f;
      },
      MiddlewareNotFoundError: function() {
        return P;
      },
      MissingStaticPage: function() {
        return p;
      },
      NormalizeError: function() {
        return u;
      },
      PageNotFoundError: function() {
        return c;
      },
      SP: function() {
        return m;
      },
      ST: function() {
        return l;
      },
      WEB_VITALS: function() {
        return s;
      },
      execOnce: function() {
        return i;
      },
      getDisplayName: function() {
        return d;
      },
      getLocationOrigin: function() {
        return r;
      },
      getURL: function() {
        return a;
      },
      isAbsoluteUrl: function() {
        return t;
      },
      isResSent: function() {
        return v;
      },
      loadGetInitialProps: function() {
        return h;
      },
      normalizeRepeatedSlashes: function() {
        return E;
      },
      stringifyError: function() {
        return g;
      }
    });
    const s = [
      "CLS",
      "FCP",
      "FID",
      "INP",
      "LCP",
      "TTFB"
    ];
    function i(y) {
      let S = !1, R;
      return function() {
        for (var _ = arguments.length, b = new Array(_), A = 0; A < _; A++)
          b[A] = arguments[A];
        return S || (S = !0, R = y(...b)), R;
      };
    }
    const o = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/, t = (y) => o.test(y);
    function r() {
      const { protocol: y, hostname: S, port: R } = window.location;
      return y + "//" + S + (R ? ":" + R : "");
    }
    function a() {
      const { href: y } = window.location, S = r();
      return y.substring(S.length);
    }
    function d(y) {
      return typeof y == "string" ? y : y.displayName || y.name || "Unknown";
    }
    function v(y) {
      return y.finished || y.headersSent;
    }
    function E(y) {
      const S = y.split("?");
      return S[0].replace(/\\/g, "/").replace(/\/\/+/g, "/") + (S[1] ? "?" + S.slice(1).join("?") : "");
    }
    async function h(y, S) {
      if (process.env.NODE_ENV !== "production") {
        var R;
        if ((R = y.prototype) != null && R.getInitialProps) {
          const A = '"' + d(y) + '.getInitialProps()" is defined as an instance method - visit https://nextjs.org/docs/messages/get-initial-props-as-an-instance-method for more information.';
          throw new Error(A);
        }
      }
      const _ = S.res || S.ctx && S.ctx.res;
      if (!y.getInitialProps)
        return S.ctx && S.Component ? {
          pageProps: await h(S.Component, S.ctx)
        } : {};
      const b = await y.getInitialProps(S);
      if (_ && v(_))
        return b;
      if (!b) {
        const A = '"' + d(y) + '.getInitialProps()" should resolve to an object. But found "' + b + '" instead.';
        throw new Error(A);
      }
      return process.env.NODE_ENV !== "production" && Object.keys(b).length === 0 && !S.ctx && console.warn("" + d(y) + " returned an empty object from `getInitialProps`. This de-optimizes and prevents automatic static optimization. https://nextjs.org/docs/messages/empty-object-getInitialProps"), b;
    }
    const m = typeof performance < "u", l = m && [
      "mark",
      "measure",
      "getEntriesByName"
    ].every((y) => typeof performance[y] == "function");
    class f extends Error {
    }
    class u extends Error {
    }
    class c extends Error {
      constructor(S) {
        super(), this.code = "ENOENT", this.name = "PageNotFoundError", this.message = "Cannot find module for page: " + S;
      }
    }
    class p extends Error {
      constructor(S, R) {
        super(), this.message = "Failed to load static file for page: " + S + " " + R;
      }
    }
    class P extends Error {
      constructor() {
        super(), this.code = "ENOENT", this.message = "Cannot find the middleware module";
      }
    }
    function g(y) {
      return JSON.stringify({
        message: y.message,
        stack: y.stack
      });
    }
  }(Qt)), Qt;
}
var st = { exports: {} }, Jt = {}, Un;
function nt() {
  return Un || (Un = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "removeTrailingSlash", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s) {
      return s.replace(/\/$/, "") || "/";
    }
  }(Jt)), Jt;
}
var Zt = {}, Bn;
function Ye() {
  return Bn || (Bn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "parsePath", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s) {
      const i = s.indexOf("#"), o = s.indexOf("?"), t = o > -1 && (i < 0 || o < i);
      return t || i > -1 ? {
        pathname: s.substring(0, t ? o : i),
        query: t ? s.substring(o, i > -1 ? i : void 0) : "",
        hash: i > -1 ? s.slice(i) : ""
      } : {
        pathname: s,
        query: "",
        hash: ""
      };
    }
  }(Zt)), Zt;
}
var Fn;
function Nt() {
  return Fn || (Fn = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "normalizePathTrailingSlash", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const s = nt(), i = Ye(), o = (t) => {
      if (!t.startsWith("/") || process.env.__NEXT_MANUAL_TRAILING_SLASH)
        return t;
      const { pathname: r, query: a, hash: d } = (0, i.parsePath)(t);
      return process.env.__NEXT_TRAILING_SLASH ? /\.[^/]+\/?$/.test(r) ? "" + (0, s.removeTrailingSlash)(r) + a + d : r.endsWith("/") ? "" + r + a + d : r + "/" + a + d : "" + (0, s.removeTrailingSlash)(r) + a + d;
    };
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(st, st.exports)), st.exports;
}
var er = {}, ut = { exports: {} }, tr = {}, zn;
function It() {
  return zn || (zn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "pathHasPrefix", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const e = Ye();
    function s(i, o) {
      if (typeof i != "string")
        return !1;
      const { pathname: t } = (0, e.parsePath)(i);
      return t === o || t.startsWith(o + "/");
    }
  }(tr)), tr;
}
var Gn;
function un() {
  return Gn || (Gn = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "hasBasePath", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const s = It(), i = process.env.__NEXT_ROUTER_BASEPATH || "";
    function o(t) {
      return (0, s.pathHasPrefix)(t, i);
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(ut, ut.exports)), ut.exports;
}
var Wn;
function cn() {
  return Wn || (Wn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "isLocalURL", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = Ke(), s = un();
    function i(o) {
      if (!(0, e.isAbsoluteUrl)(o))
        return !0;
      try {
        const t = (0, e.getLocationOrigin)(), r = new URL(o, t);
        return r.origin === t && (0, s.hasBasePath)(r.pathname);
      } catch {
        return !1;
      }
    }
  }(er)), er;
}
var rr = {}, nr = {}, Vn;
function Ji() {
  return Vn || (Vn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "getSortedRoutes", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    class e {
      insert(o) {
        this._insert(o.split("/").filter(Boolean), [], !1);
      }
      smoosh() {
        return this._smoosh();
      }
      _smoosh(o) {
        o === void 0 && (o = "/");
        const t = [
          ...this.children.keys()
        ].sort();
        this.slugName !== null && t.splice(t.indexOf("[]"), 1), this.restSlugName !== null && t.splice(t.indexOf("[...]"), 1), this.optionalRestSlugName !== null && t.splice(t.indexOf("[[...]]"), 1);
        const r = t.map((a) => this.children.get(a)._smoosh("" + o + a + "/")).reduce((a, d) => [
          ...a,
          ...d
        ], []);
        if (this.slugName !== null && r.push(...this.children.get("[]")._smoosh(o + "[" + this.slugName + "]/")), !this.placeholder) {
          const a = o === "/" ? "/" : o.slice(0, -1);
          if (this.optionalRestSlugName != null)
            throw new Error('You cannot define a route with the same specificity as a optional catch-all route ("' + a + '" and "' + a + "[[..." + this.optionalRestSlugName + ']]").');
          r.unshift(a);
        }
        return this.restSlugName !== null && r.push(...this.children.get("[...]")._smoosh(o + "[..." + this.restSlugName + "]/")), this.optionalRestSlugName !== null && r.push(...this.children.get("[[...]]")._smoosh(o + "[[..." + this.optionalRestSlugName + "]]/")), r;
      }
      _insert(o, t, r) {
        if (o.length === 0) {
          this.placeholder = !1;
          return;
        }
        if (r)
          throw new Error("Catch-all must be the last part of the URL.");
        let a = o[0];
        if (a.startsWith("[") && a.endsWith("]")) {
          let E = function(h, m) {
            if (h !== null && h !== m)
              throw new Error("You cannot use different slug names for the same dynamic path ('" + h + "' !== '" + m + "').");
            t.forEach((l) => {
              if (l === m)
                throw new Error('You cannot have the same slug name "' + m + '" repeat within a single dynamic path');
              if (l.replace(/\W/g, "") === a.replace(/\W/g, ""))
                throw new Error('You cannot have the slug names "' + l + '" and "' + m + '" differ only by non-word symbols within a single dynamic path');
            }), t.push(m);
          }, d = a.slice(1, -1), v = !1;
          if (d.startsWith("[") && d.endsWith("]") && (d = d.slice(1, -1), v = !0), d.startsWith("...") && (d = d.substring(3), r = !0), d.startsWith("[") || d.endsWith("]"))
            throw new Error("Segment names may not start or end with extra brackets ('" + d + "').");
          if (d.startsWith("."))
            throw new Error("Segment names may not start with erroneous periods ('" + d + "').");
          if (r)
            if (v) {
              if (this.restSlugName != null)
                throw new Error('You cannot use both an required and optional catch-all route at the same level ("[...' + this.restSlugName + ']" and "' + o[0] + '" ).');
              E(this.optionalRestSlugName, d), this.optionalRestSlugName = d, a = "[[...]]";
            } else {
              if (this.optionalRestSlugName != null)
                throw new Error('You cannot use both an optional and required catch-all route at the same level ("[[...' + this.optionalRestSlugName + ']]" and "' + o[0] + '").');
              E(this.restSlugName, d), this.restSlugName = d, a = "[...]";
            }
          else {
            if (v)
              throw new Error('Optional route parameters are not yet supported ("' + o[0] + '").');
            E(this.slugName, d), this.slugName = d, a = "[]";
          }
        }
        this.children.has(a) || this.children.set(a, new e()), this.children.get(a)._insert(o.slice(1), t, r);
      }
      constructor() {
        this.placeholder = !0, this.children = /* @__PURE__ */ new Map(), this.slugName = null, this.restSlugName = null, this.optionalRestSlugName = null;
      }
    }
    function s(i) {
      const o = new e();
      return i.forEach((t) => o.insert(t)), o.smoosh();
    }
  }(nr)), nr;
}
var or = {}, ar = {}, ir = {}, sr = {}, Xn;
function Zi() {
  return Xn || (Xn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "ensureLeadingSlash", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s) {
      return s.startsWith("/") ? s : "/" + s;
    }
  }(sr)), sr;
}
var ln = {};
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  function e(t, r) {
    for (var a in r)
      Object.defineProperty(t, a, {
        enumerable: !0,
        get: r[a]
      });
  }
  e(n, {
    DEFAULT_SEGMENT_KEY: function() {
      return o;
    },
    PAGE_SEGMENT_KEY: function() {
      return i;
    },
    isGroupSegment: function() {
      return s;
    }
  });
  function s(t) {
    return t[0] === "(" && t.endsWith(")");
  }
  const i = "__PAGE__", o = "__DEFAULT__";
})(ln);
var Kn;
function es() {
  return Kn || (Kn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(r, a) {
      for (var d in a)
        Object.defineProperty(r, d, {
          enumerable: !0,
          get: a[d]
        });
    }
    e(n, {
      normalizeAppPath: function() {
        return o;
      },
      normalizeRscURL: function() {
        return t;
      }
    });
    const s = Zi(), i = ln;
    function o(r) {
      return (0, s.ensureLeadingSlash)(r.split("/").reduce((a, d, v, E) => !d || (0, i.isGroupSegment)(d) || d[0] === "@" || (d === "page" || d === "route") && v === E.length - 1 ? a : a + "/" + d, ""));
    }
    function t(r) {
      return r.replace(
        /\.rsc($|\?)/,
        // $1 ensures `?` is preserved
        "$1"
      );
    }
  }(ir)), ir;
}
var Yn;
function fn() {
  return Yn || (Yn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(r, a) {
      for (var d in a)
        Object.defineProperty(r, d, {
          enumerable: !0,
          get: a[d]
        });
    }
    e(n, {
      INTERCEPTION_ROUTE_MARKERS: function() {
        return i;
      },
      extractInterceptionRouteInformation: function() {
        return t;
      },
      isInterceptionRouteAppPath: function() {
        return o;
      }
    });
    const s = es(), i = [
      "(..)(..)",
      "(.)",
      "(..)",
      "(...)"
    ];
    function o(r) {
      return r.split("/").find((a) => i.find((d) => a.startsWith(d))) !== void 0;
    }
    function t(r) {
      let a, d, v;
      for (const E of r.split("/"))
        if (d = i.find((h) => E.startsWith(h)), d) {
          [a, v] = r.split(d, 2);
          break;
        }
      if (!a || !d || !v)
        throw new Error(`Invalid interception route: ${r}. Must be in the format /<intercepting route>/(..|...|..)(..)/<intercepted route>`);
      switch (a = (0, s.normalizeAppPath)(a), d) {
        case "(.)":
          a === "/" ? v = `/${v}` : v = a + "/" + v;
          break;
        case "(..)":
          if (a === "/")
            throw new Error(`Invalid interception route: ${r}. Cannot use (..) marker at the root level, use (.) instead.`);
          v = a.split("/").slice(0, -1).concat(v).join("/");
          break;
        case "(...)":
          v = "/" + v;
          break;
        case "(..)(..)":
          const E = a.split("/");
          if (E.length <= 2)
            throw new Error(`Invalid interception route: ${r}. Cannot use (..)(..) marker at the root level or one level up.`);
          v = E.slice(0, -2).concat(v).join("/");
          break;
        default:
          throw new Error("Invariant: unexpected marker");
      }
      return {
        interceptingRoute: a,
        interceptedRoute: v
      };
    }
  }(ar)), ar;
}
var Qn;
function ma() {
  return Qn || (Qn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "isDynamicRoute", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = fn(), s = /\/\[[^/]+?\](?=\/|$)/;
    function i(o) {
      return (0, e.isInterceptionRouteAppPath)(o) && (o = (0, e.extractInterceptionRouteInformation)(o).interceptedRoute), s.test(o);
    }
  }(or)), or;
}
var Jn;
function ga() {
  return Jn || (Jn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(o, t) {
      for (var r in t)
        Object.defineProperty(o, r, {
          enumerable: !0,
          get: t[r]
        });
    }
    e(n, {
      getSortedRoutes: function() {
        return s.getSortedRoutes;
      },
      isDynamicRoute: function() {
        return i.isDynamicRoute;
      }
    });
    const s = Ji(), i = ma();
  }(rr)), rr;
}
var ur = {}, cr = {}, Zn;
function _a() {
  return Zn || (Zn = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "getRouteMatcher", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const e = Ke();
    function s(i) {
      let { re: o, groups: t } = i;
      return (r) => {
        const a = o.exec(r);
        if (!a)
          return !1;
        const d = (E) => {
          try {
            return decodeURIComponent(E);
          } catch {
            throw new e.DecodeError("failed to decode param");
          }
        }, v = {};
        return Object.keys(t).forEach((E) => {
          const h = t[E], m = a[h.pos];
          m !== void 0 && (v[E] = ~m.indexOf("/") ? m.split("/").map((l) => d(l)) : h.repeat ? [
            d(m)
          ] : d(m));
        }), v;
      };
    }
  }(cr)), cr;
}
var lr = {}, fr = {}, eo;
function ya() {
  return eo || (eo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "escapeStringRegexp", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = /[|\\{}()[\]^$+*?.-]/, s = /[|\\{}()[\]^$+*?.-]/g;
    function i(o) {
      return e.test(o) ? o.replace(s, "\\$&") : o;
    }
  }(fr)), fr;
}
var to;
function va() {
  return to || (to = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(u, c) {
      for (var p in c)
        Object.defineProperty(u, p, {
          enumerable: !0,
          get: c[p]
        });
    }
    e(n, {
      getNamedMiddlewareRegex: function() {
        return f;
      },
      getNamedRouteRegex: function() {
        return l;
      },
      getRouteRegex: function() {
        return v;
      },
      parseParameter: function() {
        return a;
      }
    });
    const s = fn(), i = ya(), o = nt(), t = "nxtP", r = "nxtI";
    function a(u) {
      const c = u.startsWith("[") && u.endsWith("]");
      c && (u = u.slice(1, -1));
      const p = u.startsWith("...");
      return p && (u = u.slice(3)), {
        key: u,
        repeat: p,
        optional: c
      };
    }
    function d(u) {
      const c = (0, o.removeTrailingSlash)(u).slice(1).split("/"), p = {};
      let P = 1;
      return {
        parameterizedRoute: c.map((g) => {
          const y = s.INTERCEPTION_ROUTE_MARKERS.find((R) => g.startsWith(R)), S = g.match(/\[((?:\[.*\])|.+)\]/);
          if (y && S) {
            const { key: R, optional: _, repeat: b } = a(S[1]);
            return p[R] = {
              pos: P++,
              repeat: b,
              optional: _
            }, "/" + (0, i.escapeStringRegexp)(y) + "([^/]+?)";
          } else if (S) {
            const { key: R, repeat: _, optional: b } = a(S[1]);
            return p[R] = {
              pos: P++,
              repeat: _,
              optional: b
            }, _ ? b ? "(?:/(.+?))?" : "/(.+?)" : "/([^/]+?)";
          } else
            return "/" + (0, i.escapeStringRegexp)(g);
        }).join(""),
        groups: p
      };
    }
    function v(u) {
      const { parameterizedRoute: c, groups: p } = d(u);
      return {
        re: new RegExp("^" + c + "(?:/)?$"),
        groups: p
      };
    }
    function E() {
      let u = 0;
      return () => {
        let c = "", p = ++u;
        for (; p > 0; )
          c += String.fromCharCode(97 + (p - 1) % 26), p = Math.floor((p - 1) / 26);
        return c;
      };
    }
    function h(u) {
      let { interceptionMarker: c, getSafeRouteKey: p, segment: P, routeKeys: g, keyPrefix: y } = u;
      const { key: S, optional: R, repeat: _ } = a(P);
      let b = S.replace(/\W/g, "");
      y && (b = "" + y + b);
      let A = !1;
      (b.length === 0 || b.length > 30) && (A = !0), isNaN(parseInt(b.slice(0, 1))) || (A = !0), A && (b = p()), y ? g[b] = "" + y + S : g[b] = S;
      const w = c ? (0, i.escapeStringRegexp)(c) : "";
      return _ ? R ? "(?:/" + w + "(?<" + b + ">.+?))?" : "/" + w + "(?<" + b + ">.+?)" : "/" + w + "(?<" + b + ">[^/]+?)";
    }
    function m(u, c) {
      const p = (0, o.removeTrailingSlash)(u).slice(1).split("/"), P = E(), g = {};
      return {
        namedParameterizedRoute: p.map((y) => {
          const S = s.INTERCEPTION_ROUTE_MARKERS.some((_) => y.startsWith(_)), R = y.match(/\[((?:\[.*\])|.+)\]/);
          if (S && R) {
            const [_] = y.split(R[0]);
            return h({
              getSafeRouteKey: P,
              interceptionMarker: _,
              segment: R[1],
              routeKeys: g,
              keyPrefix: c ? r : void 0
            });
          } else
            return R ? h({
              getSafeRouteKey: P,
              segment: R[1],
              routeKeys: g,
              keyPrefix: c ? t : void 0
            }) : "/" + (0, i.escapeStringRegexp)(y);
        }).join(""),
        routeKeys: g
      };
    }
    function l(u, c) {
      const p = m(u, c);
      return {
        ...v(u),
        namedRegex: "^" + p.namedParameterizedRoute + "(?:/)?$",
        routeKeys: p.routeKeys
      };
    }
    function f(u, c) {
      const { parameterizedRoute: p } = d(u), { catchAll: P = !0 } = c;
      if (p === "/")
        return {
          namedRegex: "^/" + (P ? ".*" : "") + "$"
        };
      const { namedParameterizedRoute: g } = m(u, !1);
      let y = P ? "(?:(/.*)?)" : "";
      return {
        namedRegex: "^" + g + y + "$"
      };
    }
  }(lr)), lr;
}
var ro;
function ba() {
  return ro || (ro = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "interpolateAs", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = _a(), s = va();
    function i(o, t, r) {
      let a = "";
      const d = (0, s.getRouteRegex)(o), v = d.groups, E = (
        // Try to match the dynamic route against the asPath
        (t !== o ? (0, e.getRouteMatcher)(d)(t) : "") || // Fall back to reading the values from the href
        // TODO: should this take priority; also need to change in the router.
        r
      );
      a = o;
      const h = Object.keys(v);
      return h.every((m) => {
        let l = E[m] || "";
        const { repeat: f, optional: u } = v[m];
        let c = "[" + (f ? "..." : "") + m + "]";
        return u && (c = (l ? "" : "/") + "[" + c + "]"), f && !Array.isArray(l) && (l = [
          l
        ]), (u || m in E) && // Interpolate group into data URL if present
        (a = a.replace(c, f ? l.map(
          // these values should be fully encoded instead of just
          // path delimiter escaped since they are being inserted
          // into the URL and we expect URL encoded segments
          // when parsing dynamic route params
          (p) => encodeURIComponent(p)
        ).join("/") : encodeURIComponent(l)) || "/");
      }) || (a = ""), {
        params: h,
        result: a
      };
    }
  }(ur)), ur;
}
var no;
function Sa() {
  return no || (no = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "resolveHref", {
      enumerable: !0,
      get: function() {
        return E;
      }
    });
    const s = Mt(), i = sn(), o = ha(), t = Ke(), r = Nt(), a = cn(), d = ga(), v = ba();
    function E(h, m, l) {
      let f, u = typeof m == "string" ? m : (0, i.formatWithValidation)(m);
      const c = u.match(/^[a-zA-Z]{1,}:\/\//), p = c ? u.slice(c[0].length) : u;
      if ((p.split("?", 1)[0] || "").match(/(\/\/|\\)/)) {
        console.error("Invalid href '" + u + "' passed to next/router in page: '" + h.pathname + "'. Repeated forward-slashes (//) or backslashes \\ are not valid in the href.");
        const g = (0, t.normalizeRepeatedSlashes)(p);
        u = (c ? c[0] : "") + g;
      }
      if (!(0, a.isLocalURL)(u))
        return l ? [
          u
        ] : u;
      try {
        f = new URL(u.startsWith("#") ? h.asPath : h.pathname, "http://n");
      } catch {
        f = new URL("/", "http://n");
      }
      try {
        const g = new URL(u, f);
        g.pathname = (0, r.normalizePathTrailingSlash)(g.pathname);
        let y = "";
        if ((0, d.isDynamicRoute)(g.pathname) && g.searchParams && l) {
          const R = (0, s.searchParamsToUrlQuery)(g.searchParams), { result: _, params: b } = (0, v.interpolateAs)(g.pathname, g.pathname, R);
          _ && (y = (0, i.formatWithValidation)({
            pathname: _,
            hash: g.hash,
            query: (0, o.omit)(R, b)
          }));
        }
        const S = g.origin === f.origin ? g.href.slice(g.origin.length) : g.href;
        return l ? [
          S,
          y || S
        ] : S;
      } catch {
        return l ? [
          u
        ] : u;
      }
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(it, it.exports)), it.exports;
}
var ct = { exports: {} }, dr = {}, pr = {}, oo;
function dn() {
  return oo || (oo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "addPathPrefix", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const e = Ye();
    function s(i, o) {
      if (!i.startsWith("/") || !o)
        return i;
      const { pathname: t, query: r, hash: a } = (0, e.parsePath)(i);
      return "" + o + t + r + a;
    }
  }(pr)), pr;
}
var ao;
function Ra() {
  return ao || (ao = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "addLocale", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = dn(), s = It();
    function i(o, t, r, a) {
      if (!t || t === r)
        return o;
      const d = o.toLowerCase();
      return !a && ((0, s.pathHasPrefix)(d, "/api") || (0, s.pathHasPrefix)(d, "/" + t.toLowerCase())) ? o : (0, e.addPathPrefix)(o, "/" + t);
    }
  }(dr)), dr;
}
var io;
function Ea() {
  return io || (io = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "addLocale", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const s = Nt(), i = function(o) {
      for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
        r[a - 1] = arguments[a];
      return process.env.__NEXT_I18N_SUPPORT ? (0, s.normalizePathTrailingSlash)(Ra().addLocale(o, ...r)) : o;
    };
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(ct, ct.exports)), ct.exports;
}
var pn = {};
(function(n) {
  "use client";
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  function e(v, E) {
    for (var h in E)
      Object.defineProperty(v, h, {
        enumerable: !0,
        get: E[h]
      });
  }
  e(n, {
    AppRouterContext: function() {
      return o;
    },
    GlobalLayoutRouterContext: function() {
      return r;
    },
    LayoutRouterContext: function() {
      return t;
    },
    MissingSlotContext: function() {
      return d;
    },
    TemplateContext: function() {
      return a;
    }
  });
  const i = /* @__PURE__ */ Te._(xe), o = i.default.createContext(null), t = i.default.createContext(null), r = i.default.createContext(null), a = i.default.createContext(null);
  process.env.NODE_ENV !== "production" && (o.displayName = "AppRouterContext", t.displayName = "LayoutRouterContext", r.displayName = "GlobalLayoutRouterContext", a.displayName = "TemplateContext");
  const d = i.default.createContext(/* @__PURE__ */ new Set());
})(pn);
var lt = { exports: {} }, ft = { exports: {} }, so;
function hn() {
  return so || (so = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function s(t, r) {
      for (var a in r)
        Object.defineProperty(t, a, {
          enumerable: !0,
          get: r[a]
        });
    }
    s(e, {
      cancelIdleCallback: function() {
        return o;
      },
      requestIdleCallback: function() {
        return i;
      }
    });
    const i = typeof self < "u" && self.requestIdleCallback && self.requestIdleCallback.bind(window) || function(t) {
      let r = Date.now();
      return self.setTimeout(function() {
        t({
          didTimeout: !1,
          timeRemaining: function() {
            return Math.max(0, 50 - (Date.now() - r));
          }
        });
      }, 1);
    }, o = typeof self < "u" && self.cancelIdleCallback && self.cancelIdleCallback.bind(window) || function(t) {
      return clearTimeout(t);
    };
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(ft, ft.exports)), ft.exports;
}
var uo;
function ts() {
  return uo || (uo = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "useIntersection", {
      enumerable: !0,
      get: function() {
        return v;
      }
    });
    const s = xe, i = hn(), o = typeof IntersectionObserver == "function", t = /* @__PURE__ */ new Map(), r = [];
    function a(E) {
      const h = {
        root: E.root || null,
        margin: E.rootMargin || ""
      }, m = r.find((c) => c.root === h.root && c.margin === h.margin);
      let l;
      if (m && (l = t.get(m), l))
        return l;
      const f = /* @__PURE__ */ new Map(), u = new IntersectionObserver((c) => {
        c.forEach((p) => {
          const P = f.get(p.target), g = p.isIntersecting || p.intersectionRatio > 0;
          P && g && P(g);
        });
      }, E);
      return l = {
        id: h,
        observer: u,
        elements: f
      }, r.push(h), t.set(h, l), l;
    }
    function d(E, h, m) {
      const { id: l, observer: f, elements: u } = a(m);
      return u.set(E, h), f.observe(E), function() {
        if (u.delete(E), f.unobserve(E), u.size === 0) {
          f.disconnect(), t.delete(l);
          const p = r.findIndex((P) => P.root === l.root && P.margin === l.margin);
          p > -1 && r.splice(p, 1);
        }
      };
    }
    function v(E) {
      let { rootRef: h, rootMargin: m, disabled: l } = E;
      const f = l || !o, [u, c] = (0, s.useState)(!1), p = (0, s.useRef)(null), P = (0, s.useCallback)((y) => {
        p.current = y;
      }, []);
      (0, s.useEffect)(() => {
        if (o) {
          if (f || u)
            return;
          const y = p.current;
          if (y && y.tagName)
            return d(y, (R) => R && c(R), {
              root: h == null ? void 0 : h.current,
              rootMargin: m
            });
        } else if (!u) {
          const y = (0, i.requestIdleCallback)(() => c(!0));
          return () => (0, i.cancelIdleCallback)(y);
        }
      }, [
        f,
        m,
        h,
        u,
        p.current
      ]);
      const g = (0, s.useCallback)(() => {
        c(!1);
      }, []);
      return [
        P,
        u,
        g
      ];
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(lt, lt.exports)), lt.exports;
}
var dt = { exports: {} }, pt = { exports: {} }, hr = {}, co;
function jt() {
  return co || (co = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "normalizeLocalePath", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s, i) {
      let o;
      const t = s.split("/");
      return (i || []).some((r) => t[1] && t[1].toLowerCase() === r.toLowerCase() ? (o = r, t.splice(1, 1), s = t.join("/") || "/", !0) : !1), {
        pathname: s,
        detectedLocale: o
      };
    }
  }(hr)), hr;
}
var lo;
function rs() {
  return lo || (lo = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "normalizeLocalePath", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const s = (i, o) => process.env.__NEXT_I18N_SUPPORT ? jt().normalizeLocalePath(i, o) : {
      pathname: i,
      detectedLocale: void 0
    };
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(pt, pt.exports)), pt.exports;
}
var ht = { exports: {} }, mr = {}, fo;
function ns() {
  return fo || (fo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "detectDomainLocale", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s, i, o) {
      if (s) {
        o && (o = o.toLowerCase());
        for (const a of s) {
          var t, r;
          const d = (t = a.domain) == null ? void 0 : t.split(":", 1)[0].toLowerCase();
          if (i === d || o === a.defaultLocale.toLowerCase() || (r = a.locales) != null && r.some((v) => v.toLowerCase() === o))
            return a;
        }
      }
    }
  }(mr)), mr;
}
var po;
function Pa() {
  return po || (po = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "detectDomainLocale", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const s = function() {
      for (var i = arguments.length, o = new Array(i), t = 0; t < i; t++)
        o[t] = arguments[t];
      if (process.env.__NEXT_I18N_SUPPORT)
        return ns().detectDomainLocale(...o);
    };
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(ht, ht.exports)), ht.exports;
}
var ho;
function os() {
  return ho || (ho = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "getDomainLocale", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const s = Nt(), i = process.env.__NEXT_ROUTER_BASEPATH || "";
    function o(t, r, a, d) {
      if (process.env.__NEXT_I18N_SUPPORT) {
        const v = rs().normalizeLocalePath, E = Pa().detectDomainLocale, h = r || v(t, a).detectedLocale, m = E(d, void 0, h);
        if (m) {
          const l = "http" + (m.http ? "" : "s") + "://", f = h === m.defaultLocale ? "" : "/" + h;
          return "" + l + m.domain + (0, s.normalizePathTrailingSlash)("" + i + f + t);
        }
        return !1;
      } else
        return !1;
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(dt, dt.exports)), dt.exports;
}
var mt = { exports: {} }, mo;
function wa() {
  return mo || (mo = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "addBasePath", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    const s = dn(), i = Nt(), o = process.env.__NEXT_ROUTER_BASEPATH || "";
    function t(r, a) {
      return (0, i.normalizePathTrailingSlash)(process.env.__NEXT_MANUAL_CLIENT_BASE_PATH && !a ? r : (0, s.addPathPrefix)(r, o));
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(mt, mt.exports)), mt.exports;
}
var gt = { exports: {} }, go;
function as() {
  return go || (go = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function s(l, f) {
      for (var u in f)
        Object.defineProperty(l, u, {
          enumerable: !0,
          get: f[u]
        });
    }
    s(e, {
      ACTION_FAST_REFRESH: function() {
        return d;
      },
      ACTION_NAVIGATE: function() {
        return o;
      },
      ACTION_PREFETCH: function() {
        return a;
      },
      ACTION_REFRESH: function() {
        return i;
      },
      ACTION_RESTORE: function() {
        return t;
      },
      ACTION_SERVER_ACTION: function() {
        return v;
      },
      ACTION_SERVER_PATCH: function() {
        return r;
      },
      PrefetchCacheEntryStatus: function() {
        return h;
      },
      PrefetchKind: function() {
        return E;
      },
      isThenable: function() {
        return m;
      }
    });
    const i = "refresh", o = "navigate", t = "restore", r = "server-patch", a = "prefetch", d = "fast-refresh", v = "server-action";
    var E;
    (function(l) {
      l.AUTO = "auto", l.FULL = "full", l.TEMPORARY = "temporary";
    })(E || (E = {}));
    var h;
    (function(l) {
      l.fresh = "fresh", l.reusable = "reusable", l.expired = "expired", l.stale = "stale";
    })(h || (h = {}));
    function m(l) {
      return l && (typeof l == "object" || typeof l == "function") && typeof l.then == "function";
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(gt, gt.exports)), gt.exports;
}
(function(n, e) {
  "use client";
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return R;
    }
  });
  const s = Te, i = tt, o = /* @__PURE__ */ s._(xe), t = Sa(), r = cn(), a = sn(), d = Ke(), v = Ea(), E = an(), h = pn, m = ts(), l = os(), f = wa(), u = as(), c = /* @__PURE__ */ new Set();
  function p(_, b, A, w, j, B) {
    if (typeof window > "u" || !B && !(0, r.isLocalURL)(b))
      return;
    if (!w.bypassPrefetchedCheck) {
      const O = (
        // Let the link's locale prop override the default router locale.
        typeof w.locale < "u" ? w.locale : "locale" in _ ? _.locale : void 0
      ), N = b + "%" + A + "%" + O;
      if (c.has(N))
        return;
      c.add(N);
    }
    (async () => B ? _.prefetch(b, j) : _.prefetch(b, A, w))().catch((O) => {
      if (process.env.NODE_ENV !== "production")
        throw O;
    });
  }
  function P(_) {
    const A = _.currentTarget.getAttribute("target");
    return A && A !== "_self" || _.metaKey || _.ctrlKey || _.shiftKey || _.altKey || // triggers resource download
    _.nativeEvent && _.nativeEvent.which === 2;
  }
  function g(_, b, A, w, j, B, X, O, N) {
    const { nodeName: L } = _.currentTarget;
    if (L.toUpperCase() === "A" && (P(_) || // app-router supports external urls out of the box so it shouldn't short-circuit here as support for e.g. `replace` is added in the app-router.
    !N && !(0, r.isLocalURL)(A)))
      return;
    _.preventDefault();
    const $ = () => {
      const U = X ?? !0;
      "beforePopState" in b ? b[j ? "replace" : "push"](A, w, {
        shallow: B,
        locale: O,
        scroll: U
      }) : b[j ? "replace" : "push"](w || A, {
        scroll: U
      });
    };
    N ? o.default.startTransition($) : $();
  }
  function y(_) {
    return typeof _ == "string" ? _ : (0, a.formatUrl)(_);
  }
  const R = /* @__PURE__ */ o.default.forwardRef(function(b, A) {
    let w;
    const { href: j, as: B, children: X, prefetch: O = null, passHref: N, replace: L, shallow: z, scroll: $, locale: U, onClick: K, onMouseEnter: Z, onTouchStart: se, legacyBehavior: ee = !1, ...ce } = b;
    w = X, ee && (typeof w == "string" || typeof w == "number") && (w = /* @__PURE__ */ (0, i.jsx)("a", {
      children: w
    }));
    const ae = o.default.useContext(E.RouterContext), pe = o.default.useContext(h.AppRouterContext), M = ae ?? pe, le = !ae, me = O !== !1, he = O === null ? u.PrefetchKind.AUTO : u.PrefetchKind.FULL;
    if (process.env.NODE_ENV !== "production") {
      let k = function(V) {
        return new Error("Failed prop type: The prop `" + V.key + "` expects a " + V.expected + " in `<Link>`, but got `" + V.actual + "` instead." + (typeof window < "u" ? `
Open your browser's console to view the Component stack trace.` : ""));
      };
      Object.keys({
        href: !0
      }).forEach((V) => {
        if (V === "href" && (b[V] == null || typeof b[V] != "string" && typeof b[V] != "object"))
          throw k({
            key: V,
            expected: "`string` or `object`",
            actual: b[V] === null ? "null" : typeof b[V]
          });
      }), Object.keys({
        as: !0,
        replace: !0,
        scroll: !0,
        shallow: !0,
        passHref: !0,
        prefetch: !0,
        locale: !0,
        onClick: !0,
        onMouseEnter: !0,
        onTouchStart: !0,
        legacyBehavior: !0
      }).forEach((V) => {
        const Q = typeof b[V];
        if (V === "as") {
          if (b[V] && Q !== "string" && Q !== "object")
            throw k({
              key: V,
              expected: "`string` or `object`",
              actual: Q
            });
        } else if (V === "locale") {
          if (b[V] && Q !== "string")
            throw k({
              key: V,
              expected: "`string`",
              actual: Q
            });
        } else if (V === "onClick" || V === "onMouseEnter" || V === "onTouchStart") {
          if (b[V] && Q !== "function")
            throw k({
              key: V,
              expected: "`function`",
              actual: Q
            });
        } else if ((V === "replace" || V === "scroll" || V === "shallow" || V === "passHref" || V === "prefetch" || V === "legacyBehavior") && b[V] != null && Q !== "boolean")
          throw k({
            key: V,
            expected: "`boolean`",
            actual: Q
          });
      });
      const I = o.default.useRef(!1);
      b.prefetch && !I.current && !le && (I.current = !0, console.warn("Next.js auto-prefetches automatically based on viewport. The prefetch attribute is no longer needed. More: https://nextjs.org/docs/messages/prefetch-true-deprecated"));
    }
    if (process.env.NODE_ENV !== "production" && le && !B) {
      let k;
      if (typeof j == "string" ? k = j : typeof j == "object" && typeof j.pathname == "string" && (k = j.pathname), k && k.split("/").some((J) => J.startsWith("[") && J.endsWith("]")))
        throw new Error("Dynamic href `" + k + "` found in <Link> while using the `/app` router, this is not supported. Read more: https://nextjs.org/docs/messages/app-dir-dynamic-href");
    }
    const { href: T, as: x } = o.default.useMemo(() => {
      if (!ae) {
        const J = y(j);
        return {
          href: J,
          as: B ? y(B) : J
        };
      }
      const [k, ne] = (0, t.resolveHref)(ae, j, !0);
      return {
        href: k,
        as: B ? (0, t.resolveHref)(ae, B) : ne || k
      };
    }, [
      ae,
      j,
      B
    ]), Re = o.default.useRef(T), q = o.default.useRef(x);
    let W;
    if (ee)
      if (process.env.NODE_ENV === "development") {
        K && console.warn('"onClick" was passed to <Link> with `href` of `' + j + '` but "legacyBehavior" was set. The legacy behavior requires onClick be set on the child of next/link'), Z && console.warn('"onMouseEnter" was passed to <Link> with `href` of `' + j + '` but "legacyBehavior" was set. The legacy behavior requires onMouseEnter be set on the child of next/link');
        try {
          W = o.default.Children.only(w);
        } catch {
          throw w ? new Error("Multiple children were passed to <Link> with `href` of `" + j + "` but only one child is supported https://nextjs.org/docs/messages/link-multiple-children" + (typeof window < "u" ? ` 
Open your browser's console to view the Component stack trace.` : "")) : new Error("No children were passed to <Link> with `href` of `" + j + "` but one child is required https://nextjs.org/docs/messages/link-no-children");
        }
      } else
        W = o.default.Children.only(w);
    else if (process.env.NODE_ENV === "development" && (w == null ? void 0 : w.type) === "a")
      throw new Error(`Invalid <Link> with <a> child. Please remove <a> or use <Link legacyBehavior>.
Learn more: https://nextjs.org/docs/messages/invalid-new-link-with-extra-anchor`);
    const H = ee ? W && typeof W == "object" && W.ref : A, [D, C, F] = (0, m.useIntersection)({
      rootMargin: "200px"
    }), ue = o.default.useCallback((k) => {
      (q.current !== x || Re.current !== T) && (F(), q.current = x, Re.current = T), D(k), H && (typeof H == "function" ? H(k) : typeof H == "object" && (H.current = k));
    }, [
      x,
      H,
      T,
      F,
      D
    ]);
    o.default.useEffect(() => {
      process.env.NODE_ENV === "production" && M && (!C || !me || p(M, T, x, {
        locale: U
      }, {
        kind: he
      }, le));
    }, [
      x,
      T,
      C,
      U,
      me,
      ae == null ? void 0 : ae.locale,
      M,
      le,
      he
    ]);
    const oe = {
      ref: ue,
      onClick(k) {
        if (process.env.NODE_ENV !== "production" && !k)
          throw new Error('Component rendered inside next/link has to pass click event to "onClick" prop.');
        !ee && typeof K == "function" && K(k), ee && W.props && typeof W.props.onClick == "function" && W.props.onClick(k), M && (k.defaultPrevented || g(k, M, T, x, L, z, $, U, le));
      },
      onMouseEnter(k) {
        !ee && typeof Z == "function" && Z(k), ee && W.props && typeof W.props.onMouseEnter == "function" && W.props.onMouseEnter(k), M && ((!me || process.env.NODE_ENV === "development") && le || p(M, T, x, {
          locale: U,
          priority: !0,
          // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
          bypassPrefetchedCheck: !0
        }, {
          kind: he
        }, le));
      },
      onTouchStart: process.env.__NEXT_LINK_NO_TOUCH_START ? void 0 : function(ne) {
        !ee && typeof se == "function" && se(ne), ee && W.props && typeof W.props.onTouchStart == "function" && W.props.onTouchStart(ne), M && (!me && le || p(M, T, x, {
          locale: U,
          priority: !0,
          // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
          bypassPrefetchedCheck: !0
        }, {
          kind: he
        }, le));
      }
    };
    if ((0, d.isAbsoluteUrl)(x))
      oe.href = x;
    else if (!ee || N || W.type === "a" && !("href" in W.props)) {
      const k = typeof U < "u" ? U : ae == null ? void 0 : ae.locale, ne = (ae == null ? void 0 : ae.isLocaleDomain) && (0, l.getDomainLocale)(x, k, ae == null ? void 0 : ae.locales, ae == null ? void 0 : ae.domainLocales);
      oe.href = ne || (0, f.addBasePath)((0, v.addLocale)(x, k, ae == null ? void 0 : ae.defaultLocale));
    }
    return ee ? /* @__PURE__ */ o.default.cloneElement(W, oe) : /* @__PURE__ */ (0, i.jsx)("a", {
      ...ce,
      ...oe,
      children: w
    });
  });
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(zr, zr.exports);
var is = zr.exports, ss = is;
const Je = /* @__PURE__ */ rt(ss), _o = {
  lg: {
    height: 48,
    width: 108
  },
  sm: {
    height: 36,
    width: 81
  }
}, bu = ({
  onClick: n,
  "data-testid": e,
  size: s = "lg",
  className: i,
  inverted: o
}) => /* @__PURE__ */ be(
  Je,
  {
    href: "/",
    "data-testid": e || "logo",
    onClick: n,
    className: i,
    children: /* @__PURE__ */ be(
      Qi,
      {
        src: o ? "https://ui-cms-s3.snapfinance.com/OneSnap/icons/svg/logo-inverted.svg" : "https://ui-cms-s3.snapfinance.com/OneSnap/icons/svg/logo.svg",
        alt: "Snap Finance Logo",
        height: _o[s].height,
        width: _o[s].width,
        priority: !0
      }
    )
  }
), us = (n, e) => {
  const s = n % e, i = n / e;
  let o;
  return i < 1 ? o = 1 : s > 0 ? o = Math.ceil(i) : o = i, o;
};
var Oa = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(n) {
  (function() {
    var e = {}.hasOwnProperty;
    function s() {
      for (var i = [], o = 0; o < arguments.length; o++) {
        var t = arguments[o];
        if (t) {
          var r = typeof t;
          if (r === "string" || r === "number")
            i.push(t);
          else if (Array.isArray(t)) {
            if (t.length) {
              var a = s.apply(null, t);
              a && i.push(a);
            }
          } else if (r === "object")
            if (t.toString === Object.prototype.toString)
              for (var d in t)
                e.call(t, d) && t[d] && i.push(d);
            else
              i.push(t.toString());
        }
      }
      return i.join(" ");
    }
    n.exports ? (s.default = s, n.exports = s) : window.classNames = s;
  })();
})(Oa);
var cs = Oa.exports;
const Ue = /* @__PURE__ */ rt(cs), ls = ({
  numberOfPages: n,
  currentPageNumber: e,
  setPageNumberAndResetScreen: s,
  generateQueryParam: i,
  variation: o = "stack"
}) => {
  let t = [];
  if (n === 1)
    return null;
  if (n <= 5)
    for (let r = 1; r <= n; r++)
      t.push(
        /* @__PURE__ */ be(
          "li",
          {
            "data-testid": e === r ? "selected-page" : `page-option-${r}`,
            className: Ue("w-full", {
              "bg-SnapBlue": e === r,
              "rounded-[4px_0_0_4px]": r === 1 && e === 1,
              "rounded-[0_4px_4px_0]": r === n && e === n
            }),
            children: /* @__PURE__ */ be(
              Je,
              {
                href: i(r),
                shallow: !0,
                className: Ue(
                  "flex items-center justify-center text-SnapGrey400 secondaryHeavyFont visited:text-SnapGrey400 hover:no-underline hover:text-SnapWhite hover:bg-SnapMediumBlue",
                  {
                    "text-SnapWhite visited:text-SnapWhite": e === r,
                    "border-l-1 border-solid border-SnapGrey300 rounded-[inherit]": r === 1 && e === 1,
                    "border-r-1 border-solid border-SnapGrey300 rounded-[inherit]": r === n && e === n
                  },
                  "w-full",
                  "h-full",
                  "border-t-1 border-b-1 border-l-0 border-r-1 border-solid border-SnapGrey300"
                ),
                onClick: (a) => {
                  s(r);
                },
                children: r
              }
            )
          },
          r
        )
      );
  else {
    let r = [];
    e === 1 || e === 2 || e === 3 ? r = [1, 2, 3, 4, "...", n] : e === n || e === n - 1 || e === n - 2 ? r = [
      1,
      "...",
      n - 3,
      n - 2,
      n - 1,
      n
    ] : r = [
      1,
      "...",
      e - 1,
      e,
      e + 1,
      "...",
      n
    ], t = r.map((a, d) => a === "..." ? /* @__PURE__ */ be(
      "li",
      {
        className: Ue(
          "flex justify-center items-center w-full",
          "text-SnapGrey400",
          "border-t-1 border-b-1 border-l-0 border-r-1 border-solid border-SnapGrey300"
        ),
        children: "..."
      },
      "ellipsis" + d
    ) : /* @__PURE__ */ be(
      "li",
      {
        "data-testid": e === a ? "selected-page" : `page-option-${a}`,
        className: Ue("flex justify-center items-center w-full", {
          "bg-SnapBlue": e === a,
          "rounded-[4px_0_0_4px]": a === 1 && e === 1,
          "rounded-[0_4px_4px_0]": a === n && e === n
        }),
        children: /* @__PURE__ */ be(
          Je,
          {
            href: i(a),
            shallow: !0,
            className: Ue(
              "border-t-1 border-b-1 border-l-0 border-r-1 border-solid border-SnapGrey300",
              "flex justify-center items-center h-full w-full text-SnapGrey400 secondaryHeavyFont visited:text-SnapGrey400 hover:no-underline hover:text-SnapWhite hover:bg-SnapMediumBlue",
              {
                "text-SnapWhite visited:text-SnapWhite": e === a,
                "border-l-1 border-solid border-SnapGrey300 rounded-[inherit]": a === 1 && e === 1,
                "border-r-1 border-solid border-SnapGrey300 rounded-[inherit]": a === n && e === n
              }
            ),
            onClick: (v) => {
              s(a);
            },
            children: a
          }
        )
      },
      a
    ));
  }
  return /* @__PURE__ */ Ze(
    "ul",
    {
      className: Ue(
        "flex mb-0 pl-0 list-none",
        o === "row" ? "w-[315px]" : null
      ),
      children: [
        e !== 1 && /* @__PURE__ */ be(
          Je,
          {
            href: i(e - 1),
            shallow: !0,
            "data-testid": "left-pagination-arrow",
            onClick: (r) => {
              s(e - 1);
            },
            "aria-label": "left pagination arrow",
            className: Ue(
              "border-1 border-solid border-SnapGrey300 rounded-[4px_0_0_4px] hover:rounded-[4px_0_0_4px]",
              "flex justify-center items-center w-full text-SnapGrey400 secondaryHeavyFont visited:text-SnapGrey400 hover:no-underline hover:text-SnapWhite hover:bg-SnapMediumBlue"
            ),
            children: /* @__PURE__ */ be($a, { className: "w-full", fontSize: "small" })
          }
        ),
        t,
        e !== n && /* @__PURE__ */ be(
          Je,
          {
            href: i(e + 1),
            shallow: !0,
            "data-testid": "right-pagination-arrow",
            onClick: (r) => {
              s(e + 1);
            },
            "aria-label": "right-pagination-arrow",
            className: Ue(
              "border-1 border-solid border-SnapGrey300 border-l-0 rounded-[0_4px_4px_0] hover:rounded-[0_4px_4px_0]",
              "flex justify-center items-center w-full text-SnapGrey400 secondaryHeavyFont visited:text-SnapGrey400 hover:no-underline hover:text-SnapWhite hover:bg-SnapMediumBlue"
            ),
            children: /* @__PURE__ */ be(ka, { className: "w-full", fontSize: "small" })
          }
        )
      ]
    }
  );
}, Su = ({
  totalItemCount: n,
  pageSize: e,
  currentPageNumber: s,
  setPageNumber: i,
  generateQueryParam: o,
  renderFootNote: t,
  testId: r,
  variation: a = "stack"
}) => {
  const d = us(n, e), v = (m) => {
    i(m), window.scrollTo(0, 0);
  }, E = e * (s - 1) + 1;
  let h = E + e - 1;
  return h = h < n ? h : n, /* @__PURE__ */ Ze(
    "div",
    {
      className: a === "row" ? "flex justify-between flex-row-reverse mx-5" : "",
      "data-testid": r,
      children: [
        d > 1 ? /* @__PURE__ */ be(
          ls,
          {
            numberOfPages: d,
            currentPageNumber: s,
            setPageNumberAndResetScreen: v,
            generateQueryParam: o,
            variation: a
          }
        ) : null,
        n > 0 ? /* @__PURE__ */ be("div", { className: a === "stack" ? "text-center mt-2" : "", children: /* @__PURE__ */ be("span", { className: "secondaryFont text-SnapGrey500", children: t ? t(
          n,
          E,
          h
        ) : null }) }) : null
      ]
    }
  );
};
var _t = { exports: {} }, gr = {}, yt = { exports: {} }, _r = {}, yo;
function fs() {
  return yo || (yo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s, i) {
      return i === void 0 && (i = ""), (s === "/" ? "/index" : /^\/index(\/|$)/.test(s) ? "/index" + s : s) + i;
    }
  }(_r)), _r;
}
var vt = { exports: {} }, vo;
function ds() {
  return vo || (vo = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "__unsafeCreateTrustedScriptURL", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    let s;
    function i() {
      if (typeof s > "u" && typeof window < "u") {
        var t;
        s = ((t = window.trustedTypes) == null ? void 0 : t.createPolicy("nextjs", {
          createHTML: (r) => r,
          createScript: (r) => r,
          createScriptURL: (r) => r
        })) || null;
      }
      return s;
    }
    function o(t) {
      var r;
      return ((r = i()) == null ? void 0 : r.createScriptURL(t)) || t;
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(vt, vt.exports)), vt.exports;
}
var yr = {}, bo;
function ps() {
  return bo || (bo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "getDeploymentIdQueryOrEmptyString", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e() {
      return process.env.NEXT_DEPLOYMENT_ID ? `?dpl=${process.env.NEXT_DEPLOYMENT_ID}` : "";
    }
  }(yr)), yr;
}
var So;
function hs() {
  return So || (So = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function s(_, b) {
      for (var A in b)
        Object.defineProperty(_, A, {
          enumerable: !0,
          get: b[A]
        });
    }
    s(e, {
      createRouteLoader: function() {
        return R;
      },
      getClientBuildManifest: function() {
        return y;
      },
      isAssetError: function() {
        return m;
      },
      markAssetError: function() {
        return h;
      }
    });
    const o = /* @__PURE__ */ Te._(fs()), t = ds(), r = hn(), a = ps(), d = 3800;
    function v(_, b, A) {
      let w = b.get(_);
      if (w)
        return "future" in w ? w.future : Promise.resolve(w);
      let j;
      const B = new Promise((X) => {
        j = X;
      });
      return b.set(_, w = {
        resolve: j,
        future: B
      }), A ? A().then((X) => (j(X), X)).catch((X) => {
        throw b.delete(_), X;
      }) : B;
    }
    const E = Symbol("ASSET_LOAD_ERROR");
    function h(_) {
      return Object.defineProperty(_, E, {});
    }
    function m(_) {
      return _ && E in _;
    }
    function l(_) {
      try {
        return _ = document.createElement("link"), // detect IE11 since it supports prefetch but isn't detected
        // with relList.support
        !!window.MSInputMethodContext && !!document.documentMode || _.relList.supports("prefetch");
      } catch {
        return !1;
      }
    }
    const f = l(), u = () => (0, a.getDeploymentIdQueryOrEmptyString)();
    function c(_, b, A) {
      return new Promise((w, j) => {
        const B = `
      link[rel="prefetch"][href^="` + _ + `"],
      link[rel="preload"][href^="` + _ + `"],
      script[src^="` + _ + '"]';
        if (document.querySelector(B))
          return w();
        A = document.createElement("link"), A.as = b, A.rel = "prefetch", A.crossOrigin = process.env.__NEXT_CROSS_ORIGIN, A.onload = w, A.onerror = () => j(h(new Error("Failed to prefetch: " + _))), A.href = _, document.head.appendChild(A);
      });
    }
    function p(_, b) {
      return new Promise((A, w) => {
        b = document.createElement("script"), b.onload = A, b.onerror = () => w(h(new Error("Failed to load script: " + _))), b.crossOrigin = process.env.__NEXT_CROSS_ORIGIN, b.src = _, document.body.appendChild(b);
      });
    }
    let P;
    function g(_, b, A) {
      return new Promise((w, j) => {
        let B = !1;
        _.then((X) => {
          B = !0, w(X);
        }).catch(j), process.env.NODE_ENV === "development" && (P || Promise.resolve()).then(() => {
          (0, r.requestIdleCallback)(() => setTimeout(() => {
            B || j(A);
          }, b));
        }), process.env.NODE_ENV !== "development" && (0, r.requestIdleCallback)(() => setTimeout(() => {
          B || j(A);
        }, b));
      });
    }
    function y() {
      if (self.__BUILD_MANIFEST)
        return Promise.resolve(self.__BUILD_MANIFEST);
      const _ = new Promise((b) => {
        const A = self.__BUILD_MANIFEST_CB;
        self.__BUILD_MANIFEST_CB = () => {
          b(self.__BUILD_MANIFEST), A && A();
        };
      });
      return g(_, d, h(new Error("Failed to load client build manifest")));
    }
    function S(_, b) {
      if (process.env.NODE_ENV === "development") {
        const A = _ + "/_next/static/chunks/pages" + encodeURI((0, o.default)(b, ".js")) + u();
        return Promise.resolve({
          scripts: [
            (0, t.__unsafeCreateTrustedScriptURL)(A)
          ],
          // Styles are handled by `style-loader` in development:
          css: []
        });
      }
      return y().then((A) => {
        if (!(b in A))
          throw h(new Error("Failed to lookup route: " + b));
        const w = A[b].map((j) => _ + "/_next/" + encodeURI(j));
        return {
          scripts: w.filter((j) => j.endsWith(".js")).map((j) => (0, t.__unsafeCreateTrustedScriptURL)(j) + u()),
          css: w.filter((j) => j.endsWith(".css")).map((j) => j + u())
        };
      });
    }
    function R(_) {
      const b = /* @__PURE__ */ new Map(), A = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Map(), j = /* @__PURE__ */ new Map();
      function B(O) {
        if (process.env.NODE_ENV !== "development") {
          let N = A.get(O.toString());
          return N || (document.querySelector('script[src^="' + O + '"]') ? Promise.resolve() : (A.set(O.toString(), N = p(O)), N));
        } else
          return p(O);
      }
      function X(O) {
        let N = w.get(O);
        return N || (w.set(O, N = fetch(O, {
          credentials: "same-origin"
        }).then((L) => {
          if (!L.ok)
            throw new Error("Failed to load stylesheet: " + O);
          return L.text().then((z) => ({
            href: O,
            content: z
          }));
        }).catch((L) => {
          throw h(L);
        })), N);
      }
      return {
        whenEntrypoint(O) {
          return v(O, b);
        },
        onEntrypoint(O, N) {
          (N ? Promise.resolve().then(() => N()).then((L) => ({
            component: L && L.default || L,
            exports: L
          }), (L) => ({
            error: L
          })) : Promise.resolve(void 0)).then((L) => {
            const z = b.get(O);
            z && "resolve" in z ? L && (b.set(O, L), z.resolve(L)) : (L ? b.set(O, L) : b.delete(O), j.delete(O));
          });
        },
        loadRoute(O, N) {
          return v(O, j, () => {
            let L;
            return process.env.NODE_ENV === "development" && (P = new Promise((z) => {
              L = z;
            })), g(S(_, O).then((z) => {
              let { scripts: $, css: U } = z;
              return Promise.all([
                b.has(O) ? [] : Promise.all($.map(B)),
                Promise.all(U.map(X))
              ]);
            }).then((z) => this.whenEntrypoint(O).then(($) => ({
              entrypoint: $,
              styles: z[1]
            }))), d, h(new Error("Route did not complete loading: " + O))).then((z) => {
              let { entrypoint: $, styles: U } = z;
              const K = Object.assign({
                styles: U
              }, $);
              return "error" in $ ? $ : K;
            }).catch((z) => {
              if (N)
                throw z;
              return {
                error: z
              };
            }).finally(() => L == null ? void 0 : L());
          });
        },
        prefetch(O) {
          let N;
          return (N = navigator.connection) && (N.saveData || /2g/.test(N.effectiveType)) ? Promise.resolve() : S(_, O).then((L) => Promise.all(f ? L.scripts.map((z) => c(z.toString(), "script")) : [])).then(() => {
            (0, r.requestIdleCallback)(() => this.loadRoute(O, !0).catch(() => {
            }));
          }).catch(
            // swallow prefetch errors
            () => {
            }
          );
        }
      };
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(yt, yt.exports)), yt.exports;
}
var bt = { exports: {} }, St = { exports: {} }, Ro;
function ms() {
  return Ro || (Ro = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function s(d, v) {
      for (var E in v)
        Object.defineProperty(d, E, {
          enumerable: !0,
          get: v[E]
        });
    }
    s(e, {
      DOMAttributeNames: function() {
        return i;
      },
      default: function() {
        return a;
      },
      isEqualNode: function() {
        return t;
      }
    });
    const i = {
      acceptCharset: "accept-charset",
      className: "class",
      htmlFor: "for",
      httpEquiv: "http-equiv",
      noModule: "noModule"
    };
    function o(d) {
      let { type: v, props: E } = d;
      const h = document.createElement(v);
      for (const f in E) {
        if (!E.hasOwnProperty(f) || f === "children" || f === "dangerouslySetInnerHTML" || E[f] === void 0)
          continue;
        const u = i[f] || f.toLowerCase();
        v === "script" && (u === "async" || u === "defer" || u === "noModule") ? h[u] = !!E[f] : h.setAttribute(u, E[f]);
      }
      const { children: m, dangerouslySetInnerHTML: l } = E;
      return l ? h.innerHTML = l.__html || "" : m && (h.textContent = typeof m == "string" ? m : Array.isArray(m) ? m.join("") : ""), h;
    }
    function t(d, v) {
      if (d instanceof HTMLElement && v instanceof HTMLElement) {
        const E = v.getAttribute("nonce");
        if (E && !d.getAttribute("nonce")) {
          const h = v.cloneNode(!0);
          return h.setAttribute("nonce", ""), h.nonce = E, E === d.nonce && d.isEqualNode(h);
        }
      }
      return d.isEqualNode(v);
    }
    let r;
    process.env.__NEXT_STRICT_NEXT_HEAD ? r = (d, v) => {
      const E = document.querySelector("head");
      if (!E)
        return;
      const h = E.querySelectorAll('meta[name="next-head"]') || [], m = [];
      if (d === "meta") {
        const u = E.querySelector("meta[charset]");
        u && m.push(u);
      }
      for (let u = 0; u < h.length; u++) {
        var l;
        const p = h[u].nextSibling;
        (p == null || (l = p.tagName) == null ? void 0 : l.toLowerCase()) === d && m.push(p);
      }
      const f = v.map(o).filter((u) => {
        for (let c = 0, p = m.length; c < p; c++) {
          const P = m[c];
          if (t(P, u))
            return m.splice(c, 1), !1;
        }
        return !0;
      });
      m.forEach((u) => {
        var c;
        const p = u.previousSibling;
        if (p && p.getAttribute("name") === "next-head") {
          var P;
          (P = u.parentNode) == null || P.removeChild(p);
        }
        (c = u.parentNode) == null || c.removeChild(u);
      }), f.forEach((u) => {
        var c;
        const p = document.createElement("meta");
        p.name = "next-head", p.content = "1", ((c = u.tagName) == null ? void 0 : c.toLowerCase()) === "meta" && u.getAttribute("charset") || E.appendChild(p), E.appendChild(u);
      });
    } : r = (d, v) => {
      const E = document.getElementsByTagName("head")[0], h = E.querySelector("meta[name=next-head-count]");
      if (process.env.NODE_ENV !== "production" && !h) {
        console.error("Warning: next-head-count is missing. https://nextjs.org/docs/messages/next-head-count-missing");
        return;
      }
      const m = Number(h.content), l = [];
      for (let c = 0, p = h.previousElementSibling; c < m; c++, p = (p == null ? void 0 : p.previousElementSibling) || null) {
        var f;
        (p == null || (f = p.tagName) == null ? void 0 : f.toLowerCase()) === d && l.push(p);
      }
      const u = v.map(o).filter((c) => {
        for (let p = 0, P = l.length; p < P; p++) {
          const g = l[p];
          if (t(g, c))
            return l.splice(p, 1), !1;
        }
        return !0;
      });
      l.forEach((c) => {
        var p;
        return (p = c.parentNode) == null ? void 0 : p.removeChild(c);
      }), u.forEach((c) => E.insertBefore(c, h)), h.content = (m - l.length + u.length).toString();
    };
    function a() {
      return {
        mountedInstances: /* @__PURE__ */ new Set(),
        updateHead: (d) => {
          const v = {};
          d.forEach((m) => {
            if (
              // If the font tag is loaded only on client navigation
              // it won't be inlined. In this case revert to the original behavior
              m.type === "link" && m.props["data-optimized-fonts"]
            ) {
              if (document.querySelector('style[data-href="' + m.props["data-href"] + '"]'))
                return;
              m.props.href = m.props["data-href"], m.props["data-href"] = void 0;
            }
            const l = v[m.type] || [];
            l.push(m), v[m.type] = l;
          });
          const E = v.title ? v.title[0] : null;
          let h = "";
          if (E) {
            const { children: m } = E.props;
            h = typeof m == "string" ? m : Array.isArray(m) ? m.join("") : "";
          }
          h !== document.title && (document.title = h), [
            "meta",
            "base",
            "link",
            "style",
            "script"
          ].forEach((m) => {
            r(m, v[m] || []);
          });
        }
      };
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(St, St.exports)), St.exports;
}
var Eo;
function gs() {
  return Eo || (Eo = 1, function(n, e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function s(R, _) {
      for (var b in _)
        Object.defineProperty(R, b, {
          enumerable: !0,
          get: _[b]
        });
    }
    s(e, {
      default: function() {
        return S;
      },
      handleClientScriptLoad: function() {
        return c;
      },
      initScriptLoader: function() {
        return g;
      }
    });
    const i = Te, o = Be, t = tt, r = /* @__PURE__ */ i._(ia), a = /* @__PURE__ */ o._(xe), d = fa(), v = ms(), E = hn(), h = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Set(), l = [
      "onLoad",
      "onReady",
      "dangerouslySetInnerHTML",
      "children",
      "onError",
      "strategy",
      "stylesheets"
    ], f = (R) => {
      if (r.default.preinit) {
        R.forEach((_) => {
          r.default.preinit(_, {
            as: "style"
          });
        });
        return;
      }
      if (typeof window < "u") {
        let _ = document.head;
        R.forEach((b) => {
          let A = document.createElement("link");
          A.type = "text/css", A.rel = "stylesheet", A.href = b, _.appendChild(A);
        });
      }
    }, u = (R) => {
      const { src: _, id: b, onLoad: A = () => {
      }, onReady: w = null, dangerouslySetInnerHTML: j, children: B = "", strategy: X = "afterInteractive", onError: O, stylesheets: N } = R, L = b || _;
      if (L && m.has(L))
        return;
      if (h.has(_)) {
        m.add(L), h.get(_).then(A, O);
        return;
      }
      const z = () => {
        w && w(), m.add(L);
      }, $ = document.createElement("script"), U = new Promise((K, Z) => {
        $.addEventListener("load", function(se) {
          K(), A && A.call(this, se), z();
        }), $.addEventListener("error", function(se) {
          Z(se);
        });
      }).catch(function(K) {
        O && O(K);
      });
      j ? ($.innerHTML = j.__html || "", z()) : B ? ($.textContent = typeof B == "string" ? B : Array.isArray(B) ? B.join("") : "", z()) : _ && ($.src = _, h.set(_, U));
      for (const [K, Z] of Object.entries(R)) {
        if (Z === void 0 || l.includes(K))
          continue;
        const se = v.DOMAttributeNames[K] || K.toLowerCase();
        $.setAttribute(se, Z);
      }
      X === "worker" && $.setAttribute("type", "text/partytown"), $.setAttribute("data-nscript", X), N && f(N), document.body.appendChild($);
    };
    function c(R) {
      const { strategy: _ = "afterInteractive" } = R;
      _ === "lazyOnload" ? window.addEventListener("load", () => {
        (0, E.requestIdleCallback)(() => u(R));
      }) : u(R);
    }
    function p(R) {
      document.readyState === "complete" ? (0, E.requestIdleCallback)(() => u(R)) : window.addEventListener("load", () => {
        (0, E.requestIdleCallback)(() => u(R));
      });
    }
    function P() {
      [
        ...document.querySelectorAll('[data-nscript="beforeInteractive"]'),
        ...document.querySelectorAll('[data-nscript="beforePageRender"]')
      ].forEach((_) => {
        const b = _.id || _.getAttribute("src");
        m.add(b);
      });
    }
    function g(R) {
      R.forEach(c), P();
    }
    function y(R) {
      const { id: _, src: b = "", onLoad: A = () => {
      }, onReady: w = null, strategy: j = "afterInteractive", onError: B, stylesheets: X, ...O } = R, { updateScripts: N, scripts: L, getIsSsr: z, appDir: $, nonce: U } = (0, a.useContext)(d.HeadManagerContext), K = (0, a.useRef)(!1);
      (0, a.useEffect)(() => {
        const se = _ || b;
        K.current || (w && se && m.has(se) && w(), K.current = !0);
      }, [
        w,
        _,
        b
      ]);
      const Z = (0, a.useRef)(!1);
      if ((0, a.useEffect)(() => {
        Z.current || (j === "afterInteractive" ? u(R) : j === "lazyOnload" && p(R), Z.current = !0);
      }, [
        R,
        j
      ]), (j === "beforeInteractive" || j === "worker") && (N ? (L[j] = (L[j] || []).concat([
        {
          id: _,
          src: b,
          onLoad: A,
          onReady: w,
          onError: B,
          ...O
        }
      ]), N(L)) : z && z() ? m.add(_ || b) : z && !z() && u(R)), $) {
        if (X && X.forEach((se) => {
          r.default.preinit(se, {
            as: "style"
          });
        }), j === "beforeInteractive")
          return b ? (r.default.preload(b, O.integrity ? {
            as: "script",
            integrity: O.integrity,
            nonce: U,
            crossOrigin: O.crossOrigin
          } : {
            as: "script",
            nonce: U,
            crossOrigin: O.crossOrigin
          }), /* @__PURE__ */ (0, t.jsx)("script", {
            nonce: U,
            dangerouslySetInnerHTML: {
              __html: "(self.__next_s=self.__next_s||[]).push(" + JSON.stringify([
                b,
                {
                  ...O,
                  id: _
                }
              ]) + ")"
            }
          })) : (O.dangerouslySetInnerHTML && (O.children = O.dangerouslySetInnerHTML.__html, delete O.dangerouslySetInnerHTML), /* @__PURE__ */ (0, t.jsx)("script", {
            nonce: U,
            dangerouslySetInnerHTML: {
              __html: "(self.__next_s=self.__next_s||[]).push(" + JSON.stringify([
                0,
                {
                  ...O,
                  id: _
                }
              ]) + ")"
            }
          }));
        j === "afterInteractive" && b && r.default.preload(b, O.integrity ? {
          as: "script",
          integrity: O.integrity,
          nonce: U,
          crossOrigin: O.crossOrigin
        } : {
          as: "script",
          nonce: U,
          crossOrigin: O.crossOrigin
        });
      }
      return null;
    }
    Object.defineProperty(y, "__nextScript", {
      value: !0
    });
    const S = y;
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(bt, bt.exports)), bt.exports;
}
var vr = {}, br = {}, Po;
function _s() {
  return Po || (Po = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(o, t) {
      for (var r in t)
        Object.defineProperty(o, r, {
          enumerable: !0,
          get: t[r]
        });
    }
    e(n, {
      getObjectClassLabel: function() {
        return s;
      },
      isPlainObject: function() {
        return i;
      }
    });
    function s(o) {
      return Object.prototype.toString.call(o);
    }
    function i(o) {
      if (s(o) !== "[object Object]")
        return !1;
      const t = Object.getPrototypeOf(o);
      return t === null || t.hasOwnProperty("isPrototypeOf");
    }
  }(br)), br;
}
var wo;
function Aa() {
  return wo || (wo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(t, r) {
      for (var a in r)
        Object.defineProperty(t, a, {
          enumerable: !0,
          get: r[a]
        });
    }
    e(n, {
      default: function() {
        return i;
      },
      getProperError: function() {
        return o;
      }
    });
    const s = _s();
    function i(t) {
      return typeof t == "object" && t !== null && "name" in t && "message" in t;
    }
    function o(t) {
      if (i(t))
        return t;
      if (process.env.NODE_ENV === "development") {
        if (typeof t > "u")
          return new Error("An undefined error was thrown, see here for more info: https://nextjs.org/docs/messages/threw-undefined");
        if (t === null)
          return new Error("A null error was thrown, see here for more info: https://nextjs.org/docs/messages/threw-undefined");
      }
      return new Error((0, s.isPlainObject)(t) ? JSON.stringify(t) : t + "");
    }
  }(vr)), vr;
}
var Sr = {}, Rr = {}, Oo;
function ys() {
  return Oo || (Oo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "normalizePathSep", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s) {
      return s.replace(/\\/g, "/");
    }
  }(Rr)), Rr;
}
var Ao;
function vs() {
  return Ao || (Ao = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "denormalizePagePath", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = ga(), s = ys();
    function i(o) {
      let t = (0, s.normalizePathSep)(o);
      return t.startsWith("/index/") && !(0, e.isDynamicRoute)(t) ? t.slice(6) : t !== "/index" ? t : "/";
    }
  }(Sr)), Sr;
}
var Er = {}, Co;
function bs() {
  return Co || (Co = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e() {
      const s = /* @__PURE__ */ Object.create(null);
      return {
        on(i, o) {
          (s[i] || (s[i] = [])).push(o);
        },
        off(i, o) {
          s[i] && s[i].splice(s[i].indexOf(o) >>> 0, 1);
        },
        emit(i) {
          for (var o = arguments.length, t = new Array(o > 1 ? o - 1 : 0), r = 1; r < o; r++)
            t[r - 1] = arguments[r];
          (s[i] || []).slice().map((a) => {
            a(...t);
          });
        }
      };
    }
  }(Er)), Er;
}
var Pr = {}, To;
function mn() {
  return To || (To = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "parseRelativeUrl", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = Ke(), s = Mt();
    function i(o, t) {
      const r = new URL(typeof window > "u" ? "http://n" : (0, e.getLocationOrigin)()), a = t ? new URL(t, r) : o.startsWith(".") ? new URL(typeof window > "u" ? "http://n" : window.location.href) : r, { pathname: d, searchParams: v, search: E, hash: h, href: m, origin: l } = new URL(o, a);
      if (l !== r.origin)
        throw new Error("invariant: invalid relative URL, router received " + o);
      return {
        pathname: d,
        query: (0, s.searchParamsToUrlQuery)(v),
        search: E,
        hash: h,
        href: m.slice(r.origin.length)
      };
    }
  }(Pr)), Pr;
}
var wr = {}, Or = {}, $e = {}, xo;
function Ca() {
  if (xo)
    return $e;
  xo = 1, Object.defineProperty($e, "__esModule", { value: !0 });
  function n(l) {
    for (var f = [], u = 0; u < l.length; ) {
      var c = l[u];
      if (c === "*" || c === "+" || c === "?") {
        f.push({ type: "MODIFIER", index: u, value: l[u++] });
        continue;
      }
      if (c === "\\") {
        f.push({ type: "ESCAPED_CHAR", index: u++, value: l[u++] });
        continue;
      }
      if (c === "{") {
        f.push({ type: "OPEN", index: u, value: l[u++] });
        continue;
      }
      if (c === "}") {
        f.push({ type: "CLOSE", index: u, value: l[u++] });
        continue;
      }
      if (c === ":") {
        for (var p = "", P = u + 1; P < l.length; ) {
          var g = l.charCodeAt(P);
          if (
            // `0-9`
            g >= 48 && g <= 57 || // `A-Z`
            g >= 65 && g <= 90 || // `a-z`
            g >= 97 && g <= 122 || // `_`
            g === 95
          ) {
            p += l[P++];
            continue;
          }
          break;
        }
        if (!p)
          throw new TypeError("Missing parameter name at " + u);
        f.push({ type: "NAME", index: u, value: p }), u = P;
        continue;
      }
      if (c === "(") {
        var y = 1, S = "", P = u + 1;
        if (l[P] === "?")
          throw new TypeError('Pattern cannot start with "?" at ' + P);
        for (; P < l.length; ) {
          if (l[P] === "\\") {
            S += l[P++] + l[P++];
            continue;
          }
          if (l[P] === ")") {
            if (y--, y === 0) {
              P++;
              break;
            }
          } else if (l[P] === "(" && (y++, l[P + 1] !== "?"))
            throw new TypeError("Capturing groups are not allowed at " + P);
          S += l[P++];
        }
        if (y)
          throw new TypeError("Unbalanced pattern at " + u);
        if (!S)
          throw new TypeError("Missing pattern at " + u);
        f.push({ type: "PATTERN", index: u, value: S }), u = P;
        continue;
      }
      f.push({ type: "CHAR", index: u, value: l[u++] });
    }
    return f.push({ type: "END", index: u, value: "" }), f;
  }
  function e(l, f) {
    f === void 0 && (f = {});
    for (var u = n(l), c = f.prefixes, p = c === void 0 ? "./" : c, P = "[^" + r(f.delimiter || "/#?") + "]+?", g = [], y = 0, S = 0, R = "", _ = function(U) {
      if (S < u.length && u[S].type === U)
        return u[S++].value;
    }, b = function(U) {
      var K = _(U);
      if (K !== void 0)
        return K;
      var Z = u[S], se = Z.type, ee = Z.index;
      throw new TypeError("Unexpected " + se + " at " + ee + ", expected " + U);
    }, A = function() {
      for (var U = "", K; K = _("CHAR") || _("ESCAPED_CHAR"); )
        U += K;
      return U;
    }; S < u.length; ) {
      var w = _("CHAR"), j = _("NAME"), B = _("PATTERN");
      if (j || B) {
        var X = w || "";
        p.indexOf(X) === -1 && (R += X, X = ""), R && (g.push(R), R = ""), g.push({
          name: j || y++,
          prefix: X,
          suffix: "",
          pattern: B || P,
          modifier: _("MODIFIER") || ""
        });
        continue;
      }
      var O = w || _("ESCAPED_CHAR");
      if (O) {
        R += O;
        continue;
      }
      R && (g.push(R), R = "");
      var N = _("OPEN");
      if (N) {
        var X = A(), L = _("NAME") || "", z = _("PATTERN") || "", $ = A();
        b("CLOSE"), g.push({
          name: L || (z ? y++ : ""),
          pattern: L && !z ? P : z,
          prefix: X,
          suffix: $,
          modifier: _("MODIFIER") || ""
        });
        continue;
      }
      b("END");
    }
    return g;
  }
  $e.parse = e;
  function s(l, f) {
    return i(e(l, f), f);
  }
  $e.compile = s;
  function i(l, f) {
    f === void 0 && (f = {});
    var u = a(f), c = f.encode, p = c === void 0 ? function(S) {
      return S;
    } : c, P = f.validate, g = P === void 0 ? !0 : P, y = l.map(function(S) {
      if (typeof S == "object")
        return new RegExp("^(?:" + S.pattern + ")$", u);
    });
    return function(S) {
      for (var R = "", _ = 0; _ < l.length; _++) {
        var b = l[_];
        if (typeof b == "string") {
          R += b;
          continue;
        }
        var A = S ? S[b.name] : void 0, w = b.modifier === "?" || b.modifier === "*", j = b.modifier === "*" || b.modifier === "+";
        if (Array.isArray(A)) {
          if (!j)
            throw new TypeError('Expected "' + b.name + '" to not repeat, but got an array');
          if (A.length === 0) {
            if (w)
              continue;
            throw new TypeError('Expected "' + b.name + '" to not be empty');
          }
          for (var B = 0; B < A.length; B++) {
            var X = p(A[B], b);
            if (g && !y[_].test(X))
              throw new TypeError('Expected all "' + b.name + '" to match "' + b.pattern + '", but got "' + X + '"');
            R += b.prefix + X + b.suffix;
          }
          continue;
        }
        if (typeof A == "string" || typeof A == "number") {
          var X = p(String(A), b);
          if (g && !y[_].test(X))
            throw new TypeError('Expected "' + b.name + '" to match "' + b.pattern + '", but got "' + X + '"');
          R += b.prefix + X + b.suffix;
          continue;
        }
        if (!w) {
          var O = j ? "an array" : "a string";
          throw new TypeError('Expected "' + b.name + '" to be ' + O);
        }
      }
      return R;
    };
  }
  $e.tokensToFunction = i;
  function o(l, f) {
    var u = [], c = m(l, u, f);
    return t(c, u, f);
  }
  $e.match = o;
  function t(l, f, u) {
    u === void 0 && (u = {});
    var c = u.decode, p = c === void 0 ? function(P) {
      return P;
    } : c;
    return function(P) {
      var g = l.exec(P);
      if (!g)
        return !1;
      for (var y = g[0], S = g.index, R = /* @__PURE__ */ Object.create(null), _ = function(A) {
        if (g[A] === void 0)
          return "continue";
        var w = f[A - 1];
        w.modifier === "*" || w.modifier === "+" ? R[w.name] = g[A].split(w.prefix + w.suffix).map(function(j) {
          return p(j, w);
        }) : R[w.name] = p(g[A], w);
      }, b = 1; b < g.length; b++)
        _(b);
      return { path: y, index: S, params: R };
    };
  }
  $e.regexpToFunction = t;
  function r(l) {
    return l.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  }
  function a(l) {
    return l && l.sensitive ? "" : "i";
  }
  function d(l, f) {
    if (!f)
      return l;
    var u = l.source.match(/\((?!\?)/g);
    if (u)
      for (var c = 0; c < u.length; c++)
        f.push({
          name: c,
          prefix: "",
          suffix: "",
          modifier: "",
          pattern: ""
        });
    return l;
  }
  function v(l, f, u) {
    var c = l.map(function(p) {
      return m(p, f, u).source;
    });
    return new RegExp("(?:" + c.join("|") + ")", a(u));
  }
  function E(l, f, u) {
    return h(e(l, u), f, u);
  }
  function h(l, f, u) {
    u === void 0 && (u = {});
    for (var c = u.strict, p = c === void 0 ? !1 : c, P = u.start, g = P === void 0 ? !0 : P, y = u.end, S = y === void 0 ? !0 : y, R = u.encode, _ = R === void 0 ? function(U) {
      return U;
    } : R, b = "[" + r(u.endsWith || "") + "]|$", A = "[" + r(u.delimiter || "/#?") + "]", w = g ? "^" : "", j = 0, B = l; j < B.length; j++) {
      var X = B[j];
      if (typeof X == "string")
        w += r(_(X));
      else {
        var O = r(_(X.prefix)), N = r(_(X.suffix));
        if (X.pattern)
          if (f && f.push(X), O || N)
            if (X.modifier === "+" || X.modifier === "*") {
              var L = X.modifier === "*" ? "?" : "";
              w += "(?:" + O + "((?:" + X.pattern + ")(?:" + N + O + "(?:" + X.pattern + "))*)" + N + ")" + L;
            } else
              w += "(?:" + O + "(" + X.pattern + ")" + N + ")" + X.modifier;
          else
            w += "(" + X.pattern + ")" + X.modifier;
        else
          w += "(?:" + O + N + ")" + X.modifier;
      }
    }
    if (S)
      p || (w += A + "?"), w += u.endsWith ? "(?=" + b + ")" : "$";
    else {
      var z = l[l.length - 1], $ = typeof z == "string" ? A.indexOf(z[z.length - 1]) > -1 : (
        // tslint:disable-next-line
        z === void 0
      );
      p || (w += "(?:" + A + "(?=" + b + "))?"), $ || (w += "(?=" + A + "|" + b + ")");
    }
    return new RegExp(w, a(u));
  }
  $e.tokensToRegexp = h;
  function m(l, f, u) {
    return l instanceof RegExp ? d(l, f) : Array.isArray(l) ? v(l, f, u) : E(l, f, u);
  }
  return $e.pathToRegexp = m, $e;
}
var Lo;
function Ss() {
  return Lo || (Lo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "getPathMatch", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const e = Ca();
    function s(i, o) {
      const t = [], r = (0, e.pathToRegexp)(i, t, {
        delimiter: "/",
        sensitive: typeof (o == null ? void 0 : o.sensitive) == "boolean" ? o.sensitive : !1,
        strict: o == null ? void 0 : o.strict
      }), a = (0, e.regexpToFunction)(o != null && o.regexModifier ? new RegExp(o.regexModifier(r.source), r.flags) : r, t);
      return (d, v) => {
        if (typeof d != "string")
          return !1;
        const E = a(d);
        if (!E)
          return !1;
        if (o != null && o.removeUnnamedParams)
          for (const h of t)
            typeof h.name == "number" && delete E.params[h.name];
        return {
          ...v,
          ...E.params
        };
      };
    }
  }(Or)), Or;
}
var Ar = {}, Cr = {}, Mo;
function Rs() {
  return Mo || (Mo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "parseUrl", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = Mt(), s = mn();
    function i(o) {
      if (o.startsWith("/"))
        return (0, s.parseRelativeUrl)(o);
      const t = new URL(o);
      return {
        hash: t.hash,
        hostname: t.hostname,
        href: t.href,
        pathname: t.pathname,
        port: t.port,
        protocol: t.protocol,
        query: (0, e.searchParamsToUrlQuery)(t.searchParams),
        search: t.search
      };
    }
  }(Cr)), Cr;
}
var Rt = { exports: {} }, No;
function Es() {
  return No || (No = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function s(m, l) {
      for (var f in l)
        Object.defineProperty(m, f, {
          enumerable: !0,
          get: l[f]
        });
    }
    s(e, {
      ACTION: function() {
        return o;
      },
      FLIGHT_PARAMETERS: function() {
        return v;
      },
      NEXT_DID_POSTPONE_HEADER: function() {
        return h;
      },
      NEXT_ROUTER_PREFETCH_HEADER: function() {
        return r;
      },
      NEXT_ROUTER_STATE_TREE: function() {
        return t;
      },
      NEXT_RSC_UNION_QUERY: function() {
        return E;
      },
      NEXT_URL: function() {
        return a;
      },
      RSC_CONTENT_TYPE_HEADER: function() {
        return d;
      },
      RSC_HEADER: function() {
        return i;
      }
    });
    const i = "RSC", o = "Next-Action", t = "Next-Router-State-Tree", r = "Next-Router-Prefetch", a = "Next-Url", d = "text/x-component", v = [
      [
        i
      ],
      [
        t
      ],
      [
        r
      ]
    ], E = "_rsc", h = "x-nextjs-postponed";
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(Rt, Rt.exports)), Rt.exports;
}
var Tr = {}, xr = { exports: {} }, Io;
function Ps() {
  return Io || (Io = 1, (() => {
    typeof __nccwpck_require__ < "u" && (__nccwpck_require__.ab = __dirname + "/");
    var n = {};
    (() => {
      var e = n;
      /*!
       * cookie
       * Copyright(c) 2012-2014 Roman Shtylman
       * Copyright(c) 2015 Douglas Christopher Wilson
       * MIT Licensed
       */
      e.parse = r, e.serialize = a;
      var s = decodeURIComponent, i = encodeURIComponent, o = /; */, t = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
      function r(v, E) {
        if (typeof v != "string")
          throw new TypeError("argument str must be a string");
        for (var h = {}, m = E || {}, l = v.split(o), f = m.decode || s, u = 0; u < l.length; u++) {
          var c = l[u], p = c.indexOf("=");
          if (!(p < 0)) {
            var P = c.substr(0, p).trim(), g = c.substr(++p, c.length).trim();
            g[0] == '"' && (g = g.slice(1, -1)), h[P] == null && (h[P] = d(g, f));
          }
        }
        return h;
      }
      function a(v, E, h) {
        var m = h || {}, l = m.encode || i;
        if (typeof l != "function")
          throw new TypeError("option encode is invalid");
        if (!t.test(v))
          throw new TypeError("argument name is invalid");
        var f = l(E);
        if (f && !t.test(f))
          throw new TypeError("argument val is invalid");
        var u = v + "=" + f;
        if (m.maxAge != null) {
          var c = m.maxAge - 0;
          if (isNaN(c) || !isFinite(c))
            throw new TypeError("option maxAge is invalid");
          u += "; Max-Age=" + Math.floor(c);
        }
        if (m.domain) {
          if (!t.test(m.domain))
            throw new TypeError("option domain is invalid");
          u += "; Domain=" + m.domain;
        }
        if (m.path) {
          if (!t.test(m.path))
            throw new TypeError("option path is invalid");
          u += "; Path=" + m.path;
        }
        if (m.expires) {
          if (typeof m.expires.toUTCString != "function")
            throw new TypeError("option expires is invalid");
          u += "; Expires=" + m.expires.toUTCString();
        }
        if (m.httpOnly && (u += "; HttpOnly"), m.secure && (u += "; Secure"), m.sameSite) {
          var p = typeof m.sameSite == "string" ? m.sameSite.toLowerCase() : m.sameSite;
          switch (p) {
            case !0:
              u += "; SameSite=Strict";
              break;
            case "lax":
              u += "; SameSite=Lax";
              break;
            case "strict":
              u += "; SameSite=Strict";
              break;
            case "none":
              u += "; SameSite=None";
              break;
            default:
              throw new TypeError("option sameSite is invalid");
          }
        }
        return u;
      }
      function d(v, E) {
        try {
          return E(v);
        } catch {
          return v;
        }
      }
    })(), xr.exports = n;
  })()), xr.exports;
}
var jo;
function ws() {
  return jo || (jo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "getCookieParser", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s) {
      return function() {
        const { cookie: o } = s;
        if (!o)
          return {};
        const { parse: t } = Ps();
        return t(Array.isArray(o) ? o.join("; ") : o);
      };
    }
  }(Tr)), Tr;
}
var Do;
function Os() {
  return Do || (Do = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(f, u) {
      for (var c in u)
        Object.defineProperty(f, c, {
          enumerable: !0,
          get: u[c]
        });
    }
    e(n, {
      compileNonPath: function() {
        return m;
      },
      matchHas: function() {
        return h;
      },
      prepareDestination: function() {
        return l;
      }
    });
    const s = Ca(), i = ya(), o = Rs(), t = fn(), r = Es(), a = ws();
    function d(f) {
      let u = "";
      for (let c = 0; c < f.length; c++) {
        const p = f.charCodeAt(c);
        (p > 64 && p < 91 || // A-Z
        p > 96 && p < 123) && (u += f[c]);
      }
      return u;
    }
    function v(f, u) {
      return f.replace(new RegExp(":" + (0, i.escapeStringRegexp)(u), "g"), "__ESC_COLON_" + u);
    }
    function E(f) {
      return f.replace(/__ESC_COLON_/gi, ":");
    }
    function h(f, u, c, p) {
      c === void 0 && (c = []), p === void 0 && (p = []);
      const P = {}, g = (S) => {
        let R, _ = S.key;
        switch (S.type) {
          case "header": {
            _ = _.toLowerCase(), R = f.headers[_];
            break;
          }
          case "cookie": {
            "cookies" in f ? R = f.cookies[S.key] : R = (0, a.getCookieParser)(f.headers)()[S.key];
            break;
          }
          case "query": {
            R = u[_];
            break;
          }
          case "host": {
            const { host: b } = (f == null ? void 0 : f.headers) || {};
            R = b == null ? void 0 : b.split(":", 1)[0].toLowerCase();
            break;
          }
        }
        if (!S.value && R)
          return P[d(_)] = R, !0;
        if (R) {
          const b = new RegExp("^" + S.value + "$"), A = Array.isArray(R) ? R.slice(-1)[0].match(b) : R.match(b);
          if (A)
            return Array.isArray(A) && (A.groups ? Object.keys(A.groups).forEach((w) => {
              P[w] = A.groups[w];
            }) : S.type === "host" && A[0] && (P.host = A[0])), !0;
        }
        return !1;
      };
      return c.every((S) => g(S)) && !p.some((S) => g(S)) ? P : !1;
    }
    function m(f, u) {
      if (!f.includes(":"))
        return f;
      for (const c of Object.keys(u))
        f.includes(":" + c) && (f = f.replace(new RegExp(":" + c + "\\*", "g"), ":" + c + "--ESCAPED_PARAM_ASTERISKS").replace(new RegExp(":" + c + "\\?", "g"), ":" + c + "--ESCAPED_PARAM_QUESTION").replace(new RegExp(":" + c + "\\+", "g"), ":" + c + "--ESCAPED_PARAM_PLUS").replace(new RegExp(":" + c + "(?!\\w)", "g"), "--ESCAPED_PARAM_COLON" + c));
      return f = f.replace(/(:|\*|\?|\+|\(|\)|\{|\})/g, "\\$1").replace(/--ESCAPED_PARAM_PLUS/g, "+").replace(/--ESCAPED_PARAM_COLON/g, ":").replace(/--ESCAPED_PARAM_QUESTION/g, "?").replace(/--ESCAPED_PARAM_ASTERISKS/g, "*"), (0, s.compile)("/" + f, {
        validate: !1
      })(u).slice(1);
    }
    function l(f) {
      const u = Object.assign({}, f.query);
      delete u.__nextLocale, delete u.__nextDefaultLocale, delete u.__nextDataReq, delete u.__nextInferredLocaleFromDefault, delete u[r.NEXT_RSC_UNION_QUERY];
      let c = f.destination;
      for (const B of Object.keys({
        ...f.params,
        ...u
      }))
        c = v(c, B);
      const p = (0, o.parseUrl)(c), P = p.query, g = E("" + p.pathname + (p.hash || "")), y = E(p.hostname || ""), S = [], R = [];
      (0, s.pathToRegexp)(g, S), (0, s.pathToRegexp)(y, R);
      const _ = [];
      S.forEach((B) => _.push(B.name)), R.forEach((B) => _.push(B.name));
      const b = (0, s.compile)(
        g,
        // we don't validate while compiling the destination since we should
        // have already validated before we got to this point and validating
        // breaks compiling destinations with named pattern params from the source
        // e.g. /something:hello(.*) -> /another/:hello is broken with validation
        // since compile validation is meant for reversing and not for inserting
        // params from a separate path-regex into another
        {
          validate: !1
        }
      ), A = (0, s.compile)(y, {
        validate: !1
      });
      for (const [B, X] of Object.entries(P))
        Array.isArray(X) ? P[B] = X.map((O) => m(E(O), f.params)) : typeof X == "string" && (P[B] = m(E(X), f.params));
      let w = Object.keys(f.params).filter((B) => B !== "nextInternalLocale");
      if (f.appendParamsToQuery && !w.some((B) => _.includes(B)))
        for (const B of w)
          B in P || (P[B] = f.params[B]);
      let j;
      if ((0, t.isInterceptionRouteAppPath)(g))
        for (const B of g.split("/")) {
          const X = t.INTERCEPTION_ROUTE_MARKERS.find((O) => B.startsWith(O));
          if (X) {
            f.params[0] = X;
            break;
          }
        }
      try {
        j = b(f.params);
        const [B, X] = j.split("#", 2);
        p.hostname = A(f.params), p.pathname = B, p.hash = (X ? "#" : "") + (X || ""), delete p.search;
      } catch (B) {
        throw B.message.match(/Expected .*? to not repeat, but got an array/) ? new Error("To use a multi-match in the destination you must add `*` at the end of the param name to signify it should repeat. https://nextjs.org/docs/messages/invalid-multi-match") : B;
      }
      return p.query = {
        ...u,
        ...p.query
      }, {
        newUrl: j,
        destQuery: P,
        parsedDestination: p
      };
    }
  }(Ar)), Ar;
}
var Et = { exports: {} }, qo;
function Ta() {
  return qo || (qo = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "removeBasePath", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const s = un(), i = process.env.__NEXT_ROUTER_BASEPATH || "";
    function o(t) {
      return process.env.__NEXT_MANUAL_CLIENT_BASE_PATH && !(0, s.hasBasePath)(t) || i.length === 0 || (t = t.slice(i.length), t.startsWith("/") || (t = "/" + t)), t;
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(Et, Et.exports)), Et.exports;
}
var Ho;
function As() {
  return Ho || (Ho = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "default", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const e = Ss(), s = Os(), i = nt(), o = jt(), t = Ta(), r = mn();
    function a(d, v, E, h, m, l) {
      let f = !1, u = !1, c = (0, r.parseRelativeUrl)(d), p = (0, i.removeTrailingSlash)((0, o.normalizeLocalePath)((0, t.removeBasePath)(c.pathname), l).pathname), P;
      const g = (S) => {
        let _ = (0, e.getPathMatch)(S.source + (process.env.__NEXT_TRAILING_SLASH ? "(/)?" : ""), {
          removeUnnamedParams: !0,
          strict: !0
        })(c.pathname);
        if ((S.has || S.missing) && _) {
          const b = (0, s.matchHas)({
            headers: {
              host: document.location.hostname,
              "user-agent": navigator.userAgent
            },
            cookies: document.cookie.split("; ").reduce((A, w) => {
              const [j, ...B] = w.split("=");
              return A[j] = B.join("="), A;
            }, {})
          }, c.query, S.has, S.missing);
          b ? Object.assign(_, b) : _ = !1;
        }
        if (_) {
          if (!S.destination)
            return u = !0, !0;
          const b = (0, s.prepareDestination)({
            appendParamsToQuery: !0,
            destination: S.destination,
            params: _,
            query: h
          });
          if (c = b.parsedDestination, d = b.newUrl, Object.assign(h, b.parsedDestination.query), p = (0, i.removeTrailingSlash)((0, o.normalizeLocalePath)((0, t.removeBasePath)(d), l).pathname), v.includes(p))
            return f = !0, P = p, !0;
          if (P = m(p), P !== d && v.includes(P))
            return f = !0, !0;
        }
      };
      let y = !1;
      for (let S = 0; S < E.beforeFiles.length; S++)
        g(E.beforeFiles[S]);
      if (f = v.includes(p), !f) {
        if (!y) {
          for (let S = 0; S < E.afterFiles.length; S++)
            if (g(E.afterFiles[S])) {
              y = !0;
              break;
            }
        }
        if (y || (P = m(p), f = v.includes(P), y = f), !y) {
          for (let S = 0; S < E.fallback.length; S++)
            if (g(E.fallback[S])) {
              y = !0;
              break;
            }
        }
      }
      return {
        asPath: d,
        parsedAs: c,
        matchedPage: f,
        resolvedHref: P,
        externalDest: u
      };
    }
  }(wr)), wr;
}
var Pt = { exports: {} }, $o;
function Cs() {
  return $o || ($o = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "removeLocale", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const s = Ye();
    function i(o, t) {
      if (process.env.__NEXT_I18N_SUPPORT) {
        const { pathname: r } = (0, s.parsePath)(o), a = r.toLowerCase(), d = t == null ? void 0 : t.toLowerCase();
        return t && (a.startsWith("/" + d + "/") || a === "/" + d) ? (r.length === t.length + 1 ? "/" : "") + o.slice(t.length + 1) : o;
      }
      return o;
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(Pt, Pt.exports)), Pt.exports;
}
var Lr = {}, ko;
function Ts() {
  return ko || (ko = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "isAPIRoute", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s) {
      return s === "/api" || !!(s != null && s.startsWith("/api/"));
    }
  }(Lr)), Lr;
}
var Mr = {}, Nr = {}, Uo;
function xs() {
  return Uo || (Uo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "removePathPrefix", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const e = It();
    function s(i, o) {
      if (!(0, e.pathHasPrefix)(i, o))
        return i;
      const t = i.slice(o.length);
      return t.startsWith("/") ? t : "/" + t;
    }
  }(Nr)), Nr;
}
var Bo;
function Ls() {
  return Bo || (Bo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "getNextPathnameInfo", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const e = jt(), s = xs(), i = It();
    function o(t, r) {
      var a;
      const { basePath: d, i18n: v, trailingSlash: E } = (a = r.nextConfig) != null ? a : {}, h = {
        pathname: t,
        trailingSlash: t !== "/" ? t.endsWith("/") : E
      };
      d && (0, i.pathHasPrefix)(h.pathname, d) && (h.pathname = (0, s.removePathPrefix)(h.pathname, d), h.basePath = d);
      let m = h.pathname;
      if (h.pathname.startsWith("/_next/data/") && h.pathname.endsWith(".json")) {
        const f = h.pathname.replace(/^\/_next\/data\//, "").replace(/\.json$/, "").split("/"), u = f[0];
        h.buildId = u, m = f[1] !== "index" ? "/" + f.slice(1).join("/") : "/", r.parseData === !0 && (h.pathname = m);
      }
      if (v) {
        let f = r.i18nProvider ? r.i18nProvider.analyze(h.pathname) : (0, e.normalizeLocalePath)(h.pathname, v.locales);
        h.locale = f.detectedLocale;
        var l;
        h.pathname = (l = f.pathname) != null ? l : h.pathname, !f.detectedLocale && h.buildId && (f = r.i18nProvider ? r.i18nProvider.analyze(m) : (0, e.normalizeLocalePath)(m, v.locales), f.detectedLocale && (h.locale = f.detectedLocale));
      }
      return h;
    }
  }(Mr)), Mr;
}
var Ir = {}, jr = {}, Fo;
function Ms() {
  return Fo || (Fo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "addPathSuffix", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const e = Ye();
    function s(i, o) {
      if (!i.startsWith("/") || !o)
        return i;
      const { pathname: t, query: r, hash: a } = (0, e.parsePath)(i);
      return "" + t + o + r + a;
    }
  }(jr)), jr;
}
var zo;
function Ns() {
  return zo || (zo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "formatNextPathnameInfo", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    const e = nt(), s = dn(), i = Ms(), o = Ra();
    function t(r) {
      let a = (0, o.addLocale)(r.pathname, r.locale, r.buildId ? void 0 : r.defaultLocale, r.ignorePrefix);
      return (r.buildId || !r.trailingSlash) && (a = (0, e.removeTrailingSlash)(a)), r.buildId && (a = (0, i.addPathSuffix)((0, s.addPathPrefix)(a, "/_next/data/" + r.buildId), r.pathname === "/" ? "index.json" : ".json")), a = (0, s.addPathPrefix)(a, r.basePath), !r.buildId && r.trailingSlash ? a.endsWith("/") ? a : (0, i.addPathSuffix)(a, "/") : (0, e.removeTrailingSlash)(a);
    }
  }(Ir)), Ir;
}
var Dr = {}, Go;
function Is() {
  return Go || (Go = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "compareRouterStates", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s, i) {
      const o = Object.keys(s);
      if (o.length !== Object.keys(i).length)
        return !1;
      for (let t = o.length; t--; ) {
        const r = o[t];
        if (r === "query") {
          const a = Object.keys(s.query);
          if (a.length !== Object.keys(i.query).length)
            return !1;
          for (let d = a.length; d--; ) {
            const v = a[d];
            if (!i.query.hasOwnProperty(v) || s.query[v] !== i.query[v])
              return !1;
          }
        } else if (!i.hasOwnProperty(r) || s[r] !== i[r])
          return !1;
      }
      return !0;
    }
  }(Dr)), Dr;
}
var qr = {}, Wo;
function js() {
  return Wo || (Wo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "isBot", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s) {
      return /Googlebot|Mediapartners-Google|AdsBot-Google|googleweblight|Storebot-Google|Google-PageRenderer|Bingbot|BingPreview|Slurp|DuckDuckBot|baiduspider|yandex|sogou|LinkedInBot|bitlybot|tumblr|vkShare|quora link preview|facebookexternalhit|facebookcatalog|Twitterbot|applebot|redditbot|Slackbot|Discordbot|WhatsApp|SkypeUriPreview|ia_archiver/i.test(s);
    }
  }(qr)), qr;
}
var Hr = {}, Vo;
function Ds() {
  return Vo || (Vo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "handleSmoothScroll", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(s, i) {
      if (i === void 0 && (i = {}), i.onlyHashChange) {
        s();
        return;
      }
      const o = document.documentElement, t = o.style.scrollBehavior;
      o.style.scrollBehavior = "auto", i.dontForceLayout || o.getClientRects(), s(), o.style.scrollBehavior = t;
    }
  }(Hr)), Hr;
}
var wt = { exports: {} }, _e = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xo;
function qs() {
  if (Xo)
    return _e;
  Xo = 1;
  var n = Symbol.for("react.element"), e = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), r = Symbol.for("react.context"), a = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), l = Symbol.for("react.offscreen"), f;
  f = Symbol.for("react.module.reference");
  function u(c) {
    if (typeof c == "object" && c !== null) {
      var p = c.$$typeof;
      switch (p) {
        case n:
          switch (c = c.type, c) {
            case s:
            case o:
            case i:
            case v:
            case E:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case a:
                case r:
                case d:
                case m:
                case h:
                case t:
                  return c;
                default:
                  return p;
              }
          }
        case e:
          return p;
      }
    }
  }
  return _e.ContextConsumer = r, _e.ContextProvider = t, _e.Element = n, _e.ForwardRef = d, _e.Fragment = s, _e.Lazy = m, _e.Memo = h, _e.Portal = e, _e.Profiler = o, _e.StrictMode = i, _e.Suspense = v, _e.SuspenseList = E, _e.isAsyncMode = function() {
    return !1;
  }, _e.isConcurrentMode = function() {
    return !1;
  }, _e.isContextConsumer = function(c) {
    return u(c) === r;
  }, _e.isContextProvider = function(c) {
    return u(c) === t;
  }, _e.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === n;
  }, _e.isForwardRef = function(c) {
    return u(c) === d;
  }, _e.isFragment = function(c) {
    return u(c) === s;
  }, _e.isLazy = function(c) {
    return u(c) === m;
  }, _e.isMemo = function(c) {
    return u(c) === h;
  }, _e.isPortal = function(c) {
    return u(c) === e;
  }, _e.isProfiler = function(c) {
    return u(c) === o;
  }, _e.isStrictMode = function(c) {
    return u(c) === i;
  }, _e.isSuspense = function(c) {
    return u(c) === v;
  }, _e.isSuspenseList = function(c) {
    return u(c) === E;
  }, _e.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === s || c === o || c === i || c === v || c === E || c === l || typeof c == "object" && c !== null && (c.$$typeof === m || c.$$typeof === h || c.$$typeof === t || c.$$typeof === r || c.$$typeof === d || c.$$typeof === f || c.getModuleId !== void 0);
  }, _e.typeOf = u, _e;
}
var ye = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ko;
function Hs() {
  return Ko || (Ko = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Symbol.for("react.element"), e = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), r = Symbol.for("react.context"), a = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), l = Symbol.for("react.offscreen"), f = !1, u = !1, c = !1, p = !1, P = !1, g;
    g = Symbol.for("react.module.reference");
    function y(q) {
      return !!(typeof q == "string" || typeof q == "function" || q === s || q === o || P || q === i || q === v || q === E || p || q === l || f || u || c || typeof q == "object" && q !== null && (q.$$typeof === m || q.$$typeof === h || q.$$typeof === t || q.$$typeof === r || q.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      q.$$typeof === g || q.getModuleId !== void 0));
    }
    function S(q) {
      if (typeof q == "object" && q !== null) {
        var W = q.$$typeof;
        switch (W) {
          case n:
            var H = q.type;
            switch (H) {
              case s:
              case o:
              case i:
              case v:
              case E:
                return H;
              default:
                var D = H && H.$$typeof;
                switch (D) {
                  case a:
                  case r:
                  case d:
                  case m:
                  case h:
                  case t:
                    return D;
                  default:
                    return W;
                }
            }
          case e:
            return W;
        }
      }
    }
    var R = r, _ = t, b = n, A = d, w = s, j = m, B = h, X = e, O = o, N = i, L = v, z = E, $ = !1, U = !1;
    function K(q) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Z(q) {
      return U || (U = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function se(q) {
      return S(q) === r;
    }
    function ee(q) {
      return S(q) === t;
    }
    function ce(q) {
      return typeof q == "object" && q !== null && q.$$typeof === n;
    }
    function ae(q) {
      return S(q) === d;
    }
    function pe(q) {
      return S(q) === s;
    }
    function M(q) {
      return S(q) === m;
    }
    function le(q) {
      return S(q) === h;
    }
    function me(q) {
      return S(q) === e;
    }
    function he(q) {
      return S(q) === o;
    }
    function T(q) {
      return S(q) === i;
    }
    function x(q) {
      return S(q) === v;
    }
    function Re(q) {
      return S(q) === E;
    }
    ye.ContextConsumer = R, ye.ContextProvider = _, ye.Element = b, ye.ForwardRef = A, ye.Fragment = w, ye.Lazy = j, ye.Memo = B, ye.Portal = X, ye.Profiler = O, ye.StrictMode = N, ye.Suspense = L, ye.SuspenseList = z, ye.isAsyncMode = K, ye.isConcurrentMode = Z, ye.isContextConsumer = se, ye.isContextProvider = ee, ye.isElement = ce, ye.isForwardRef = ae, ye.isFragment = pe, ye.isLazy = M, ye.isMemo = le, ye.isPortal = me, ye.isProfiler = he, ye.isStrictMode = T, ye.isSuspense = x, ye.isSuspenseList = Re, ye.isValidElementType = y, ye.typeOf = S;
  }()), ye;
}
var Yo;
function $s() {
  return Yo || (Yo = 1, process.env.NODE_ENV === "production" ? wt.exports = qs() : wt.exports = Hs()), wt.exports;
}
var $r = {}, kr = { exports: {} };
const ks = {}, Us = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ks
}, Symbol.toStringTag, { value: "Module" })), Ur = /* @__PURE__ */ $i(Us);
var Qo;
function Bs() {
  return Qo || (Qo = 1, (() => {
    var n = { 154: (o, t, r) => {
      var a = r(781), d = ["write", "end", "destroy"], v = ["resume", "pause"], E = ["data", "close"], h = Array.prototype.slice;
      o.exports = l;
      function m(f, u) {
        if (f.forEach)
          return f.forEach(u);
        for (var c = 0; c < f.length; c++)
          u(f[c], c);
      }
      function l(f, u) {
        var c = new a(), p = !1;
        return m(d, P), m(v, g), m(E, y), u.on("end", S), f.on("drain", function() {
          c.emit("drain");
        }), f.on("error", R), u.on("error", R), c.writable = f.writable, c.readable = u.readable, c;
        function P(_) {
          c[_] = b;
          function b() {
            return f[_].apply(f, arguments);
          }
        }
        function g(_) {
          c[_] = b;
          function b() {
            c.emit(_);
            var A = u[_];
            if (A)
              return A.apply(u, arguments);
            u.emit(_);
          }
        }
        function y(_) {
          u.on(_, b);
          function b() {
            var A = h.call(arguments);
            A.unshift(_), c.emit.apply(c, A);
          }
        }
        function S() {
          if (!p) {
            p = !0;
            var _ = h.call(arguments);
            _.unshift("end"), c.emit.apply(c, _);
          }
        }
        function R(_) {
          c.emit("error", _);
        }
      }
    }, 349: (o, t, r) => {
      const a = r(147), d = r(781), v = r(796), E = r(154), h = r(530), m = (l) => Object.assign({ level: 9 }, l);
      o.exports = (l, f) => l ? h(v.gzip)(l, m(f)).then((u) => u.length).catch((u) => 0) : Promise.resolve(0), o.exports.sync = (l, f) => v.gzipSync(l, m(f)).length, o.exports.stream = (l) => {
        const f = new d.PassThrough(), u = new d.PassThrough(), c = E(f, u);
        let p = 0;
        const P = v.createGzip(m(l)).on("data", (g) => {
          p += g.length;
        }).on("error", () => {
          c.gzipSize = 0;
        }).on("end", () => {
          c.gzipSize = p, c.emit("gzip-size", p), u.end();
        });
        return f.pipe(P), f.pipe(u, { end: !1 }), c;
      }, o.exports.file = (l, f) => new Promise((u, c) => {
        const p = a.createReadStream(l);
        p.on("error", c);
        const P = p.pipe(o.exports.stream(f));
        P.on("error", c), P.on("gzip-size", u);
      }), o.exports.fileSync = (l, f) => o.exports.sync(a.readFileSync(l), f);
    }, 530: (o) => {
      const t = (r, a) => function(...d) {
        const v = a.promiseModule;
        return new v((E, h) => {
          a.multiArgs ? d.push((...m) => {
            a.errorFirst ? m[0] ? h(m) : (m.shift(), E(m)) : E(m);
          }) : a.errorFirst ? d.push((m, l) => {
            m ? h(m) : E(l);
          }) : d.push(E), r.apply(this, d);
        });
      };
      o.exports = (r, a) => {
        a = Object.assign({ exclude: [/.+(Sync|Stream)$/], errorFirst: !0, promiseModule: Promise }, a);
        const d = typeof r;
        if (!(r !== null && (d === "object" || d === "function")))
          throw new TypeError(`Expected \`input\` to be a \`Function\` or \`Object\`, got \`${r === null ? "null" : d}\``);
        const v = (h) => {
          const m = (l) => typeof l == "string" ? h === l : l.test(h);
          return a.include ? a.include.some(m) : !a.exclude.some(m);
        };
        let E;
        d === "function" ? E = function(...h) {
          return a.excludeMain ? r(...h) : t(r, a).apply(this, h);
        } : E = Object.create(Object.getPrototypeOf(r));
        for (const h in r) {
          const m = r[h];
          E[h] = typeof m == "function" && v(h) ? t(m, a) : m;
        }
        return E;
      };
    }, 147: (o) => {
      o.exports = Ur;
    }, 781: (o) => {
      o.exports = Ur;
    }, 796: (o) => {
      o.exports = Ur;
    } }, e = {};
    function s(o) {
      var t = e[o];
      if (t !== void 0)
        return t.exports;
      var r = e[o] = { exports: {} }, a = !0;
      try {
        n[o](r, r.exports, s), a = !1;
      } finally {
        a && delete e[o];
      }
      return r.exports;
    }
    typeof s < "u" && (s.ab = __dirname + "/");
    var i = s(349);
    kr.exports = i;
  })()), kr.exports;
}
var Jo;
function Fs() {
  return Jo || (Jo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "BloomFilter", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    function e(o) {
      let t = 0;
      for (let r = 0; r < o.length; r++) {
        const a = o.charCodeAt(r);
        t = Math.imul(t ^ a, 1540483477), t ^= t >>> 13, t = Math.imul(t, 1540483477);
      }
      return t >>> 0;
    }
    const s = 1e-4;
    class i {
      static from(t, r) {
        r === void 0 && (r = s);
        const a = new i(t.length, r);
        for (const d of t)
          a.add(d);
        return a;
      }
      export() {
        const t = {
          numItems: this.numItems,
          errorRate: this.errorRate,
          numBits: this.numBits,
          numHashes: this.numHashes,
          bitArray: this.bitArray
        };
        if (process.env.NEXT_RUNTIME === "nodejs" && this.errorRate < s) {
          const r = JSON.stringify(t), a = Bs().sync(r);
          a > 1024 && console.warn("Creating filter with error rate less than 0.1% (0.001) can increase the size dramatically proceed with caution. Received error rate " + this.errorRate + " resulted in size " + r.length + " bytes, " + a + " bytes (gzip)");
        }
        return t;
      }
      import(t) {
        this.numItems = t.numItems, this.errorRate = t.errorRate, this.numBits = t.numBits, this.numHashes = t.numHashes, this.bitArray = t.bitArray;
      }
      add(t) {
        this.getHashValues(t).forEach((a) => {
          this.bitArray[a] = 1;
        });
      }
      contains(t) {
        return this.getHashValues(t).every((a) => this.bitArray[a]);
      }
      getHashValues(t) {
        const r = [];
        for (let a = 1; a <= this.numHashes; a++) {
          const d = e("" + t + a) % this.numBits;
          r.push(d);
        }
        return r;
      }
      constructor(t, r = s) {
        this.numItems = t, this.errorRate = r, this.numBits = Math.ceil(-(t * Math.log(r)) / (Math.log(2) * Math.log(2))), this.numHashes = Math.ceil(this.numBits / t * Math.log(2)), this.bitArray = new Array(this.numBits).fill(0);
      }
    }
  }($r)), $r;
}
var Zo;
function zs() {
  return Zo || (Zo = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(W, H) {
      for (var D in H)
        Object.defineProperty(W, D, {
          enumerable: !0,
          get: H[D]
        });
    }
    e(n, {
      createKey: function() {
        return T;
      },
      default: function() {
        return q;
      },
      matchesMiddleware: function() {
        return K;
      }
    });
    const s = Te, i = Be, o = nt(), t = hs(), r = gs(), a = /* @__PURE__ */ i._(Aa()), d = vs(), v = jt(), E = /* @__PURE__ */ s._(bs()), h = Ke(), m = ma(), l = mn(), f = /* @__PURE__ */ s._(As()), u = _a(), c = va(), p = sn(), P = Pa(), g = Ye(), y = Ea(), S = Cs(), R = Ta(), _ = wa(), b = un(), A = Sa(), w = Ts(), j = Ls(), B = Ns(), X = Is(), O = cn(), N = js(), L = ha(), z = ba(), $ = Ds();
    function U() {
      return Object.assign(new Error("Route Cancelled"), {
        cancelled: !0
      });
    }
    async function K(W) {
      const H = await Promise.resolve(W.router.pageLoader.getMiddleware());
      if (!H)
        return !1;
      const { pathname: D } = (0, g.parsePath)(W.asPath), C = (0, b.hasBasePath)(D) ? (0, R.removeBasePath)(D) : D, F = (0, _.addBasePath)((0, y.addLocale)(C, W.locale));
      return H.some((ue) => new RegExp(ue.regexp).test(F));
    }
    function Z(W) {
      const H = (0, h.getLocationOrigin)();
      return W.startsWith(H) ? W.substring(H.length) : W;
    }
    function se(W, H, D) {
      let [C, F] = (0, A.resolveHref)(W, H, !0);
      const ue = (0, h.getLocationOrigin)(), oe = C.startsWith(ue), k = F && F.startsWith(ue);
      C = Z(C), F = F && Z(F);
      const ne = oe ? C : (0, _.addBasePath)(C), J = D ? Z((0, A.resolveHref)(W, D)) : F || C;
      return {
        url: ne,
        as: k ? J : (0, _.addBasePath)(J)
      };
    }
    function ee(W, H) {
      const D = (0, o.removeTrailingSlash)((0, d.denormalizePagePath)(W));
      return D === "/404" || D === "/_error" ? W : (H.includes(D) || H.some((C) => {
        if ((0, m.isDynamicRoute)(C) && (0, c.getRouteRegex)(C).re.test(D))
          return W = C, !0;
      }), (0, o.removeTrailingSlash)(W));
    }
    function ce(W, H, D) {
      const C = {
        basePath: D.router.basePath,
        i18n: {
          locales: D.router.locales
        },
        trailingSlash: !!process.env.__NEXT_TRAILING_SLASH
      }, F = H.headers.get("x-nextjs-rewrite");
      let ue = F || H.headers.get("x-nextjs-matched-path");
      const oe = H.headers.get("x-matched-path");
      if (oe && !ue && !oe.includes("__next_data_catchall") && !oe.includes("/_error") && !oe.includes("/404") && (ue = oe), ue) {
        if (ue.startsWith("/") || process.env.__NEXT_EXTERNAL_MIDDLEWARE_REWRITE_RESOLVE) {
          const G = (0, l.parseRelativeUrl)(ue), Y = (0, j.getNextPathnameInfo)(G.pathname, {
            nextConfig: C,
            parseData: !0
          });
          let I = (0, o.removeTrailingSlash)(Y.pathname);
          return Promise.all([
            D.router.pageLoader.getPageList(),
            (0, t.getClientBuildManifest)()
          ]).then((V) => {
            let [Q, { __rewrites: te }] = V, ie = (0, y.addLocale)(Y.pathname, Y.locale);
            if ((0, m.isDynamicRoute)(ie) || !F && Q.includes((0, v.normalizeLocalePath)((0, R.removeBasePath)(ie), D.router.locales).pathname)) {
              const Se = (0, j.getNextPathnameInfo)((0, l.parseRelativeUrl)(W).pathname, {
                nextConfig: process.env.__NEXT_HAS_REWRITES ? void 0 : C,
                parseData: !0
              });
              ie = (0, _.addBasePath)(Se.pathname), G.pathname = ie;
            }
            if (process.env.__NEXT_HAS_REWRITES) {
              const Se = (0, f.default)(ie, Q, te, G.query, (Ee) => ee(Ee, Q), D.router.locales);
              Se.matchedPage && (G.pathname = Se.parsedAs.pathname, ie = G.pathname, Object.assign(G.query, Se.parsedAs.query));
            } else if (!Q.includes(I)) {
              const Se = ee(I, Q);
              Se !== I && (I = Se);
            }
            const ve = Q.includes(I) ? I : ee((0, v.normalizeLocalePath)((0, R.removeBasePath)(G.pathname), D.router.locales).pathname, Q);
            if ((0, m.isDynamicRoute)(ve)) {
              const Se = (0, u.getRouteMatcher)((0, c.getRouteRegex)(ve))(ie);
              Object.assign(G.query, Se || {});
            }
            return {
              type: "rewrite",
              parsedAs: G,
              resolvedHref: ve
            };
          });
        }
        const ne = (0, g.parsePath)(W), J = (0, B.formatNextPathnameInfo)({
          ...(0, j.getNextPathnameInfo)(ne.pathname, {
            nextConfig: C,
            parseData: !0
          }),
          defaultLocale: D.router.defaultLocale,
          buildId: ""
        });
        return Promise.resolve({
          type: "redirect-external",
          destination: "" + J + ne.query + ne.hash
        });
      }
      const k = H.headers.get("x-nextjs-redirect");
      if (k) {
        if (k.startsWith("/")) {
          const ne = (0, g.parsePath)(k), J = (0, B.formatNextPathnameInfo)({
            ...(0, j.getNextPathnameInfo)(ne.pathname, {
              nextConfig: C,
              parseData: !0
            }),
            defaultLocale: D.router.defaultLocale,
            buildId: ""
          });
          return Promise.resolve({
            type: "redirect-internal",
            newAs: "" + J + ne.query + ne.hash,
            newUrl: "" + J + ne.query + ne.hash
          });
        }
        return Promise.resolve({
          type: "redirect-external",
          destination: k
        });
      }
      return Promise.resolve({
        type: "next"
      });
    }
    async function ae(W) {
      if (!await K(W) || !W.fetchData)
        return null;
      const D = await W.fetchData(), C = await ce(D.dataHref, D.response, W);
      return {
        dataHref: D.dataHref,
        json: D.json,
        response: D.response,
        text: D.text,
        cacheKey: D.cacheKey,
        effect: C
      };
    }
    const pe = process.env.__NEXT_SCROLL_RESTORATION && typeof window < "u" && "scrollRestoration" in window.history && !!function() {
      try {
        let W = "__next";
        return sessionStorage.setItem(W, W), sessionStorage.removeItem(W), !0;
      } catch {
      }
    }(), M = Symbol("SSG_DATA_NOT_FOUND");
    function le(W, H, D) {
      return fetch(W, {
        // Cookies are required to be present for Next.js' SSG "Preview Mode".
        // Cookies may also be required for `getServerSideProps`.
        //
        // > `fetch` won’t send cookies, unless you set the credentials init
        // > option.
        // https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
        //
        // > For maximum browser compatibility when it comes to sending &
        // > receiving cookies, always supply the `credentials: 'same-origin'`
        // > option instead of relying on the default.
        // https://github.com/github/fetch#caveats
        credentials: "same-origin",
        method: D.method || "GET",
        headers: Object.assign({}, D.headers, {
          "x-nextjs-data": "1"
        })
      }).then((C) => !C.ok && H > 1 && C.status >= 500 ? le(W, H - 1, D) : C);
    }
    function me(W) {
      try {
        return JSON.parse(W);
      } catch {
        return null;
      }
    }
    function he(W) {
      let { dataHref: H, inflightCache: D, isPrefetch: C, hasMiddleware: F, isServerRender: ue, parseJSON: oe, persistCache: k, isBackground: ne, unstable_skipClientCache: J } = W;
      const { href: G } = new URL(H, window.location.href), Y = (I) => {
        var V;
        return le(H, ue ? 3 : 1, {
          headers: Object.assign({}, C ? {
            purpose: "prefetch"
          } : {}, C && F ? {
            "x-middleware-prefetch": "1"
          } : {}),
          method: (V = I == null ? void 0 : I.method) != null ? V : "GET"
        }).then((Q) => Q.ok && (I == null ? void 0 : I.method) === "HEAD" ? {
          dataHref: H,
          response: Q,
          text: "",
          json: {},
          cacheKey: G
        } : Q.text().then((te) => {
          if (!Q.ok) {
            if (F && [
              301,
              302,
              307,
              308
            ].includes(Q.status))
              return {
                dataHref: H,
                response: Q,
                text: te,
                json: {},
                cacheKey: G
              };
            if (Q.status === 404) {
              var ie;
              if ((ie = me(te)) != null && ie.notFound)
                return {
                  dataHref: H,
                  json: {
                    notFound: M
                  },
                  response: Q,
                  text: te,
                  cacheKey: G
                };
            }
            const ve = new Error("Failed to load static props");
            throw ue || (0, t.markAssetError)(ve), ve;
          }
          return {
            dataHref: H,
            json: oe ? me(te) : null,
            response: Q,
            text: te,
            cacheKey: G
          };
        })).then((Q) => ((!k || process.env.NODE_ENV !== "production" || Q.response.headers.get("x-middleware-cache") === "no-cache") && delete D[G], Q)).catch((Q) => {
          throw J || delete D[G], // chrome
          (Q.message === "Failed to fetch" || // firefox
          Q.message === "NetworkError when attempting to fetch resource." || // safari
          Q.message === "Load failed") && (0, t.markAssetError)(Q), Q;
        });
      };
      return J && k ? Y({}).then((I) => (I.response.headers.get("x-middleware-cache") !== "no-cache" && (D[G] = Promise.resolve(I)), I)) : D[G] !== void 0 ? D[G] : D[G] = Y(ne ? {
        method: "HEAD"
      } : {});
    }
    function T() {
      return Math.random().toString(36).slice(2, 10);
    }
    function x(W) {
      let { url: H, router: D } = W;
      if (H === (0, _.addBasePath)((0, y.addLocale)(D.asPath, D.locale)))
        throw new Error("Invariant: attempted to hard navigate to the same URL " + H + " " + location.href);
      window.location.href = H;
    }
    const Re = (W) => {
      let { route: H, router: D } = W, C = !1;
      const F = D.clc = () => {
        C = !0;
      };
      return () => {
        if (C) {
          const oe = new Error('Abort fetching component for route: "' + H + '"');
          throw oe.cancelled = !0, oe;
        }
        F === D.clc && (D.clc = null);
      };
    };
    class q {
      reload() {
        window.location.reload();
      }
      /**
      * Go back in history
      */
      back() {
        window.history.back();
      }
      /**
      * Go forward in history
      */
      forward() {
        window.history.forward();
      }
      /**
      * Performs a `pushState` with arguments
      * @param url of the route
      * @param as masks `url` for the browser
      * @param options object you can define `shallow` and other options
      */
      push(H, D, C) {
        if (C === void 0 && (C = {}), process.env.__NEXT_SCROLL_RESTORATION && pe)
          try {
            sessionStorage.setItem("__next_scroll_" + this._key, JSON.stringify({
              x: self.pageXOffset,
              y: self.pageYOffset
            }));
          } catch {
          }
        return { url: H, as: D } = se(this, H, D), this.change("pushState", H, D, C);
      }
      /**
      * Performs a `replaceState` with arguments
      * @param url of the route
      * @param as masks `url` for the browser
      * @param options object you can define `shallow` and other options
      */
      replace(H, D, C) {
        return C === void 0 && (C = {}), { url: H, as: D } = se(this, H, D), this.change("replaceState", H, D, C);
      }
      async _bfl(H, D, C, F) {
        if (process.env.__NEXT_CLIENT_ROUTER_FILTER_ENABLED) {
          let ne = !1, J = !1;
          for (const G of [
            H,
            D
          ])
            if (G) {
              const Y = (0, o.removeTrailingSlash)(new URL(G, "http://n").pathname), I = (0, _.addBasePath)((0, y.addLocale)(Y, C || this.locale));
              if (Y !== (0, o.removeTrailingSlash)(new URL(this.asPath, "http://n").pathname)) {
                var ue, oe;
                ne = ne || !!((ue = this._bfl_s) != null && ue.contains(Y)) || !!((oe = this._bfl_s) != null && oe.contains(I));
                for (const V of [
                  Y,
                  I
                ]) {
                  const Q = V.split("/");
                  for (let te = 0; !J && te < Q.length + 1; te++) {
                    var k;
                    const ie = Q.slice(0, te).join("/");
                    if (ie && ((k = this._bfl_d) != null && k.contains(ie))) {
                      J = !0;
                      break;
                    }
                  }
                }
                if (ne || J)
                  return F ? !0 : (x({
                    url: (0, _.addBasePath)((0, y.addLocale)(H, C || this.locale, this.defaultLocale)),
                    router: this
                  }), new Promise(() => {
                  }));
              }
            }
        }
        return !1;
      }
      async change(H, D, C, F, ue) {
        var oe;
        if (!(0, O.isLocalURL)(D))
          return x({
            url: D,
            router: this
          }), !1;
        const k = F._h === 1;
        !k && !F.shallow && await this._bfl(C, void 0, F.locale);
        let ne = k || F._shouldResolveHref || (0, g.parsePath)(D).pathname === (0, g.parsePath)(C).pathname;
        const J = {
          ...this.state
        }, G = this.isReady !== !0;
        this.isReady = !0;
        const Y = this.isSsr;
        if (k || (this.isSsr = !1), k && this.clc)
          return !1;
        const I = J.locale;
        if (process.env.__NEXT_I18N_SUPPORT) {
          J.locale = F.locale === !1 ? this.defaultLocale : F.locale || J.locale, typeof F.locale > "u" && (F.locale = J.locale);
          const re = (0, l.parseRelativeUrl)((0, b.hasBasePath)(C) ? (0, R.removeBasePath)(C) : C), De = (0, v.normalizeLocalePath)(re.pathname, this.locales);
          De.detectedLocale && (J.locale = De.detectedLocale, re.pathname = (0, _.addBasePath)(re.pathname), C = (0, p.formatWithValidation)(re), D = (0, _.addBasePath)((0, v.normalizeLocalePath)((0, b.hasBasePath)(D) ? (0, R.removeBasePath)(D) : D, this.locales).pathname));
          let qe = !1;
          if (process.env.__NEXT_I18N_SUPPORT) {
            var V;
            (V = this.locales) != null && V.includes(J.locale) || (re.pathname = (0, y.addLocale)(re.pathname, J.locale), x({
              url: (0, p.formatWithValidation)(re),
              router: this
            }), qe = !0);
          }
          const Ce = (0, P.detectDomainLocale)(this.domainLocales, void 0, J.locale);
          if (process.env.__NEXT_I18N_SUPPORT && !qe && Ce && this.isLocaleDomain && self.location.hostname !== Ce.domain) {
            const Ge = (0, R.removeBasePath)(C);
            x({
              url: "http" + (Ce.http ? "" : "s") + "://" + Ce.domain + (0, _.addBasePath)((J.locale === Ce.defaultLocale ? "" : "/" + J.locale) + (Ge === "/" ? "" : Ge) || "/"),
              router: this
            }), qe = !0;
          }
          if (qe)
            return new Promise(() => {
            });
        }
        h.ST && performance.mark("routeChange");
        const { shallow: Q = !1, scroll: te = !0 } = F, ie = {
          shallow: Q
        };
        this._inFlightRoute && this.clc && (Y || q.events.emit("routeChangeError", U(), this._inFlightRoute, ie), this.clc(), this.clc = null), C = (0, _.addBasePath)((0, y.addLocale)((0, b.hasBasePath)(C) ? (0, R.removeBasePath)(C) : C, F.locale, this.defaultLocale));
        const ve = (0, S.removeLocale)((0, b.hasBasePath)(C) ? (0, R.removeBasePath)(C) : C, J.locale);
        this._inFlightRoute = C;
        const Se = I !== J.locale;
        if (!k && this.onlyAHashChange(ve) && !Se) {
          J.asPath = ve, q.events.emit("hashChangeStart", C, ie), this.changeState(H, D, C, {
            ...F,
            scroll: !1
          }), te && this.scrollToHash(ve);
          try {
            await this.set(J, this.components[J.route], null);
          } catch (re) {
            throw (0, a.default)(re) && re.cancelled && q.events.emit("routeChangeError", re, ve, ie), re;
          }
          return q.events.emit("hashChangeComplete", C, ie), !0;
        }
        let Ee = (0, l.parseRelativeUrl)(D), { pathname: de, query: ge } = Ee, Le, Me;
        try {
          [Le, { __rewrites: Me }] = await Promise.all([
            this.pageLoader.getPageList(),
            (0, t.getClientBuildManifest)(),
            this.pageLoader.getMiddleware()
          ]);
        } catch {
          return x({
            url: C,
            router: this
          }), !1;
        }
        !this.urlIsNew(ve) && !Se && (H = "replaceState");
        let Ne = C;
        de = de && (0, o.removeTrailingSlash)((0, R.removeBasePath)(de));
        let fe = (0, o.removeTrailingSlash)(de);
        const Pe = C.startsWith("/") && (0, l.parseRelativeUrl)(C).pathname;
        if ((oe = this.components[de]) != null && oe.__appRouter)
          return x({
            url: C,
            router: this
          }), new Promise(() => {
          });
        const Fe = !!(Pe && fe !== Pe && (!(0, m.isDynamicRoute)(fe) || !(0, u.getRouteMatcher)((0, c.getRouteRegex)(fe))(Pe))), Ae = !F.shallow && await K({
          asPath: C,
          locale: J.locale,
          router: this
        });
        if (k && Ae && (ne = !1), ne && de !== "/_error")
          if (F._shouldResolveHref = !0, process.env.__NEXT_HAS_REWRITES && C.startsWith("/")) {
            const re = (0, f.default)((0, _.addBasePath)((0, y.addLocale)(ve, J.locale), !0), Le, Me, ge, (De) => ee(De, Le), this.locales);
            if (re.externalDest)
              return x({
                url: C,
                router: this
              }), !0;
            Ae || (Ne = re.asPath), re.matchedPage && re.resolvedHref && (de = re.resolvedHref, Ee.pathname = (0, _.addBasePath)(de), Ae || (D = (0, p.formatWithValidation)(Ee)));
          } else
            Ee.pathname = ee(de, Le), Ee.pathname !== de && (de = Ee.pathname, Ee.pathname = (0, _.addBasePath)(de), Ae || (D = (0, p.formatWithValidation)(Ee)));
        if (!(0, O.isLocalURL)(C)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error('Invalid href: "' + D + '" and as: "' + C + `", received relative href and external as
See more info: https://nextjs.org/docs/messages/invalid-relative-url-external-as`);
          return x({
            url: C,
            router: this
          }), !1;
        }
        Ne = (0, S.removeLocale)((0, R.removeBasePath)(Ne), J.locale), fe = (0, o.removeTrailingSlash)(de);
        let je = !1;
        if ((0, m.isDynamicRoute)(fe)) {
          const re = (0, l.parseRelativeUrl)(Ne), De = re.pathname, qe = (0, c.getRouteRegex)(fe);
          je = (0, u.getRouteMatcher)(qe)(De);
          const Ce = fe === De, Ge = Ce ? (0, z.interpolateAs)(fe, De, ge) : {};
          if (!je || Ce && !Ge.result) {
            const We = Object.keys(qe.groups).filter((Ve) => !ge[Ve] && !qe.groups[Ve].optional);
            if (We.length > 0 && !Ae)
              throw process.env.NODE_ENV !== "production" && console.warn((Ce ? "Interpolating href" : "Mismatching `as` and `href`") + " failed to manually provide " + ("the params: " + We.join(", ") + " in the `href`'s `query`")), new Error((Ce ? "The provided `href` (" + D + ") value is missing query values (" + We.join(", ") + ") to be interpolated properly. " : "The provided `as` value (" + De + ") is incompatible with the `href` value (" + fe + "). ") + ("Read more: https://nextjs.org/docs/messages/" + (Ce ? "href-interpolation-failed" : "incompatible-href-as")));
          } else
            Ce ? C = (0, p.formatWithValidation)(Object.assign({}, re, {
              pathname: Ge.result,
              query: (0, L.omit)(ge, Ge.params)
            })) : Object.assign(ge, je);
        }
        k || q.events.emit("routeChangeStart", C, ie);
        const ot = this.pathname === "/404" || this.pathname === "/_error";
        try {
          var Oe, ze, _n;
          let re = await this.getRouteInfo({
            route: fe,
            pathname: de,
            query: ge,
            as: C,
            resolvedAs: Ne,
            routeProps: ie,
            locale: J.locale,
            isPreview: J.isPreview,
            hasMiddleware: Ae,
            unstable_skipClientCache: F.unstable_skipClientCache,
            isQueryUpdating: k && !this.isFallback,
            isMiddlewareRewrite: Fe
          });
          if (!k && !F.shallow && await this._bfl(C, "resolvedAs" in re ? re.resolvedAs : void 0, J.locale), "route" in re && Ae) {
            de = re.route || fe, fe = de, ie.shallow || (ge = Object.assign({}, re.query || {}, ge));
            const we = (0, b.hasBasePath)(Ee.pathname) ? (0, R.removeBasePath)(Ee.pathname) : Ee.pathname;
            if (je && de !== we && Object.keys(je).forEach((Ie) => {
              je && ge[Ie] === je[Ie] && delete ge[Ie];
            }), (0, m.isDynamicRoute)(de)) {
              let ke = !ie.shallow && re.resolvedAs ? re.resolvedAs : (0, _.addBasePath)((0, y.addLocale)(new URL(C, location.href).pathname, J.locale), !0);
              if ((0, b.hasBasePath)(ke) && (ke = (0, R.removeBasePath)(ke)), process.env.__NEXT_I18N_SUPPORT) {
                const Pn = (0, v.normalizeLocalePath)(ke, this.locales);
                J.locale = Pn.detectedLocale || J.locale, ke = Pn.pathname;
              }
              const qt = (0, c.getRouteRegex)(de), En = (0, u.getRouteMatcher)(qt)(new URL(ke, location.href).pathname);
              En && Object.assign(ge, En);
            }
          }
          if ("type" in re)
            return re.type === "redirect-internal" ? this.change(H, re.newUrl, re.newAs, F) : (x({
              url: re.destination,
              router: this
            }), new Promise(() => {
            }));
          const De = re.Component;
          if (De && De.unstable_scriptLoader && [].concat(De.unstable_scriptLoader()).forEach((Ie) => {
            (0, r.handleClientScriptLoad)(Ie.props);
          }), (re.__N_SSG || re.__N_SSP) && re.props) {
            if (re.props.pageProps && re.props.pageProps.__N_REDIRECT) {
              F.locale = !1;
              const we = re.props.pageProps.__N_REDIRECT;
              if (we.startsWith("/") && re.props.pageProps.__N_REDIRECT_BASE_PATH !== !1) {
                const Ie = (0, l.parseRelativeUrl)(we);
                Ie.pathname = ee(Ie.pathname, Le);
                const { url: ke, as: qt } = se(this, we, we);
                return this.change(H, ke, qt, F);
              }
              return x({
                url: we,
                router: this
              }), new Promise(() => {
              });
            }
            if (J.isPreview = !!re.props.__N_PREVIEW, re.props.notFound === M) {
              let we;
              try {
                await this.fetchComponent("/404"), we = "/404";
              } catch {
                we = "/_error";
              }
              if (re = await this.getRouteInfo({
                route: we,
                pathname: we,
                query: ge,
                as: C,
                resolvedAs: Ne,
                routeProps: {
                  shallow: !1
                },
                locale: J.locale,
                isPreview: J.isPreview,
                isNotFound: !0
              }), "type" in re)
                throw new Error("Unexpected middleware effect on /404");
            }
          }
          k && this.pathname === "/_error" && ((ze = self.__NEXT_DATA__.props) == null || (Oe = ze.pageProps) == null ? void 0 : Oe.statusCode) === 500 && ((_n = re.props) != null && _n.pageProps) && (re.props.pageProps.statusCode = 500);
          var yn;
          const qe = F.shallow && J.route === ((yn = re.route) != null ? yn : fe);
          var vn;
          const Ce = (vn = F.scroll) != null ? vn : !k && !qe, We = ue ?? (Ce ? {
            x: 0,
            y: 0
          } : null), Ve = {
            ...J,
            route: fe,
            pathname: de,
            query: ge,
            asPath: ve,
            isFallback: !1
          };
          if (k && ot) {
            var bn, Sn, Rn;
            if (re = await this.getRouteInfo({
              route: this.pathname,
              pathname: this.pathname,
              query: ge,
              as: C,
              resolvedAs: Ne,
              routeProps: {
                shallow: !1
              },
              locale: J.locale,
              isPreview: J.isPreview,
              isQueryUpdating: k && !this.isFallback
            }), "type" in re)
              throw new Error("Unexpected middleware effect on " + this.pathname);
            this.pathname === "/_error" && ((Sn = self.__NEXT_DATA__.props) == null || (bn = Sn.pageProps) == null ? void 0 : bn.statusCode) === 500 && ((Rn = re.props) != null && Rn.pageProps) && (re.props.pageProps.statusCode = 500);
            try {
              await this.set(Ve, re, We);
            } catch (we) {
              throw (0, a.default)(we) && we.cancelled && q.events.emit("routeChangeError", we, ve, ie), we;
            }
            return !0;
          }
          if (q.events.emit("beforeHistoryChange", C, ie), this.changeState(H, D, C, F), !(k && !We && !G && !Se && (0, X.compareRouterStates)(Ve, this.state))) {
            try {
              await this.set(Ve, re, We);
            } catch (Ie) {
              if (Ie.cancelled)
                re.error = re.error || Ie;
              else
                throw Ie;
            }
            if (re.error)
              throw k || q.events.emit("routeChangeError", re.error, ve, ie), re.error;
            process.env.__NEXT_I18N_SUPPORT && J.locale && (document.documentElement.lang = J.locale), k || q.events.emit("routeChangeComplete", C, ie), Ce && /#.+$/.test(C) && this.scrollToHash(C);
          }
          return !0;
        } catch (re) {
          if ((0, a.default)(re) && re.cancelled)
            return !1;
          throw re;
        }
      }
      changeState(H, D, C, F) {
        if (F === void 0 && (F = {}), process.env.NODE_ENV !== "production") {
          if (typeof window.history > "u") {
            console.error("Warning: window.history is not available.");
            return;
          }
          if (typeof window.history[H] > "u") {
            console.error("Warning: window.history." + H + " is not available");
            return;
          }
        }
        (H !== "pushState" || (0, h.getURL)() !== C) && (this._shallow = F.shallow, window.history[H](
          {
            url: D,
            as: C,
            options: F,
            __N: !0,
            key: this._key = H !== "pushState" ? this._key : T()
          },
          // Most browsers currently ignores this parameter, although they may use it in the future.
          // Passing the empty string here should be safe against future changes to the method.
          // https://developer.mozilla.org/docs/Web/API/History/replaceState
          "",
          C
        ));
      }
      async handleRouteInfoError(H, D, C, F, ue, oe) {
        if (console.error(H), H.cancelled)
          throw H;
        if ((0, t.isAssetError)(H) || oe)
          throw q.events.emit("routeChangeError", H, F, ue), x({
            url: F,
            router: this
          }), U();
        try {
          let k;
          const { page: ne, styleSheets: J } = await this.fetchComponent("/_error"), G = {
            props: k,
            Component: ne,
            styleSheets: J,
            err: H,
            error: H
          };
          if (!G.props)
            try {
              G.props = await this.getInitialProps(ne, {
                err: H,
                pathname: D,
                query: C
              });
            } catch (Y) {
              console.error("Error in error page `getInitialProps`: ", Y), G.props = {};
            }
          return G;
        } catch (k) {
          return this.handleRouteInfoError((0, a.default)(k) ? k : new Error(k + ""), D, C, F, ue, !0);
        }
      }
      async getRouteInfo(H) {
        let { route: D, pathname: C, query: F, as: ue, resolvedAs: oe, routeProps: k, locale: ne, hasMiddleware: J, isPreview: G, unstable_skipClientCache: Y, isQueryUpdating: I, isMiddlewareRewrite: V, isNotFound: Q } = H, te = D;
        try {
          var ie, ve, Se, Ee;
          let de = this.components[te];
          if (k.shallow && de && this.route === te)
            return de;
          const ge = Re({
            route: te,
            router: this
          });
          J && (de = void 0);
          let Le = de && !("initial" in de) && process.env.NODE_ENV !== "development" ? de : void 0;
          const Me = I, Ne = {
            dataHref: this.pageLoader.getDataHref({
              href: (0, p.formatWithValidation)({
                pathname: C,
                query: F
              }),
              skipInterpolation: !0,
              asPath: Q ? "/404" : oe,
              locale: ne
            }),
            hasMiddleware: !0,
            isServerRender: this.isSsr,
            parseJSON: !0,
            inflightCache: Me ? this.sbc : this.sdc,
            persistCache: !G,
            isPrefetch: !1,
            unstable_skipClientCache: Y,
            isBackground: Me
          };
          let fe = I && !V ? null : await ae({
            fetchData: () => he(Ne),
            asPath: Q ? "/404" : oe,
            locale: ne,
            router: this
          }).catch((Oe) => {
            if (I)
              return null;
            throw Oe;
          });
          if (fe && (C === "/_error" || C === "/404") && (fe.effect = void 0), I && (fe ? fe.json = self.__NEXT_DATA__.props : fe = {
            json: self.__NEXT_DATA__.props
          }), ge(), (fe == null || (ie = fe.effect) == null ? void 0 : ie.type) === "redirect-internal" || (fe == null || (ve = fe.effect) == null ? void 0 : ve.type) === "redirect-external")
            return fe.effect;
          if ((fe == null || (Se = fe.effect) == null ? void 0 : Se.type) === "rewrite") {
            const Oe = (0, o.removeTrailingSlash)(fe.effect.resolvedHref), ze = await this.pageLoader.getPageList();
            if ((!I || ze.includes(Oe)) && (te = Oe, C = fe.effect.resolvedHref, F = {
              ...F,
              ...fe.effect.parsedAs.query
            }, oe = (0, R.removeBasePath)((0, v.normalizeLocalePath)(fe.effect.parsedAs.pathname, this.locales).pathname), de = this.components[te], k.shallow && de && this.route === te && !J))
              return {
                ...de,
                route: te
              };
          }
          if ((0, w.isAPIRoute)(te))
            return x({
              url: ue,
              router: this
            }), new Promise(() => {
            });
          const Pe = Le || await this.fetchComponent(te).then((Oe) => ({
            Component: Oe.page,
            styleSheets: Oe.styleSheets,
            __N_SSG: Oe.mod.__N_SSG,
            __N_SSP: Oe.mod.__N_SSP
          }));
          if (process.env.NODE_ENV !== "production") {
            const { isValidElementType: Oe } = $s();
            if (!Oe(Pe.Component))
              throw new Error('The default export is not a React Component in page: "' + C + '"');
          }
          const Fe = fe == null || (Ee = fe.response) == null ? void 0 : Ee.headers.get("x-middleware-skip"), Ae = Pe.__N_SSG || Pe.__N_SSP;
          Fe && (fe != null && fe.dataHref) && delete this.sdc[fe.dataHref];
          const { props: je, cacheKey: ot } = await this._getData(async () => {
            if (Ae) {
              if (fe != null && fe.json && !Fe)
                return {
                  cacheKey: fe.cacheKey,
                  props: fe.json
                };
              const Oe = fe != null && fe.dataHref ? fe.dataHref : this.pageLoader.getDataHref({
                href: (0, p.formatWithValidation)({
                  pathname: C,
                  query: F
                }),
                asPath: oe,
                locale: ne
              }), ze = await he({
                dataHref: Oe,
                isServerRender: this.isSsr,
                parseJSON: !0,
                inflightCache: Fe ? {} : this.sdc,
                persistCache: !G,
                isPrefetch: !1,
                unstable_skipClientCache: Y
              });
              return {
                cacheKey: ze.cacheKey,
                props: ze.json || {}
              };
            }
            return {
              headers: {},
              props: await this.getInitialProps(
                Pe.Component,
                // we provide AppTree later so this needs to be `any`
                {
                  pathname: C,
                  query: F,
                  asPath: ue,
                  locale: ne,
                  locales: this.locales,
                  defaultLocale: this.defaultLocale
                }
              )
            };
          });
          return Pe.__N_SSP && Ne.dataHref && ot && delete this.sdc[ot], !this.isPreview && Pe.__N_SSG && process.env.NODE_ENV !== "development" && !I && he(Object.assign({}, Ne, {
            isBackground: !0,
            persistCache: !1,
            inflightCache: this.sbc
          })).catch(() => {
          }), je.pageProps = Object.assign({}, je.pageProps), Pe.props = je, Pe.route = te, Pe.query = F, Pe.resolvedAs = oe, this.components[te] = Pe, Pe;
        } catch (de) {
          return this.handleRouteInfoError((0, a.getProperError)(de), C, F, ue, k);
        }
      }
      set(H, D, C) {
        return this.state = H, this.sub(D, this.components["/_app"].Component, C);
      }
      /**
      * Callback to execute before replacing router state
      * @param cb callback to be executed
      */
      beforePopState(H) {
        this._bps = H;
      }
      onlyAHashChange(H) {
        if (!this.asPath)
          return !1;
        const [D, C] = this.asPath.split("#", 2), [F, ue] = H.split("#", 2);
        return ue && D === F && C === ue ? !0 : D !== F ? !1 : C !== ue;
      }
      scrollToHash(H) {
        const [, D = ""] = H.split("#", 2);
        (0, $.handleSmoothScroll)(() => {
          if (D === "" || D === "top") {
            window.scrollTo(0, 0);
            return;
          }
          const C = decodeURIComponent(D), F = document.getElementById(C);
          if (F) {
            F.scrollIntoView();
            return;
          }
          const ue = document.getElementsByName(C)[0];
          ue && ue.scrollIntoView();
        }, {
          onlyHashChange: this.onlyAHashChange(H)
        });
      }
      urlIsNew(H) {
        return this.asPath !== H;
      }
      /**
      * Prefetch page code, you may wait for the data during page rendering.
      * This feature only works in production!
      * @param url the href of prefetched page
      * @param asPath the as path of the prefetched page
      */
      async prefetch(H, D, C) {
        if (D === void 0 && (D = H), C === void 0 && (C = {}), process.env.NODE_ENV !== "production" || typeof window < "u" && (0, N.isBot)(window.navigator.userAgent))
          return;
        let F = (0, l.parseRelativeUrl)(H);
        const ue = F.pathname;
        let { pathname: oe, query: k } = F;
        const ne = oe;
        if (process.env.__NEXT_I18N_SUPPORT && C.locale === !1) {
          oe = (0, v.normalizeLocalePath)(oe, this.locales).pathname, F.pathname = oe, H = (0, p.formatWithValidation)(F);
          let te = (0, l.parseRelativeUrl)(D);
          const ie = (0, v.normalizeLocalePath)(te.pathname, this.locales);
          te.pathname = ie.pathname, C.locale = ie.detectedLocale || this.defaultLocale, D = (0, p.formatWithValidation)(te);
        }
        const J = await this.pageLoader.getPageList();
        let G = D;
        const Y = typeof C.locale < "u" ? C.locale || void 0 : this.locale, I = await K({
          asPath: D,
          locale: Y,
          router: this
        });
        if (process.env.__NEXT_HAS_REWRITES && D.startsWith("/")) {
          let te;
          ({ __rewrites: te } = await (0, t.getClientBuildManifest)());
          const ie = (0, f.default)((0, _.addBasePath)((0, y.addLocale)(D, this.locale), !0), J, te, F.query, (ve) => ee(ve, J), this.locales);
          if (ie.externalDest)
            return;
          I || (G = (0, S.removeLocale)((0, R.removeBasePath)(ie.asPath), this.locale)), ie.matchedPage && ie.resolvedHref && (oe = ie.resolvedHref, F.pathname = oe, I || (H = (0, p.formatWithValidation)(F)));
        }
        F.pathname = ee(F.pathname, J), (0, m.isDynamicRoute)(F.pathname) && (oe = F.pathname, F.pathname = oe, Object.assign(k, (0, u.getRouteMatcher)((0, c.getRouteRegex)(F.pathname))((0, g.parsePath)(D).pathname) || {}), I || (H = (0, p.formatWithValidation)(F)));
        const V = process.env.__NEXT_MIDDLEWARE_PREFETCH === "strict" ? null : await ae({
          fetchData: () => he({
            dataHref: this.pageLoader.getDataHref({
              href: (0, p.formatWithValidation)({
                pathname: ne,
                query: k
              }),
              skipInterpolation: !0,
              asPath: G,
              locale: Y
            }),
            hasMiddleware: !0,
            isServerRender: !1,
            parseJSON: !0,
            inflightCache: this.sdc,
            persistCache: !this.isPreview,
            isPrefetch: !0
          }),
          asPath: D,
          locale: Y,
          router: this
        });
        if ((V == null ? void 0 : V.effect.type) === "rewrite" && (F.pathname = V.effect.resolvedHref, oe = V.effect.resolvedHref, k = {
          ...k,
          ...V.effect.parsedAs.query
        }, G = V.effect.parsedAs.pathname, H = (0, p.formatWithValidation)(F)), (V == null ? void 0 : V.effect.type) === "redirect-external")
          return;
        const Q = (0, o.removeTrailingSlash)(oe);
        await this._bfl(D, G, C.locale, !0) && (this.components[ue] = {
          __appRouter: !0
        }), await Promise.all([
          this.pageLoader._isSsg(Q).then((te) => te ? he({
            dataHref: V != null && V.json ? V == null ? void 0 : V.dataHref : this.pageLoader.getDataHref({
              href: H,
              asPath: G,
              locale: Y
            }),
            isServerRender: !1,
            parseJSON: !0,
            inflightCache: this.sdc,
            persistCache: !this.isPreview,
            isPrefetch: !0,
            unstable_skipClientCache: C.unstable_skipClientCache || C.priority && !!process.env.__NEXT_OPTIMISTIC_CLIENT_CACHE
          }).then(() => !1).catch(() => !1) : !1),
          this.pageLoader[C.priority ? "loadPage" : "prefetch"](Q)
        ]);
      }
      async fetchComponent(H) {
        const D = Re({
          route: H,
          router: this
        });
        try {
          const C = await this.pageLoader.loadPage(H);
          return D(), C;
        } catch (C) {
          throw D(), C;
        }
      }
      _getData(H) {
        let D = !1;
        const C = () => {
          D = !0;
        };
        return this.clc = C, H().then((F) => {
          if (C === this.clc && (this.clc = null), D) {
            const ue = new Error("Loading initial props cancelled");
            throw ue.cancelled = !0, ue;
          }
          return F;
        });
      }
      _getFlightData(H) {
        return he({
          dataHref: H,
          isServerRender: !0,
          parseJSON: !1,
          inflightCache: this.sdc,
          persistCache: !1,
          isPrefetch: !1
        }).then((D) => {
          let { text: C } = D;
          return {
            data: C
          };
        });
      }
      getInitialProps(H, D) {
        const { Component: C } = this.components["/_app"], F = this._wrapApp(C);
        return D.AppTree = F, (0, h.loadGetInitialProps)(C, {
          AppTree: F,
          Component: H,
          router: this,
          ctx: D
        });
      }
      get route() {
        return this.state.route;
      }
      get pathname() {
        return this.state.pathname;
      }
      get query() {
        return this.state.query;
      }
      get asPath() {
        return this.state.asPath;
      }
      get locale() {
        return this.state.locale;
      }
      get isFallback() {
        return this.state.isFallback;
      }
      get isPreview() {
        return this.state.isPreview;
      }
      constructor(H, D, C, { initialProps: F, pageLoader: ue, App: oe, wrapApp: k, Component: ne, err: J, subscription: G, isFallback: Y, locale: I, locales: V, defaultLocale: Q, domainLocales: te, isPreview: ie }) {
        this.sdc = {}, this.sbc = {}, this.isFirstPopStateEvent = !0, this._key = T(), this.onPopState = (Ee) => {
          const { isFirstPopStateEvent: de } = this;
          this.isFirstPopStateEvent = !1;
          const ge = Ee.state;
          if (!ge) {
            const { pathname: Ae, query: je } = this;
            this.changeState("replaceState", (0, p.formatWithValidation)({
              pathname: (0, _.addBasePath)(Ae),
              query: je
            }), (0, h.getURL)());
            return;
          }
          if (ge.__NA) {
            window.location.reload();
            return;
          }
          if (!ge.__N || de && this.locale === ge.options.locale && ge.as === this.asPath)
            return;
          let Le;
          const { url: Me, as: Ne, options: fe, key: Pe } = ge;
          if (process.env.__NEXT_SCROLL_RESTORATION && pe && this._key !== Pe) {
            try {
              sessionStorage.setItem("__next_scroll_" + this._key, JSON.stringify({
                x: self.pageXOffset,
                y: self.pageYOffset
              }));
            } catch {
            }
            try {
              const Ae = sessionStorage.getItem("__next_scroll_" + Pe);
              Le = JSON.parse(Ae);
            } catch {
              Le = {
                x: 0,
                y: 0
              };
            }
          }
          this._key = Pe;
          const { pathname: Fe } = (0, l.parseRelativeUrl)(Me);
          this.isSsr && Ne === (0, _.addBasePath)(this.asPath) && Fe === (0, _.addBasePath)(this.pathname) || this._bps && !this._bps(ge) || this.change("replaceState", Me, Ne, Object.assign({}, fe, {
            shallow: fe.shallow && this._shallow,
            locale: fe.locale || this.defaultLocale,
            // @ts-ignore internal value not exposed on types
            _h: 0
          }), Le);
        };
        const ve = (0, o.removeTrailingSlash)(H);
        if (this.components = {}, H !== "/_error" && (this.components[ve] = {
          Component: ne,
          initial: !0,
          props: F,
          err: J,
          __N_SSG: F && F.__N_SSG,
          __N_SSP: F && F.__N_SSP
        }), this.components["/_app"] = {
          Component: oe,
          styleSheets: []
        }, process.env.__NEXT_CLIENT_ROUTER_FILTER_ENABLED) {
          const { BloomFilter: Ee } = Fs(), de = process.env.__NEXT_CLIENT_ROUTER_S_FILTER, ge = de || void 0, Le = process.env.__NEXT_CLIENT_ROUTER_D_FILTER, Me = Le || void 0;
          ge != null && ge.numHashes && (this._bfl_s = new Ee(ge.numItems, ge.errorRate), this._bfl_s.import(ge)), Me != null && Me.numHashes && (this._bfl_d = new Ee(Me.numItems, Me.errorRate), this._bfl_d.import(Me));
        }
        this.events = q.events, this.pageLoader = ue;
        const Se = (0, m.isDynamicRoute)(H) && self.__NEXT_DATA__.autoExport;
        if (this.basePath = process.env.__NEXT_ROUTER_BASEPATH || "", this.sub = G, this.clc = null, this._wrapApp = k, this.isSsr = !0, this.isLocaleDomain = !1, this.isReady = !!(self.__NEXT_DATA__.gssp || self.__NEXT_DATA__.gip || self.__NEXT_DATA__.isExperimentalCompile || self.__NEXT_DATA__.appGip && !self.__NEXT_DATA__.gsp || !Se && !self.location.search && !process.env.__NEXT_HAS_REWRITES), process.env.__NEXT_I18N_SUPPORT && (this.locales = V, this.defaultLocale = Q, this.domainLocales = te, this.isLocaleDomain = !!(0, P.detectDomainLocale)(te, self.location.hostname)), this.state = {
          route: ve,
          pathname: H,
          query: D,
          asPath: Se ? H : C,
          isPreview: !!ie,
          locale: process.env.__NEXT_I18N_SUPPORT ? I : void 0,
          isFallback: Y
        }, this._initialMatchesMiddlewarePromise = Promise.resolve(!1), typeof window < "u") {
          if (!C.startsWith("//")) {
            const Ee = {
              locale: I
            }, de = (0, h.getURL)();
            this._initialMatchesMiddlewarePromise = K({
              router: this,
              locale: I,
              asPath: de
            }).then((ge) => (Ee._shouldResolveHref = C !== H, this.changeState("replaceState", ge ? de : (0, p.formatWithValidation)({
              pathname: (0, _.addBasePath)(H),
              query: D
            }), de, Ee), ge));
          }
          window.addEventListener("popstate", this.onPopState), process.env.__NEXT_SCROLL_RESTORATION && pe && (window.history.scrollRestoration = "manual");
        }
      }
    }
    q.events = (0, E.default)();
  }(gr)), gr;
}
var Ot = { exports: {} }, ea;
function Gs() {
  return ea || (ea = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const s = tt, i = xa();
    function o(t) {
      function r(a) {
        return /* @__PURE__ */ (0, s.jsx)(t, {
          router: (0, i.useRouter)(),
          ...a
        });
      }
      if (r.getInitialProps = t.getInitialProps, r.origGetInitialProps = t.origGetInitialProps, process.env.NODE_ENV !== "production") {
        const a = t.displayName || t.name || "Unknown";
        r.displayName = "withRouter(" + a + ")";
      }
      return r;
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(Ot, Ot.exports)), Ot.exports;
}
var ta;
function xa() {
  return ta || (ta = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function s(P, g) {
      for (var y in g)
        Object.defineProperty(P, y, {
          enumerable: !0,
          get: g[y]
        });
    }
    s(e, {
      Router: function() {
        return t.default;
      },
      createRouter: function() {
        return c;
      },
      // Export the singletonRouter and this is the public API.
      default: function() {
        return f;
      },
      makePublicRouterInstance: function() {
        return p;
      },
      useRouter: function() {
        return u;
      },
      withRouter: function() {
        return d.default;
      }
    });
    const i = Te, o = /* @__PURE__ */ i._(xe), t = /* @__PURE__ */ i._(zs()), r = an(), a = /* @__PURE__ */ i._(Aa()), d = /* @__PURE__ */ i._(Gs()), v = {
      router: null,
      readyCallbacks: [],
      ready(P) {
        if (this.router)
          return P();
        typeof window < "u" && this.readyCallbacks.push(P);
      }
    }, E = [
      "pathname",
      "route",
      "query",
      "asPath",
      "components",
      "isFallback",
      "basePath",
      "locale",
      "locales",
      "defaultLocale",
      "isReady",
      "isPreview",
      "isLocaleDomain",
      "domainLocales"
    ], h = [
      "routeChangeStart",
      "beforeHistoryChange",
      "routeChangeComplete",
      "routeChangeError",
      "hashChangeStart",
      "hashChangeComplete"
    ], m = [
      "push",
      "replace",
      "reload",
      "back",
      "prefetch",
      "beforePopState"
    ];
    Object.defineProperty(v, "events", {
      get() {
        return t.default.events;
      }
    });
    function l() {
      if (!v.router) {
        const P = `No router instance found.
You should only use "next/router" on the client side of your app.
`;
        throw new Error(P);
      }
      return v.router;
    }
    E.forEach((P) => {
      Object.defineProperty(v, P, {
        get() {
          return l()[P];
        }
      });
    }), m.forEach((P) => {
      v[P] = function() {
        for (var g = arguments.length, y = new Array(g), S = 0; S < g; S++)
          y[S] = arguments[S];
        return l()[P](...y);
      };
    }), h.forEach((P) => {
      v.ready(() => {
        t.default.events.on(P, function() {
          for (var g = arguments.length, y = new Array(g), S = 0; S < g; S++)
            y[S] = arguments[S];
          const R = "on" + P.charAt(0).toUpperCase() + P.substring(1), _ = v;
          if (_[R])
            try {
              _[R](...y);
            } catch (b) {
              console.error("Error when running the Router event: " + R), console.error((0, a.default)(b) ? b.message + `
` + b.stack : b + "");
            }
        });
      });
    });
    const f = v;
    function u() {
      const P = o.default.useContext(r.RouterContext);
      if (!P)
        throw new Error("NextRouter was not mounted. https://nextjs.org/docs/messages/next-router-not-mounted");
      return P;
    }
    function c() {
      for (var P = arguments.length, g = new Array(P), y = 0; y < P; y++)
        g[y] = arguments[y];
      return v.router = new t.default(...g), v.readyCallbacks.forEach((S) => S()), v.readyCallbacks = [], v.router;
    }
    function p(P) {
      const g = P, y = {};
      for (const S of E) {
        if (typeof g[S] == "object") {
          y[S] = Object.assign(Array.isArray(g[S]) ? [] : {}, g[S]);
          continue;
        }
        y[S] = g[S];
      }
      return y.events = t.default.events, m.forEach((S) => {
        y[S] = function() {
          for (var R = arguments.length, _ = new Array(R), b = 0; b < R; b++)
            _[b] = arguments[b];
          return g[S](..._);
        };
      }), y;
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(_t, _t.exports)), _t.exports;
}
var Ws = xa();
const Xe = /* @__PURE__ */ rt(Ws);
function Ru() {
  const [n, e] = rn(!1);
  return nn(() => {
    const s = () => e(!0), i = () => e(!1), o = () => e(!1);
    return Xe.events.on("routeChangeError", o), Xe.events.on("routeChangeComplete", i), Xe.events.on("routeChangeStart", s), () => {
      Xe.events.off("routeChangeError", o), Xe.events.off("routeChangeComplete", i), Xe.events.off("routeChangeStart", s);
    };
  }, []), n ? /* @__PURE__ */ be(Va, {}) : null;
}
var Gr = { exports: {} }, La = {};
(function(n) {
  "use client";
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  function e(r, a) {
    for (var d in a)
      Object.defineProperty(r, d, {
        enumerable: !0,
        get: a[d]
      });
  }
  e(n, {
    PathParamsContext: function() {
      return t;
    },
    PathnameContext: function() {
      return o;
    },
    SearchParamsContext: function() {
      return i;
    }
  });
  const s = xe, i = (0, s.createContext)(null), o = (0, s.createContext)(null), t = (0, s.createContext)(null);
  process.env.NODE_ENV !== "production" && (i.displayName = "SearchParamsContext", o.displayName = "PathnameContext", t.displayName = "PathParamsContext");
})(La);
var Wr = { exports: {} };
(function(n, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "getSegmentValue", {
    enumerable: !0,
    get: function() {
      return s;
    }
  });
  function s(i) {
    return Array.isArray(i) ? i[1] : i;
  }
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(Wr, Wr.exports);
var Vs = Wr.exports, Vr = { exports: {} }, Xr = { exports: {} }, Kr = { exports: {} }, Yr = { exports: {} }, Qr = { exports: {} };
(function(n, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "createAsyncLocalStorage", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  const s = new Error("Invariant: AsyncLocalStorage accessed in runtime where it is not available");
  class i {
    disable() {
      throw s;
    }
    getStore() {
    }
    run() {
      throw s;
    }
    exit() {
      throw s;
    }
    enterWith() {
      throw s;
    }
  }
  const o = globalThis.AsyncLocalStorage;
  function t() {
    return o ? new o() : new i();
  }
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(Qr, Qr.exports);
var gn = Qr.exports;
(function(n, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "requestAsyncStorage", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const i = (0, gn.createAsyncLocalStorage)();
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(Yr, Yr.exports);
var Xs = Yr.exports;
(function(n, e) {
  "TURBOPACK { transition: next-shared }";
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function s(t, r) {
    for (var a in r)
      Object.defineProperty(t, a, {
        enumerable: !0,
        get: r[a]
      });
  }
  s(e, {
    getExpectedRequestStore: function() {
      return o;
    },
    requestAsyncStorage: function() {
      return i.requestAsyncStorage;
    }
  });
  const i = Xs;
  function o(t) {
    const r = i.requestAsyncStorage.getStore();
    if (r)
      return r;
    throw new Error("`" + t + "` was called outside a request scope. Read more: https://nextjs.org/docs/messages/next-dynamic-api-wrong-context");
  }
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(Kr, Kr.exports);
var Ks = Kr.exports, Jr = { exports: {} }, Zr = { exports: {} };
(function(n, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "actionAsyncStorage", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const i = (0, gn.createAsyncLocalStorage)();
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(Zr, Zr.exports);
var Ys = Zr.exports;
(function(n, e) {
  "TURBOPACK { transition: next-shared }";
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "actionAsyncStorage", {
    enumerable: !0,
    get: function() {
      return s.actionAsyncStorage;
    }
  });
  const s = Ys;
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(Jr, Jr.exports);
var Qs = Jr.exports, en = { exports: {} };
(function(n, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "RedirectStatusCode", {
    enumerable: !0,
    get: function() {
      return s;
    }
  });
  var s;
  (function(i) {
    i[i.SeeOther = 303] = "SeeOther", i[i.TemporaryRedirect = 307] = "TemporaryRedirect", i[i.PermanentRedirect = 308] = "PermanentRedirect";
  })(s || (s = {})), (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(en, en.exports);
var Js = en.exports;
(function(n, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function s(u, c) {
    for (var p in c)
      Object.defineProperty(u, p, {
        enumerable: !0,
        get: c[p]
      });
  }
  s(e, {
    RedirectType: function() {
      return a;
    },
    getRedirectError: function() {
      return d;
    },
    getRedirectStatusCodeFromError: function() {
      return f;
    },
    getRedirectTypeFromError: function() {
      return l;
    },
    getURLFromRedirectError: function() {
      return m;
    },
    isRedirectError: function() {
      return h;
    },
    permanentRedirect: function() {
      return E;
    },
    redirect: function() {
      return v;
    }
  });
  const i = Ks, o = Qs, t = Js, r = "NEXT_REDIRECT";
  var a;
  (function(u) {
    u.push = "push", u.replace = "replace";
  })(a || (a = {}));
  function d(u, c, p) {
    p === void 0 && (p = t.RedirectStatusCode.TemporaryRedirect);
    const P = new Error(r);
    P.digest = r + ";" + c + ";" + u + ";" + p + ";";
    const g = i.requestAsyncStorage.getStore();
    return g && (P.mutableCookies = g.mutableCookies), P;
  }
  function v(u, c) {
    c === void 0 && (c = "replace");
    const p = o.actionAsyncStorage.getStore();
    throw d(
      u,
      c,
      // If we're in an action, we want to use a 303 redirect
      // as we don't want the POST request to follow the redirect,
      // as it could result in erroneous re-submissions.
      p != null && p.isAction ? t.RedirectStatusCode.SeeOther : t.RedirectStatusCode.TemporaryRedirect
    );
  }
  function E(u, c) {
    c === void 0 && (c = "replace");
    const p = o.actionAsyncStorage.getStore();
    throw d(
      u,
      c,
      // If we're in an action, we want to use a 303 redirect
      // as we don't want the POST request to follow the redirect,
      // as it could result in erroneous re-submissions.
      p != null && p.isAction ? t.RedirectStatusCode.SeeOther : t.RedirectStatusCode.PermanentRedirect
    );
  }
  function h(u) {
    if (typeof u != "object" || u === null || !("digest" in u) || typeof u.digest != "string")
      return !1;
    const [c, p, P, g] = u.digest.split(";", 4), y = Number(g);
    return c === r && (p === "replace" || p === "push") && typeof P == "string" && !isNaN(y) && y in t.RedirectStatusCode;
  }
  function m(u) {
    return h(u) ? u.digest.split(";", 3)[2] : null;
  }
  function l(u) {
    if (!h(u))
      throw new Error("Not a redirect error");
    return u.digest.split(";", 2)[1];
  }
  function f(u) {
    if (!h(u))
      throw new Error("Not a redirect error");
    return Number(u.digest.split(";", 4)[3]);
  }
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(Xr, Xr.exports);
var Zs = Xr.exports, tn = { exports: {} };
(function(n, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function s(r, a) {
    for (var d in a)
      Object.defineProperty(r, d, {
        enumerable: !0,
        get: a[d]
      });
  }
  s(e, {
    isNotFoundError: function() {
      return t;
    },
    notFound: function() {
      return o;
    }
  });
  const i = "NEXT_NOT_FOUND";
  function o() {
    const r = new Error(i);
    throw r.digest = i, r;
  }
  function t(r) {
    return typeof r != "object" || r === null || !("digest" in r) ? !1 : r.digest === i;
  }
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(tn, tn.exports);
var eu = tn.exports;
(function(n, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function s(a, d) {
    for (var v in d)
      Object.defineProperty(a, v, {
        enumerable: !0,
        get: d[v]
      });
  }
  s(e, {
    ReadonlyURLSearchParams: function() {
      return r;
    },
    RedirectType: function() {
      return i.RedirectType;
    },
    notFound: function() {
      return o.notFound;
    },
    permanentRedirect: function() {
      return i.permanentRedirect;
    },
    redirect: function() {
      return i.redirect;
    }
  });
  const i = Zs, o = eu;
  class t extends Error {
    constructor() {
      super("Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams");
    }
  }
  class r extends URLSearchParams {
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    append() {
      throw new t();
    }
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    delete() {
      throw new t();
    }
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    set() {
      throw new t();
    }
    /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
    sort() {
      throw new t();
    }
  }
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(Vr, Vr.exports);
var tu = Vr.exports, Ma = {};
(function(n) {
  "use client";
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  function e(r, a) {
    for (var d in a)
      Object.defineProperty(r, d, {
        enumerable: !0,
        get: a[d]
      });
  }
  e(n, {
    ServerInsertedHTMLContext: function() {
      return o;
    },
    useServerInsertedHTML: function() {
      return t;
    }
  });
  const i = /* @__PURE__ */ Be._(xe), o = /* @__PURE__ */ i.default.createContext(null);
  function t(r) {
    const a = (0, i.useContext)(o);
    a && a(r);
  }
})(Ma);
var At = { exports: {} }, Br = {}, ra;
function ru() {
  return ra || (ra = 1, function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function e(t, r) {
      for (var a in r)
        Object.defineProperty(t, a, {
          enumerable: !0,
          get: r[a]
        });
    }
    e(n, {
      BailoutToCSRError: function() {
        return i;
      },
      isBailoutToCSRError: function() {
        return o;
      }
    });
    const s = "BAILOUT_TO_CLIENT_SIDE_RENDERING";
    class i extends Error {
      constructor(r) {
        super("Bail out to client-side rendering: " + r), this.reason = r, this.digest = s;
      }
    }
    function o(t) {
      return typeof t != "object" || t === null || !("digest" in t) ? !1 : t.digest === s;
    }
  }(Br)), Br;
}
var Ct = { exports: {} }, Tt = { exports: {} }, na;
function nu() {
  return na || (na = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "staticGenerationAsyncStorage", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const i = (0, gn.createAsyncLocalStorage)();
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(Tt, Tt.exports)), Tt.exports;
}
var oa;
function ou() {
  return oa || (oa = 1, function(n, e) {
    "TURBOPACK { transition: next-shared }";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "staticGenerationAsyncStorage", {
      enumerable: !0,
      get: function() {
        return s.staticGenerationAsyncStorage;
      }
    });
    const s = nu();
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(Ct, Ct.exports)), Ct.exports;
}
var aa;
function au() {
  return aa || (aa = 1, function(n, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "bailoutToClientRendering", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const s = ru(), i = ou();
    function o(t) {
      const r = i.staticGenerationAsyncStorage.getStore();
      if (!(r != null && r.forceStatic) && r != null && r.isStaticGeneration)
        throw new s.BailoutToCSRError(t);
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
  }(At, At.exports)), At.exports;
}
(function(n, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function s(p, P) {
    for (var g in P)
      Object.defineProperty(p, g, {
        enumerable: !0,
        get: P[g]
      });
  }
  s(e, {
    ReadonlyURLSearchParams: function() {
      return d.ReadonlyURLSearchParams;
    },
    RedirectType: function() {
      return d.RedirectType;
    },
    ServerInsertedHTMLContext: function() {
      return v.ServerInsertedHTMLContext;
    },
    notFound: function() {
      return d.notFound;
    },
    permanentRedirect: function() {
      return d.permanentRedirect;
    },
    redirect: function() {
      return d.redirect;
    },
    useParams: function() {
      return l;
    },
    usePathname: function() {
      return h;
    },
    useRouter: function() {
      return m;
    },
    useSearchParams: function() {
      return E;
    },
    useSelectedLayoutSegment: function() {
      return c;
    },
    useSelectedLayoutSegments: function() {
      return u;
    },
    useServerInsertedHTML: function() {
      return v.useServerInsertedHTML;
    }
  });
  const i = xe, o = pn, t = La, r = Vs, a = ln, d = tu, v = Ma;
  function E() {
    const p = (0, i.useContext)(t.SearchParamsContext), P = (0, i.useMemo)(() => p ? new d.ReadonlyURLSearchParams(p) : null, [
      p
    ]);
    if (typeof window > "u") {
      const { bailoutToClientRendering: g } = au();
      g("useSearchParams()");
    }
    return P;
  }
  function h() {
    return (0, i.useContext)(t.PathnameContext);
  }
  function m() {
    const p = (0, i.useContext)(o.AppRouterContext);
    if (p === null)
      throw new Error("invariant expected app router to be mounted");
    return p;
  }
  function l() {
    return (0, i.useContext)(t.PathParamsContext);
  }
  function f(p, P, g, y) {
    g === void 0 && (g = !0), y === void 0 && (y = []);
    let S;
    if (g)
      S = p[1][P];
    else {
      const A = p[1];
      var R;
      S = (R = A.children) != null ? R : Object.values(A)[0];
    }
    if (!S)
      return y;
    const _ = S[0], b = (0, r.getSegmentValue)(_);
    return !b || b.startsWith(a.PAGE_SEGMENT_KEY) ? y : (y.push(b), f(S, P, !1, y));
  }
  function u(p) {
    p === void 0 && (p = "children");
    const P = (0, i.useContext)(o.LayoutRouterContext);
    return P ? f(P.tree, p) : null;
  }
  function c(p) {
    p === void 0 && (p = "children");
    const P = u(p);
    if (!P || P.length === 0)
      return null;
    const g = p === "children" ? P[0] : P[P.length - 1];
    return g === a.DEFAULT_SEGMENT_KEY ? null : g;
  }
  (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), n.exports = e.default);
})(Gr, Gr.exports);
var iu = Gr.exports, Dt = iu;
const su = 3156e7;
function Eu() {
  const n = Dt.useSearchParams(), e = n == null ? void 0 : n.get("gclsrc");
  nn(() => {
    e && Ya("_snap_gclsrc", e, su, !0);
  }, [e]);
}
var Na = { exports: {} };
(function(n, e) {
  (function(s, i) {
    n.exports = i();
  })(Hi, function() {
    var s = 1e3, i = 6e4, o = 36e5, t = "millisecond", r = "second", a = "minute", d = "hour", v = "day", E = "week", h = "month", m = "quarter", l = "year", f = "date", u = "Invalid Date", c = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, p = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, P = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(O) {
      var N = ["th", "st", "nd", "rd"], L = O % 100;
      return "[" + O + (N[(L - 20) % 10] || N[L] || N[0]) + "]";
    } }, g = function(O, N, L) {
      var z = String(O);
      return !z || z.length >= N ? O : "" + Array(N + 1 - z.length).join(L) + O;
    }, y = { s: g, z: function(O) {
      var N = -O.utcOffset(), L = Math.abs(N), z = Math.floor(L / 60), $ = L % 60;
      return (N <= 0 ? "+" : "-") + g(z, 2, "0") + ":" + g($, 2, "0");
    }, m: function O(N, L) {
      if (N.date() < L.date())
        return -O(L, N);
      var z = 12 * (L.year() - N.year()) + (L.month() - N.month()), $ = N.clone().add(z, h), U = L - $ < 0, K = N.clone().add(z + (U ? -1 : 1), h);
      return +(-(z + (L - $) / (U ? $ - K : K - $)) || 0);
    }, a: function(O) {
      return O < 0 ? Math.ceil(O) || 0 : Math.floor(O);
    }, p: function(O) {
      return { M: h, y: l, w: E, d: v, D: f, h: d, m: a, s: r, ms: t, Q: m }[O] || String(O || "").toLowerCase().replace(/s$/, "");
    }, u: function(O) {
      return O === void 0;
    } }, S = "en", R = {};
    R[S] = P;
    var _ = "$isDayjsObject", b = function(O) {
      return O instanceof B || !(!O || !O[_]);
    }, A = function O(N, L, z) {
      var $;
      if (!N)
        return S;
      if (typeof N == "string") {
        var U = N.toLowerCase();
        R[U] && ($ = U), L && (R[U] = L, $ = U);
        var K = N.split("-");
        if (!$ && K.length > 1)
          return O(K[0]);
      } else {
        var Z = N.name;
        R[Z] = N, $ = Z;
      }
      return !z && $ && (S = $), $ || !z && S;
    }, w = function(O, N) {
      if (b(O))
        return O.clone();
      var L = typeof N == "object" ? N : {};
      return L.date = O, L.args = arguments, new B(L);
    }, j = y;
    j.l = A, j.i = b, j.w = function(O, N) {
      return w(O, { locale: N.$L, utc: N.$u, x: N.$x, $offset: N.$offset });
    };
    var B = function() {
      function O(L) {
        this.$L = A(L.locale, null, !0), this.parse(L), this.$x = this.$x || L.x || {}, this[_] = !0;
      }
      var N = O.prototype;
      return N.parse = function(L) {
        this.$d = function(z) {
          var $ = z.date, U = z.utc;
          if ($ === null)
            return /* @__PURE__ */ new Date(NaN);
          if (j.u($))
            return /* @__PURE__ */ new Date();
          if ($ instanceof Date)
            return new Date($);
          if (typeof $ == "string" && !/Z$/i.test($)) {
            var K = $.match(c);
            if (K) {
              var Z = K[2] - 1 || 0, se = (K[7] || "0").substring(0, 3);
              return U ? new Date(Date.UTC(K[1], Z, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, se)) : new Date(K[1], Z, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, se);
            }
          }
          return new Date($);
        }(L), this.init();
      }, N.init = function() {
        var L = this.$d;
        this.$y = L.getFullYear(), this.$M = L.getMonth(), this.$D = L.getDate(), this.$W = L.getDay(), this.$H = L.getHours(), this.$m = L.getMinutes(), this.$s = L.getSeconds(), this.$ms = L.getMilliseconds();
      }, N.$utils = function() {
        return j;
      }, N.isValid = function() {
        return this.$d.toString() !== u;
      }, N.isSame = function(L, z) {
        var $ = w(L);
        return this.startOf(z) <= $ && $ <= this.endOf(z);
      }, N.isAfter = function(L, z) {
        return w(L) < this.startOf(z);
      }, N.isBefore = function(L, z) {
        return this.endOf(z) < w(L);
      }, N.$g = function(L, z, $) {
        return j.u(L) ? this[z] : this.set($, L);
      }, N.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, N.valueOf = function() {
        return this.$d.getTime();
      }, N.startOf = function(L, z) {
        var $ = this, U = !!j.u(z) || z, K = j.p(L), Z = function(me, he) {
          var T = j.w($.$u ? Date.UTC($.$y, he, me) : new Date($.$y, he, me), $);
          return U ? T : T.endOf(v);
        }, se = function(me, he) {
          return j.w($.toDate()[me].apply($.toDate("s"), (U ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(he)), $);
        }, ee = this.$W, ce = this.$M, ae = this.$D, pe = "set" + (this.$u ? "UTC" : "");
        switch (K) {
          case l:
            return U ? Z(1, 0) : Z(31, 11);
          case h:
            return U ? Z(1, ce) : Z(0, ce + 1);
          case E:
            var M = this.$locale().weekStart || 0, le = (ee < M ? ee + 7 : ee) - M;
            return Z(U ? ae - le : ae + (6 - le), ce);
          case v:
          case f:
            return se(pe + "Hours", 0);
          case d:
            return se(pe + "Minutes", 1);
          case a:
            return se(pe + "Seconds", 2);
          case r:
            return se(pe + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, N.endOf = function(L) {
        return this.startOf(L, !1);
      }, N.$set = function(L, z) {
        var $, U = j.p(L), K = "set" + (this.$u ? "UTC" : ""), Z = ($ = {}, $[v] = K + "Date", $[f] = K + "Date", $[h] = K + "Month", $[l] = K + "FullYear", $[d] = K + "Hours", $[a] = K + "Minutes", $[r] = K + "Seconds", $[t] = K + "Milliseconds", $)[U], se = U === v ? this.$D + (z - this.$W) : z;
        if (U === h || U === l) {
          var ee = this.clone().set(f, 1);
          ee.$d[Z](se), ee.init(), this.$d = ee.set(f, Math.min(this.$D, ee.daysInMonth())).$d;
        } else
          Z && this.$d[Z](se);
        return this.init(), this;
      }, N.set = function(L, z) {
        return this.clone().$set(L, z);
      }, N.get = function(L) {
        return this[j.p(L)]();
      }, N.add = function(L, z) {
        var $, U = this;
        L = Number(L);
        var K = j.p(z), Z = function(ce) {
          var ae = w(U);
          return j.w(ae.date(ae.date() + Math.round(ce * L)), U);
        };
        if (K === h)
          return this.set(h, this.$M + L);
        if (K === l)
          return this.set(l, this.$y + L);
        if (K === v)
          return Z(1);
        if (K === E)
          return Z(7);
        var se = ($ = {}, $[a] = i, $[d] = o, $[r] = s, $)[K] || 1, ee = this.$d.getTime() + L * se;
        return j.w(ee, this);
      }, N.subtract = function(L, z) {
        return this.add(-1 * L, z);
      }, N.format = function(L) {
        var z = this, $ = this.$locale();
        if (!this.isValid())
          return $.invalidDate || u;
        var U = L || "YYYY-MM-DDTHH:mm:ssZ", K = j.z(this), Z = this.$H, se = this.$m, ee = this.$M, ce = $.weekdays, ae = $.months, pe = $.meridiem, M = function(he, T, x, Re) {
          return he && (he[T] || he(z, U)) || x[T].slice(0, Re);
        }, le = function(he) {
          return j.s(Z % 12 || 12, he, "0");
        }, me = pe || function(he, T, x) {
          var Re = he < 12 ? "AM" : "PM";
          return x ? Re.toLowerCase() : Re;
        };
        return U.replace(p, function(he, T) {
          return T || function(x) {
            switch (x) {
              case "YY":
                return String(z.$y).slice(-2);
              case "YYYY":
                return j.s(z.$y, 4, "0");
              case "M":
                return ee + 1;
              case "MM":
                return j.s(ee + 1, 2, "0");
              case "MMM":
                return M($.monthsShort, ee, ae, 3);
              case "MMMM":
                return M(ae, ee);
              case "D":
                return z.$D;
              case "DD":
                return j.s(z.$D, 2, "0");
              case "d":
                return String(z.$W);
              case "dd":
                return M($.weekdaysMin, z.$W, ce, 2);
              case "ddd":
                return M($.weekdaysShort, z.$W, ce, 3);
              case "dddd":
                return ce[z.$W];
              case "H":
                return String(Z);
              case "HH":
                return j.s(Z, 2, "0");
              case "h":
                return le(1);
              case "hh":
                return le(2);
              case "a":
                return me(Z, se, !0);
              case "A":
                return me(Z, se, !1);
              case "m":
                return String(se);
              case "mm":
                return j.s(se, 2, "0");
              case "s":
                return String(z.$s);
              case "ss":
                return j.s(z.$s, 2, "0");
              case "SSS":
                return j.s(z.$ms, 3, "0");
              case "Z":
                return K;
            }
            return null;
          }(he) || K.replace(":", "");
        });
      }, N.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, N.diff = function(L, z, $) {
        var U, K = this, Z = j.p(z), se = w(L), ee = (se.utcOffset() - this.utcOffset()) * i, ce = this - se, ae = function() {
          return j.m(K, se);
        };
        switch (Z) {
          case l:
            U = ae() / 12;
            break;
          case h:
            U = ae();
            break;
          case m:
            U = ae() / 3;
            break;
          case E:
            U = (ce - ee) / 6048e5;
            break;
          case v:
            U = (ce - ee) / 864e5;
            break;
          case d:
            U = ce / o;
            break;
          case a:
            U = ce / i;
            break;
          case r:
            U = ce / s;
            break;
          default:
            U = ce;
        }
        return $ ? U : j.a(U);
      }, N.daysInMonth = function() {
        return this.endOf(h).$D;
      }, N.$locale = function() {
        return R[this.$L];
      }, N.locale = function(L, z) {
        if (!L)
          return this.$L;
        var $ = this.clone(), U = A(L, z, !0);
        return U && ($.$L = U), $;
      }, N.clone = function() {
        return j.w(this.$d, this);
      }, N.toDate = function() {
        return new Date(this.valueOf());
      }, N.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, N.toISOString = function() {
        return this.$d.toISOString();
      }, N.toString = function() {
        return this.$d.toUTCString();
      }, O;
    }(), X = B.prototype;
    return w.prototype = X, [["$ms", t], ["$s", r], ["$m", a], ["$H", d], ["$W", v], ["$M", h], ["$y", l], ["$D", f]].forEach(function(O) {
      X[O[1]] = function(N) {
        return this.$g(N, O[0], O[1]);
      };
    }), w.extend = function(O, N) {
      return O.$i || (O(N, B, w), O.$i = !0), w;
    }, w.locale = A, w.isDayjs = b, w.unix = function(O) {
      return w(1e3 * O);
    }, w.en = R[S], w.Ls = R, w.p = {}, w;
  });
})(Na);
var uu = Na.exports;
const cu = /* @__PURE__ */ rt(uu);
function Pu() {
  const n = Dt.useSearchParams(), e = n == null ? void 0 : n.get.ranSiteID, s = n == null ? void 0 : n.get.ranEAID, i = n == null ? void 0 : n.get.ranMID, [o, t] = rn(null);
  return nn(() => {
    if (e && s && i) {
      const r = {
        ranMID: i,
        ranEAID: s,
        ranSiteID: e,
        landingDate: cu().format("YYYYMMDD_HHmm")
      };
      sessionStorage.setItem("rakutenParams", JSON.stringify(r)), t(r);
    } else if (sessionStorage.getItem("rakutenParams")) {
      const r = JSON.parse(
        sessionStorage.getItem("rakutenParams")
      );
      t(r);
    }
  }, [e, s, i]), {
    rakutenParams: o
  };
}
function wu() {
  const n = Dt.useSearchParams(), e = et(
    () => n ? Object.fromEntries(n == null ? void 0 : n.entries()) : {},
    [n]
  ), {
    utm_source: s = "",
    utm_medium: i = "",
    utm_campaign: o = "",
    utm_term: t = "",
    utm_id: r = "",
    utm_content: a = ""
  } = e;
  return et(
    () => ({
      utm_source: s,
      utm_medium: i,
      utm_campaign: o,
      utm_term: t,
      utm_id: r,
      utm_content: a
    }),
    [s, i, o, t, r, a]
  );
}
function Ou() {
  const n = Dt.useSearchParams();
  return et(() => {
    const s = /* @__PURE__ */ new Set([
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "utm_id"
    ]), i = {};
    return n.forEach((o, t) => {
      s.has(t) && (i[t] = o);
    }), i;
  }, [n]);
}
export {
  vu as AppMessage,
  sa as AppMessageContext,
  Ru as PageLoadingSpinner,
  Su as Pagination,
  bu as SnapLogo,
  yu as useAppMessage,
  Ou as useDefinedUTM,
  Eu as useMarketingCookies,
  Pu as useRakutenParams,
  wu as useUTM
};
